'use strict';

var React$1 = require('react');
var componentsLoader = require('@keytrade/components-loader');
var componentsSpan = require('@keytrade/components-span');
var componentsTitle = require('@keytrade/components-title');
require('@keytrade/components-badge');
var componentsButton = require('@keytrade/components-button');
var componentsIcon = require('@keytrade/components-icon');
var require$$0 = require('styled-components');
var componentsParagraph = require('@keytrade/components-paragraph');
var componentsLink = require('@keytrade/components-link');
var componentsCard = require('@keytrade/components-card');
function _arrayLikeToArray$3(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles$2(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles$3(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$3(r);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _iterableToArray$3(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit$2(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread$3() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _slicedToArray$2(r, e) {
  return _arrayWithHoles$2(r) || _iterableToArrayLimit$2(r, e) || _unsupportedIterableToArray$3(r, e) || _nonIterableRest$2();
}
function _toConsumableArray$3(r) {
  return _arrayWithoutHoles$3(r) || _iterableToArray$3(r) || _unsupportedIterableToArray$3(r) || _nonIterableSpread$3();
}
function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}
function _unsupportedIterableToArray$3(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$3(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$3(r, a) : void 0;
  }
}
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */ && prop.charCodeAt(1) === 110
  /* n */ && prop.charCodeAt(2) < 91;
}
/* Z+1 */);

// src/css.ts

// src/cx.ts
var cx = function cx2() {
  const presentClassNames = Array.prototype.slice.call(arguments).filter(Boolean);
  const atomicClasses = {};
  const nonAtomicClasses = [];
  presentClassNames.forEach(arg => {
    const individualClassNames = arg ? arg.split(" ") : [];
    individualClassNames.forEach(className => {
      if (className.startsWith("atm_")) {
        const [, keyHash] = className.split("_");
        atomicClasses[keyHash] = className;
      } else {
        nonAtomicClasses.push(className);
      }
    });
  });
  const result = [];
  for (const keyHash in atomicClasses) {
    if (Object.prototype.hasOwnProperty.call(atomicClasses, keyHash)) {
      result.push(atomicClasses[keyHash]);
    }
  }
  result.push(...nonAtomicClasses);
  return result.join(" ");
};
var cx_default = cx;

// src/styled.ts
var isCapital = ch => ch.toUpperCase() === ch;
var filterKey = keys => key => keys.indexOf(key) === -1;
var omit = (obj, keys) => {
  const res = {};
  Object.keys(obj).filter(filterKey(keys)).forEach(key => {
    res[key] = obj[key];
  });
  return res;
};
function filterProps(asIs, props, omitKeys) {
  const filteredProps = omit(props, omitKeys);
  if (!asIs) {
    const interopValidAttr = typeof isPropValid === "function" ? {
      default: isPropValid
    } : isPropValid;
    Object.keys(filteredProps).forEach(key => {
      if (!interopValidAttr.default(key)) {
        delete filteredProps[key];
      }
    });
  }
  return filteredProps;
}
var warnIfInvalid = (value, componentName) => {
  if (process.env.NODE_ENV !== "production") {
    if (typeof value === "string" ||
    // eslint-disable-next-line no-self-compare,no-restricted-globals
    typeof value === "number" && isFinite(value)) {
      return;
    }
    const stringified = typeof value === "object" ? JSON.stringify(value) : String(value);
    console.warn(`An interpolation evaluated to '${stringified}' in the component '${componentName}', which is probably a mistake. You should explicitly cast or transform the value to a string.`);
  }
};
var idx = 0;
function styled$1(tag) {
  let mockedClass = "";
  if (process.env.NODE_ENV === "test") {
    mockedClass += `mocked-styled-${idx++}`;
    if (tag && tag.__wyw_meta && tag.__wyw_meta.className) {
      mockedClass += ` ${tag.__wyw_meta.className}`;
    }
  }
  return options => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test") {
      if (Array.isArray(options)) {
        throw new Error('Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup');
      }
    }
    const render = (props, ref) => {
      const {
        as: component = tag,
        class: className = mockedClass
      } = props;
      const shouldKeepProps = options.propsAsIs === void 0 ? !(typeof component === "string" && component.indexOf("-") === -1 && !isCapital(component[0])) : options.propsAsIs;
      const filteredProps = filterProps(shouldKeepProps, props, ["as", "class"]);
      filteredProps.ref = ref;
      filteredProps.className = options.atomic ? cx_default(options.class, filteredProps.className || className) : cx_default(filteredProps.className || className, options.class);
      const {
        vars
      } = options;
      if (vars) {
        const style = {};
        for (const name in vars) {
          const variable = vars[name];
          const result = variable[0];
          const unit = variable[1] || "";
          const value = typeof result === "function" ? result(props) : result;
          warnIfInvalid(value, options.name);
          style[`--${name}`] = `${value}${unit}`;
        }
        const ownStyle = filteredProps.style || {};
        const keys = Object.keys(ownStyle);
        if (keys.length > 0) {
          keys.forEach(key => {
            style[key] = ownStyle[key];
          });
        }
        filteredProps.style = style;
      }
      if (tag.__wyw_meta && tag !== component) {
        filteredProps.as = component;
        return React$1.createElement(tag, filteredProps);
      }
      return React$1.createElement(component, filteredProps);
    };
    const Result = React$1.forwardRef ? React$1.forwardRef(render) :
    // React.forwardRef won't available on older React versions and in Preact
    // Fallback to a innerRef prop in that case
    props => {
      const rest = omit(props, ["innerRef"]);
      return render(rest, props.innerRef);
    };
    Result.displayName = options.name;
    Result.__wyw_meta = {
      className: options.class || mockedClass,
      extends: tag
    };
    return Result;
  };
}
var styled_default = process.env.NODE_ENV !== "production" ? new Proxy(styled$1, {
  get(o, prop) {
    return o(prop);
  }
}) : styled$1;
var request_expired_title$2 = "Demande expirée";
var request_expired_description$2 = "Il semble que cette demande ait expiré. Pour traiter votre demande d'ouverture de compte, nous vous demandons de compléter votre dossier dans un délai de 45 jours.\n Merci de soumettre une nouvelle demande.";
var request_expired_button_label$2 = "Ouvrir une nouvelle demande";
var cant_connect$2 = "Je ne peux pas me connecter à mon espace personnel";
var questions$2 = "Voir les questions les plus fréquemment posées concernant l'espace personnel";
var download$2 = "Télécharger";
var requested_document$2 = "Document demandé";
var multiple_documents$2 = "Si votre document comporte plusieurs pages, vous avez la possibilité de les ajouter une par une ou de télécharger un fichier unique contenant toutes les pages.";
var drop_here$2 = "Déposez ici ou ";
var browse_files$2 = "parcourir les fichiers";
var accepted_formats$2 = "Format de fichier : pdf, jpf ou png avec une taille maximale de 5Mb";
var readable_files$2 = "Veuillez vous assurer que tous les fichiers sont lisibles.  Une fois envoyés, vous ne pouvez plus ajouter ou modifier de fichiers.";
var error_contract_not_found$2 = "Une erreur est survenue lors de la récupération du contrat. Veuillez réessayer plus tard.";
var send_for_review$2 = "Envoyer pour révision";
var upload_error$2 = "Veuillez utiliser le bon format de fichier : PDF, JPG, PNG ou Word avec une taille maximale de 5Mb.";
var good_morning$2 = "Bonjour ";
var request_type_OPEN_ACCOUNT$2 = "Votre demande d'ouverture de compte";
var request_type_JOINT_ACCOUNT$2 = "Votre demande d'ouverture de compte joint avec ";
var request_type_MINOR_ACCOUNT$2 = "Votre demande d'ouverture de compte mineur";
var request_type_opening_account_description$2 = "Pour compléter votre demande de compte, nous vous demandons de télécharger les documents suivants.";
var requested_documents$2 = "document(s) demandé(s)";
var reference$2 = "Référence :";
var creation_date$2 = "Date de création de la demande :";
var upload$2 = "Télécharger";
var need_help$2 = "Besoin d'aide ?";
var faq$2 = "FAQ";
var faq_url$2 = "https://www.keytradebank.be/fr/aide";
var contact_us$2 = "Contactez-nous";
var logout$2 = "Déconnexion";
var request_status_DOC_MISSING$2 = "Doc manquant";
var request_status_IN_REVIEW$2 = "En cours d'examen";
var request_status_VALIDATED$2 = "Validé";
var request_status_REJECTED$2 = "Rejeté";
var document_type_UNSPECIFIED$2 = "Non spécifié";
var document_type_CONTRACT$2 = "Contrat (OOD)";
var document_type_PROXY_IDENTITY_DOCUMENT$2 = "Identité du mandataire";
var document_type_ID_CARD$2 = "Copie de la carte d'identité";
var document_type_PASSPORT$2 = "Copie du passeport";
var document_type_POWER_OF_ATTORNEY$2 = "Procuration";
var document_type_LEGAL_ADDRESS_OFFICIAL_PROOF$2 = "Preuve de résidence légale";
var document_type_FISCAL_ADDRESS_OFFICIAL_PROOF$2 = "Preuve de résidence fiscale";
var document_type_WITHHOLDING_TAX_DECLARATION_FOR_NON_RESIDENT_FORM$2 = "Formulaire de déclaration de retenue à la source";
var document_type_W8BEN_CERTIFICATE_FOR_INDIVIDUALS_FORM$2 = "W8-BEN";
var document_type_STUDENT_CARD$2 = "Carte d'étudiant";
var document_type_RETIREMENT_PROOF$2 = "Certificat de pension";
var document_type_RETIRED$2 = "Retraité";
var document_type_WITHDRAWAL_AMERICAN_CITIZEN_PROOF$2 = "Preuve de retrait citoyenneté américaine";
var document_type_HIS_276$2 = "Document HIS 276";
var document_type_TRANSFER_OUTSIDE_EU$2 = "Transferts en dehors de l'UE";
var document_type_WITHDRAW_MORE_THAN_2500$2 = "Retirer plus de 2 500 euros";
var document_type_BIRTH_CERTIFICATE$2 = "Acte de naissance";
var document_type_ID_CARD_MINOR$2 = "Carte d'identité mineur";
var document_type_BIRTH_CERTIFICATE_OR_HOUSEHOLD_COMPOSITION$2 = "Acte de naissance OU Composition du ménage";
var validated$2 = "Validé";
var rejected$2 = "Rejeté";
var in_progress$2 = "En cours";
var file_format$2 = "Format de fichier : PDF, JPG, PNG ou Word";
var pending_for_validation$2 = "En attente de validation depuis ";
var uploaded_on$2 = "Téléchargé le ";
var error$2 = "Erreur";
var error_occurred$2 = "Une erreur est survenue...";
var refusal_reasons$2 = {
  UNSPECIFIED: "Indéterminé",
  FREE_TEXT: "Free text",
  UNREADABLE_DOCUMENT: "Document illisible",
  MISSING_SIGNATURE: "Signature manquante",
  SIGNATURE_NOT_MATCHING_ID_SIGNATURE: "Signature not matching ID signature",
  INFORMATION_MISSING: "Information manquante",
  INVALID_ID: "Carte d'indentité invalide",
  INVALID_PASSPORT: "Passeport invalide",
  OUTDATED_OR_CUT_ID: "ID obsolète ou coupée",
  OUTDATED_OR_CUT_DOCUMENT: "Document obsolète ou coupé",
  DOCUMENT_EXPIRED: "Document expiré",
  NON_OFFICIAL_DOCUMENT: "Document non-officiel",
  LANGUAGE_NOT_ACCEPTED: "Langue non acceptée",
  MISMATCH_TIN_AND_LEGAL_ADDRESS: "Le numéro d'identification fiscale et l'adresse légale ne correspondent pas",
  TIN_MISSING: "Numéro d'identification fiscal manquant"
};
var fr = {
  request_expired_title: request_expired_title$2,
  request_expired_description: request_expired_description$2,
  request_expired_button_label: request_expired_button_label$2,
  cant_connect: cant_connect$2,
  questions: questions$2,
  download: download$2,
  requested_document: requested_document$2,
  multiple_documents: multiple_documents$2,
  drop_here: drop_here$2,
  browse_files: browse_files$2,
  accepted_formats: accepted_formats$2,
  readable_files: readable_files$2,
  error_contract_not_found: error_contract_not_found$2,
  send_for_review: send_for_review$2,
  upload_error: upload_error$2,
  good_morning: good_morning$2,
  request_type_OPEN_ACCOUNT: request_type_OPEN_ACCOUNT$2,
  request_type_JOINT_ACCOUNT: request_type_JOINT_ACCOUNT$2,
  request_type_MINOR_ACCOUNT: request_type_MINOR_ACCOUNT$2,
  request_type_opening_account_description: request_type_opening_account_description$2,
  requested_documents: requested_documents$2,
  reference: reference$2,
  creation_date: creation_date$2,
  upload: upload$2,
  need_help: need_help$2,
  faq: faq$2,
  faq_url: faq_url$2,
  contact_us: contact_us$2,
  logout: logout$2,
  request_status_DOC_MISSING: request_status_DOC_MISSING$2,
  request_status_IN_REVIEW: request_status_IN_REVIEW$2,
  request_status_VALIDATED: request_status_VALIDATED$2,
  request_status_REJECTED: request_status_REJECTED$2,
  document_type_UNSPECIFIED: document_type_UNSPECIFIED$2,
  document_type_CONTRACT: document_type_CONTRACT$2,
  document_type_PROXY_IDENTITY_DOCUMENT: document_type_PROXY_IDENTITY_DOCUMENT$2,
  document_type_ID_CARD: document_type_ID_CARD$2,
  document_type_PASSPORT: document_type_PASSPORT$2,
  document_type_POWER_OF_ATTORNEY: document_type_POWER_OF_ATTORNEY$2,
  document_type_LEGAL_ADDRESS_OFFICIAL_PROOF: document_type_LEGAL_ADDRESS_OFFICIAL_PROOF$2,
  document_type_FISCAL_ADDRESS_OFFICIAL_PROOF: document_type_FISCAL_ADDRESS_OFFICIAL_PROOF$2,
  document_type_WITHHOLDING_TAX_DECLARATION_FOR_NON_RESIDENT_FORM: document_type_WITHHOLDING_TAX_DECLARATION_FOR_NON_RESIDENT_FORM$2,
  document_type_W8BEN_CERTIFICATE_FOR_INDIVIDUALS_FORM: document_type_W8BEN_CERTIFICATE_FOR_INDIVIDUALS_FORM$2,
  document_type_STUDENT_CARD: document_type_STUDENT_CARD$2,
  document_type_RETIREMENT_PROOF: document_type_RETIREMENT_PROOF$2,
  document_type_RETIRED: document_type_RETIRED$2,
  document_type_WITHDRAWAL_AMERICAN_CITIZEN_PROOF: document_type_WITHDRAWAL_AMERICAN_CITIZEN_PROOF$2,
  document_type_HIS_276: document_type_HIS_276$2,
  document_type_TRANSFER_OUTSIDE_EU: document_type_TRANSFER_OUTSIDE_EU$2,
  document_type_WITHDRAW_MORE_THAN_2500: document_type_WITHDRAW_MORE_THAN_2500$2,
  document_type_BIRTH_CERTIFICATE: document_type_BIRTH_CERTIFICATE$2,
  document_type_ID_CARD_MINOR: document_type_ID_CARD_MINOR$2,
  document_type_BIRTH_CERTIFICATE_OR_HOUSEHOLD_COMPOSITION: document_type_BIRTH_CERTIFICATE_OR_HOUSEHOLD_COMPOSITION$2,
  validated: validated$2,
  rejected: rejected$2,
  in_progress: in_progress$2,
  file_format: file_format$2,
  pending_for_validation: pending_for_validation$2,
  uploaded_on: uploaded_on$2,
  error: error$2,
  error_occurred: error_occurred$2,
  refusal_reasons: refusal_reasons$2
};
var request_expired_title$1 = "Request expired";
var request_expired_description$1 = "It looks like this request has expired. To process your account request we ask you to complete your file within 45 days.\n Please make a new request.";
var request_expired_button_label$1 = "Open a new request";
var cant_connect$1 = "I can't connect to my personal space";
var questions$1 = "See the most frequently asked questions related to the personal space";
var download$1 = "Download";
var requested_document$1 = "Requested document";
var multiple_documents$1 = "If your document has multiple pages, you have the option to either add them one by one or upload a single file containing all the pages.";
var drop_here$1 = "Drop here or ";
var browse_files$1 = "browse files";
var accepted_formats$1 = "File Format: pdf, jpf or png with a max. size of 5Mb";
var readable_files$1 = "Please make sure all files are readable.  Once sent, you can no longer add of modify files";
var error_contract_not_found$1 = "Something went wrong when trying to get the contract. Please, try again later.";
var send_for_review$1 = "Send for review";
var upload_error$1 = "Please use the correct file format: PDF, JPG, PNG or Word with a maximum size of 5Mb.";
var good_morning$1 = "Good morning ";
var request_type_OPEN_ACCOUNT$1 = "Your opening account request";
var request_type_JOINT_ACCOUNT$1 = "Your joint account opening request with ";
var request_type_MINOR_ACCOUNT$1 = "Your opening minor account request";
var request_type_opening_account_description$1 = "To complete your account request we ask you to upload the following documents.";
var requested_documents$1 = "requested document(s)";
var reference$1 = "Reference:";
var creation_date$1 = "Request creation date:";
var upload$1 = "Upload";
var need_help$1 = "Need help?";
var faq$1 = "FAQ";
var faq_url$1 = "https://www.keytradebank.be/en/support";
var contact_us$1 = "Contact us";
var logout$1 = "Logout";
var request_status_DOC_MISSING$1 = "Doc missing";
var request_status_IN_REVIEW$1 = "Under review";
var request_status_VALIDATED$1 = "Validated";
var request_status_REJECTED$1 = "Rejected";
var document_type_UNSPECIFIED$1 = "Unspecified";
var document_type_PROXY_IDENTITY_DOCUMENT$1 = "Identity of the proxy";
var document_type_POWER_OF_ATTORNEY$1 = "Power of Attorney";
var document_type_CONTRACT$1 = "Contract (OOD)";
var document_type_ID_CARD$1 = "Copy of ID card";
var document_type_PASSPORT$1 = "Copy of passport";
var document_type_LEGAL_ADDRESS_OFFICIAL_PROOF$1 = "Proof of legal residence";
var document_type_FISCAL_ADDRESS_OFFICIAL_PROOF$1 = "Proof of fiscal residence";
var document_type_WITHHOLDING_TAX_DECLARATION_FOR_NON_RESIDENT_FORM$1 = "Witholding tax declaration form";
var document_type_W8BEN_CERTIFICATE_FOR_INDIVIDUALS_FORM$1 = "W8-BEN";
var document_type_STUDENT_CARD$1 = "Student card";
var document_type_RETIREMENT_PROOF$1 = "Pension income";
var document_type_RETIRED$1 = "Retired";
var document_type_WITHDRAWAL_AMERICAN_CITIZEN_PROOF$1 = "Proof of Withdrawal American citizenship";
var document_type_HIS_276$1 = "HIS 276 document";
var document_type_TRANSFER_OUTSIDE_EU$1 = "Transfers outside EU";
var document_type_WITHDRAW_MORE_THAN_2500$1 = "Withdraw more than €2.500";
var document_type_BIRTH_CERTIFICATE$1 = "Birth certificate";
var document_type_ID_CARD_MINOR$1 = "Id card minor";
var document_type_BIRTH_CERTIFICATE_OR_HOUSEHOLD_COMPOSITION$1 = "Birth certificate OR Household composition";
var validated$1 = "Validated";
var rejected$1 = "Rejected";
var in_progress$1 = "In progress";
var file_format$1 = "File format: PDF, JPG, PNG or Word";
var pending_for_validation$1 = "Pending for validation since ";
var uploaded_on$1 = "Uploaded on ";
var error$1 = "Error";
var error_occurred$1 = "An error has occurred...";
var refusal_reasons$1 = {
  UNSPECIFIED: "Unspecified",
  FREE_TEXT: "Free text",
  UNREADABLE_DOCUMENT: "Unreadable document",
  MISSING_SIGNATURE: "Missing signature",
  SIGNATURE_NOT_MATCHING_ID_SIGNATURE: "Signature not matching ID signature",
  INFORMATION_MISSING: "Information missing",
  INVALID_ID: "Invalid ID",
  INVALID_PASSPORT: "Invalid passport",
  OUTDATED_OR_CUT_ID: "Outdated or cut ID",
  OUTDATED_OR_CUT_DOCUMENT: "Outdated or cut document",
  DOCUMENT_EXPIRED: "Document expired",
  NON_OFFICIAL_DOCUMENT: "Non-official document",
  LANGUAGE_NOT_ACCEPTED: "Language not accepted",
  MISMATCH_TIN_AND_LEGAL_ADDRESS: "Mismatch between TIN and legal address",
  TIN_MISSING: "TIN missing"
};
var en$1 = {
  request_expired_title: request_expired_title$1,
  request_expired_description: request_expired_description$1,
  request_expired_button_label: request_expired_button_label$1,
  cant_connect: cant_connect$1,
  questions: questions$1,
  download: download$1,
  requested_document: requested_document$1,
  multiple_documents: multiple_documents$1,
  drop_here: drop_here$1,
  browse_files: browse_files$1,
  accepted_formats: accepted_formats$1,
  readable_files: readable_files$1,
  error_contract_not_found: error_contract_not_found$1,
  send_for_review: send_for_review$1,
  upload_error: upload_error$1,
  good_morning: good_morning$1,
  request_type_OPEN_ACCOUNT: request_type_OPEN_ACCOUNT$1,
  request_type_JOINT_ACCOUNT: request_type_JOINT_ACCOUNT$1,
  request_type_MINOR_ACCOUNT: request_type_MINOR_ACCOUNT$1,
  request_type_opening_account_description: request_type_opening_account_description$1,
  requested_documents: requested_documents$1,
  reference: reference$1,
  creation_date: creation_date$1,
  upload: upload$1,
  need_help: need_help$1,
  faq: faq$1,
  faq_url: faq_url$1,
  contact_us: contact_us$1,
  logout: logout$1,
  request_status_DOC_MISSING: request_status_DOC_MISSING$1,
  request_status_IN_REVIEW: request_status_IN_REVIEW$1,
  request_status_VALIDATED: request_status_VALIDATED$1,
  request_status_REJECTED: request_status_REJECTED$1,
  document_type_UNSPECIFIED: document_type_UNSPECIFIED$1,
  document_type_PROXY_IDENTITY_DOCUMENT: document_type_PROXY_IDENTITY_DOCUMENT$1,
  document_type_POWER_OF_ATTORNEY: document_type_POWER_OF_ATTORNEY$1,
  document_type_CONTRACT: document_type_CONTRACT$1,
  document_type_ID_CARD: document_type_ID_CARD$1,
  document_type_PASSPORT: document_type_PASSPORT$1,
  document_type_LEGAL_ADDRESS_OFFICIAL_PROOF: document_type_LEGAL_ADDRESS_OFFICIAL_PROOF$1,
  document_type_FISCAL_ADDRESS_OFFICIAL_PROOF: document_type_FISCAL_ADDRESS_OFFICIAL_PROOF$1,
  document_type_WITHHOLDING_TAX_DECLARATION_FOR_NON_RESIDENT_FORM: document_type_WITHHOLDING_TAX_DECLARATION_FOR_NON_RESIDENT_FORM$1,
  document_type_W8BEN_CERTIFICATE_FOR_INDIVIDUALS_FORM: document_type_W8BEN_CERTIFICATE_FOR_INDIVIDUALS_FORM$1,
  document_type_STUDENT_CARD: document_type_STUDENT_CARD$1,
  document_type_RETIREMENT_PROOF: document_type_RETIREMENT_PROOF$1,
  document_type_RETIRED: document_type_RETIRED$1,
  document_type_WITHDRAWAL_AMERICAN_CITIZEN_PROOF: document_type_WITHDRAWAL_AMERICAN_CITIZEN_PROOF$1,
  document_type_HIS_276: document_type_HIS_276$1,
  document_type_TRANSFER_OUTSIDE_EU: document_type_TRANSFER_OUTSIDE_EU$1,
  document_type_WITHDRAW_MORE_THAN_2500: document_type_WITHDRAW_MORE_THAN_2500$1,
  document_type_BIRTH_CERTIFICATE: document_type_BIRTH_CERTIFICATE$1,
  document_type_ID_CARD_MINOR: document_type_ID_CARD_MINOR$1,
  document_type_BIRTH_CERTIFICATE_OR_HOUSEHOLD_COMPOSITION: document_type_BIRTH_CERTIFICATE_OR_HOUSEHOLD_COMPOSITION$1,
  validated: validated$1,
  rejected: rejected$1,
  in_progress: in_progress$1,
  file_format: file_format$1,
  pending_for_validation: pending_for_validation$1,
  uploaded_on: uploaded_on$1,
  error: error$1,
  error_occurred: error_occurred$1,
  refusal_reasons: refusal_reasons$1
};
var request_expired_title = "Aanvraag verlopen";
var request_expired_description = "Het lijkt erop dat je aanvraag verlopen is. Om je rekeningaanvraag te behandelen vragen we steeds om je dossier te vervolledigen binnen de 45 dagen.\n Gelieve een nieuwe aanvraag in te dienen.";
var request_expired_button_label = "Start een nieuwe aanvraag";
var cant_connect = "Ik kan geen verbinding maken met mijn persoonlijke ruimte";
var questions = "Bekijk de meest gestelde vragen met betrekking tot de persoonlijke ruimte";
var download = "Downloaden";
var requested_document = "Opgevraagd document";
var multiple_documents = "Als je document uit meerdere pagina's bestaat, heb je de optie om ze één voor één toe te voegen of om één bestand met alle pagina's te uploaden.";
var drop_here = "Drop hier of ";
var browse_files = "door bestanden bladeren";
var accepted_formats = "Bestandsformaat: pdf, jpf of png met een maximale grootte van 5Mb";
var readable_files = "Zorg ervoor dat alle bestanden leesbaar zijn.  Eenmaal verzonden, kun je geen bestanden meer toevoegen of wijzigen.";
var error_contract_not_found = "Er is iets mis gegaan bij het ophalen van het contract. Probeer het later opnieuw.";
var send_for_review = "Verzenden voor beoordeling";
var upload_error = "Gebruik het juiste bestandsformaat: PDF, JPG, PNG of Word met een maximale grootte van 5Mb.";
var good_morning = "Goedemorgen ";
var request_type_OPEN_ACCOUNT = "Uw aanvraag voor een openingsrekening";
var request_type_JOINT_ACCOUNT = "Uw aanvraag voor het openen van een gezamenlijke rekening met ";
var request_type_MINOR_ACCOUNT = "Uw aanvraag voor het openen van een kleine account";
var request_type_opening_account_description = "Om uw aanvraag te vervolledigen vragen wij u om onderstaande documenten aan te leveren.";
var requested_documents = "opgevraagd(e) document(en)";
var reference = "Referentie:";
var creation_date = "Datum waarop het verzoek is aangemaakt:";
var upload = "Upload";
var need_help = "Hulp nodig?";
var faq = "FAQ";
var faq_url = "https://www.keytradebank.be/nl/hulp";
var contact_us = "Contacteer ons";
var logout = "Afmelden";
var request_status_DOC_MISSING = "Doc vermist";
var request_status_IN_REVIEW = "Wordt beoordeeld";
var request_status_VALIDATED = "Gevalideerd";
var request_status_REJECTED = "Afgewezen";
var document_type_UNSPECIFIED = "Ongespecificeerd";
var document_type_CONTRACT = "Contract (OOD)";
var document_type_ID_CARD = "Kopie van ID-kaart";
var document_type_PASSPORT = "Kopie paspoort";
var document_type_LEGAL_ADDRESS_OFFICIAL_PROOF = "Bewijs van legaal verblijf";
var document_type_FISCAL_ADDRESS_OFFICIAL_PROOF = "Bewijs van fiscale residentie";
var document_type_WITHHOLDING_TAX_DECLARATION_FOR_NON_RESIDENT_FORM = "Aangifteformulier voor bronbelasting";
var document_type_W8BEN_CERTIFICATE_FOR_INDIVIDUALS_FORM = "W8-BEN";
var document_type_STUDENT_CARD = "Studentenkaart";
var document_type_RETIREMENT_PROOF = "Attest of fiche van pensioen";
var document_type_RETIRED = "Gepensioneerd";
var document_type_PROXY_IDENTITY_DOCUMENT = "Identiteit van de volmachtigde";
var document_type_WITHDRAWAL_AMERICAN_CITIZEN_PROOF = "Bewijs van intrekking Amerikaans staatsburgerschap";
var document_type_HIS_276 = "HIS 276 document";
var document_type_POWER_OF_ATTORNEY = "Volmacht";
var document_type_TRANSFER_OUTSIDE_EU = "Overboekingen buiten de EU";
var document_type_WITHDRAW_MORE_THAN_2500 = "Meer dan €2.500 opnemen";
var document_type_BIRTH_CERTIFICATE = "Geboorteakte";
var document_type_ID_CARD_MINOR = "Identiteitskaart minderjarige";
var document_type_BIRTH_CERTIFICATE_OR_HOUSEHOLD_COMPOSITION = "Geboorteakte OF Huishoudsamenstelling";
var validated = "Gevalideerd";
var rejected = "Afgewezen";
var in_progress = "In uitvoering";
var file_format = "Bestandsformaat: PDF, JPG, PNG of Word";
var pending_for_validation = "In afwachting van validatie sinds ";
var uploaded_on = "Geüpload op ";
var error = "Fout";
var error_occurred = "Er is een fout opgetreden...";
var refusal_reasons = {
  UNSPECIFIED: "Onbepaald",
  FREE_TEXT: "Free text",
  UNREADABLE_DOCUMENT: "Onleesbaar document",
  MISSING_SIGNATURE: "Ontbrekende handtekening",
  SIGNATURE_NOT_MATCHING_ID_SIGNATURE: "Handtekening komt niet overeen met ID-handtekening",
  INFORMATION_MISSING: "Ontbrekende informatie",
  INVALID_ID: "Ongeldig ID",
  INVALID_PASSPORT: "Ongeldig paspoort",
  OUTDATED_OR_CUT_ID: "Verouderde of afgesneden ID",
  OUTDATED_OR_CUT_DOCUMENT: "Verouderd of verknipt document",
  DOCUMENT_EXPIRED: "Document verlopen",
  NON_OFFICIAL_DOCUMENT: "Officieus document",
  LANGUAGE_NOT_ACCEPTED: "Taal niet geaccepteerd",
  MISMATCH_TIN_AND_LEGAL_ADDRESS: "Het wettelijke adres komen niet overeen",
  TIN_MISSING: "TIN ontbreekt"
};
var nl = {
  request_expired_title: request_expired_title,
  request_expired_description: request_expired_description,
  request_expired_button_label: request_expired_button_label,
  cant_connect: cant_connect,
  questions: questions,
  download: download,
  requested_document: requested_document,
  multiple_documents: multiple_documents,
  drop_here: drop_here,
  browse_files: browse_files,
  accepted_formats: accepted_formats,
  readable_files: readable_files,
  error_contract_not_found: error_contract_not_found,
  send_for_review: send_for_review,
  upload_error: upload_error,
  good_morning: good_morning,
  request_type_OPEN_ACCOUNT: request_type_OPEN_ACCOUNT,
  request_type_JOINT_ACCOUNT: request_type_JOINT_ACCOUNT,
  request_type_MINOR_ACCOUNT: request_type_MINOR_ACCOUNT,
  request_type_opening_account_description: request_type_opening_account_description,
  requested_documents: requested_documents,
  reference: reference,
  creation_date: creation_date,
  upload: upload,
  need_help: need_help,
  faq: faq,
  faq_url: faq_url,
  contact_us: contact_us,
  logout: logout,
  request_status_DOC_MISSING: request_status_DOC_MISSING,
  request_status_IN_REVIEW: request_status_IN_REVIEW,
  request_status_VALIDATED: request_status_VALIDATED,
  request_status_REJECTED: request_status_REJECTED,
  document_type_UNSPECIFIED: document_type_UNSPECIFIED,
  document_type_CONTRACT: document_type_CONTRACT,
  document_type_ID_CARD: document_type_ID_CARD,
  document_type_PASSPORT: document_type_PASSPORT,
  document_type_LEGAL_ADDRESS_OFFICIAL_PROOF: document_type_LEGAL_ADDRESS_OFFICIAL_PROOF,
  document_type_FISCAL_ADDRESS_OFFICIAL_PROOF: document_type_FISCAL_ADDRESS_OFFICIAL_PROOF,
  document_type_WITHHOLDING_TAX_DECLARATION_FOR_NON_RESIDENT_FORM: document_type_WITHHOLDING_TAX_DECLARATION_FOR_NON_RESIDENT_FORM,
  document_type_W8BEN_CERTIFICATE_FOR_INDIVIDUALS_FORM: document_type_W8BEN_CERTIFICATE_FOR_INDIVIDUALS_FORM,
  document_type_STUDENT_CARD: document_type_STUDENT_CARD,
  document_type_RETIREMENT_PROOF: document_type_RETIREMENT_PROOF,
  document_type_RETIRED: document_type_RETIRED,
  document_type_PROXY_IDENTITY_DOCUMENT: document_type_PROXY_IDENTITY_DOCUMENT,
  document_type_WITHDRAWAL_AMERICAN_CITIZEN_PROOF: document_type_WITHDRAWAL_AMERICAN_CITIZEN_PROOF,
  document_type_HIS_276: document_type_HIS_276,
  document_type_POWER_OF_ATTORNEY: document_type_POWER_OF_ATTORNEY,
  document_type_TRANSFER_OUTSIDE_EU: document_type_TRANSFER_OUTSIDE_EU,
  document_type_WITHDRAW_MORE_THAN_2500: document_type_WITHDRAW_MORE_THAN_2500,
  document_type_BIRTH_CERTIFICATE: document_type_BIRTH_CERTIFICATE,
  document_type_ID_CARD_MINOR: document_type_ID_CARD_MINOR,
  document_type_BIRTH_CERTIFICATE_OR_HOUSEHOLD_COMPOSITION: document_type_BIRTH_CERTIFICATE_OR_HOUSEHOLD_COMPOSITION,
  validated: validated,
  rejected: rejected,
  in_progress: in_progress,
  file_format: file_format,
  pending_for_validation: pending_for_validation,
  uploaded_on: uploaded_on,
  error: error,
  error_occurred: error_occurred,
  refusal_reasons: refusal_reasons
};
var locales = {
  fr: fr,
  nl: nl,
  en: en$1
};
const createStoreImpl = createState => {
  let state;
  const listeners = /* @__PURE__ */new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
      listeners.forEach(listener => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribe = listener => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if ((undefined && undefined.MODE) !== "production") {
      console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
    }
    listeners.clear();
  };
  const api = {
    setState,
    getState,
    subscribe,
    destroy
  };
  state = createState(setState, getState, api);
  return api;
};
const createStore = createState => createState ? createStoreImpl(createState) : createStoreImpl;
var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};

// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

function defaultSetTimout() {
  throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
  throw new Error('clearTimeout has not been defined');
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === 'function') {
  cachedSetTimeout = setTimeout;
}
if (typeof global$1.clearTimeout === 'function') {
  cachedClearTimeout = clearTimeout;
}
function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    //normal enviroments in sane situations
    return setTimeout(fun, 0);
  }
  // if setTimeout wasn't available but was latter defined
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }
  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}
function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    //normal enviroments in sane situations
    return clearTimeout(marker);
  }
  // if clearTimeout wasn't available but was latter defined
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }
  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
      return cachedClearTimeout.call(null, marker);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
      // Some versions of I.E. have different rules for clearTimeout vs setTimeout
      return cachedClearTimeout.call(this, marker);
    }
  }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }
  draining = false;
  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }
  if (queue.length) {
    drainQueue();
  }
}
function drainQueue() {
  if (draining) {
    return;
  }
  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;
  while (len) {
    currentQueue = queue;
    queue = [];
    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }
    queueIndex = -1;
    len = queue.length;
  }
  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}
function nextTick(fun) {
  var args = new Array(arguments.length - 1);
  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
  }
  queue.push(new Item(fun, args));
  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
}
// v8 likes predictible objects
function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}
Item.prototype.run = function () {
  this.fun.apply(null, this.array);
};
var title = 'browser';
var platform$1 = 'browser';
var browser = true;
var env = {};
var argv = [];
var version = ''; // empty string to avoid regexp issues
var versions = {};
var release = {};
var config$1 = {};
function noop$1() {}
var on = noop$1;
var addListener = noop$1;
var once = noop$1;
var off = noop$1;
var removeListener = noop$1;
var removeAllListeners = noop$1;
var emit = noop$1;
function binding(name) {
  throw new Error('process.binding is not supported');
}
function cwd() {
  return '/';
}
function chdir(dir) {
  throw new Error('process.chdir is not supported');
}
function umask() {
  return 0;
}

// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function () {
  return new Date().getTime();
};

// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp) {
  var clocktime = performanceNow.call(performance) * 1e-3;
  var seconds = Math.floor(clocktime);
  var nanoseconds = Math.floor(clocktime % 1 * 1e9);
  if (previousTimestamp) {
    seconds = seconds - previousTimestamp[0];
    nanoseconds = nanoseconds - previousTimestamp[1];
    if (nanoseconds < 0) {
      seconds--;
      nanoseconds += 1e9;
    }
  }
  return [seconds, nanoseconds];
}
var startTime = new Date();
function uptime() {
  var currentTime = new Date();
  var dif = currentTime - startTime;
  return dif / 1000;
}
var browser$1 = {
  nextTick: nextTick,
  title: title,
  browser: browser,
  env: env,
  argv: argv,
  version: version,
  versions: versions,
  on: on,
  addListener: addListener,
  once: once,
  off: off,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform$1,
  release: release,
  config: config$1,
  uptime: uptime
};
var commonjsGlobal$2 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var withSelector = {
  exports: {}
};
var withSelector_production_min = {};
var shim = {
  exports: {}
};
var useSyncExternalStoreShim_production_min = {};

/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production_min;
function requireUseSyncExternalStoreShim_production_min() {
  if (hasRequiredUseSyncExternalStoreShim_production_min) return useSyncExternalStoreShim_production_min;
  hasRequiredUseSyncExternalStoreShim_production_min = 1;
  var e = React$1;
  function h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
  }
  var k = "function" === typeof Object.is ? Object.is : h,
    l = e.useState,
    m = e.useEffect,
    n = e.useLayoutEffect,
    p = e.useDebugValue;
  function q(a, b) {
    var d = b(),
      f = l({
        inst: {
          value: d,
          getSnapshot: b
        }
      }),
      c = f[0].inst,
      g = f[1];
    n(function () {
      c.value = d;
      c.getSnapshot = b;
      r(c) && g({
        inst: c
      });
    }, [a, d, b]);
    m(function () {
      r(c) && g({
        inst: c
      });
      return a(function () {
        r(c) && g({
          inst: c
        });
      });
    }, [a]);
    p(d);
    return d;
  }
  function r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
      var d = b();
      return !k(a, d);
    } catch (f) {
      return !0;
    }
  }
  function t(a, b) {
    return b();
  }
  var u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t : q;
  useSyncExternalStoreShim_production_min.useSyncExternalStore = void 0 !== e.useSyncExternalStore ? e.useSyncExternalStore : u;
  return useSyncExternalStoreShim_production_min;
}
var useSyncExternalStoreShim_development = {};
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  if (hasRequiredUseSyncExternalStoreShim_development) return useSyncExternalStoreShim_development;
  hasRequiredUseSyncExternalStoreShim_development = 1;
  if (browser$1.env.NODE_ENV !== "production") {
    (function () {
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React = React$1;
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning('error', format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          } // eslint-disable-next-line react-internal/safe-string-coercion

          var argsWithFormat = args.map(function (item) {
            return String(item);
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }

      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */
      function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
      }
      var objectIs = typeof Object.is === 'function' ? Object.is : is;

      // dispatch for CommonJS interop named imports.

      var useState = React.useState,
        useEffect = React.useEffect,
        useLayoutEffect = React.useLayoutEffect,
        useDebugValue = React.useDebugValue;
      var didWarnOld18Alpha = false;
      var didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
      // because of a very particular set of implementation details and assumptions
      // -- change any one of them and it will break. The most important assumption
      // is that updates are always synchronous, because concurrent rendering is
      // only available in versions of React that also have a built-in
      // useSyncExternalStore API. And we only use this shim when the built-in API
      // does not exist.
      //
      // Do not assume that the clever hacks used by this hook also work in general.
      // The point of this shim is to replace the need for hacks by other libraries.

      function useSyncExternalStore(subscribe, getSnapshot,
      // Note: The shim does not use getServerSnapshot, because pre-18 versions of
      // React do not expose a way to check if we're hydrating. So users of the shim
      // will need to track that themselves and return the correct value
      // from `getSnapshot`.
      getServerSnapshot) {
        {
          if (!didWarnOld18Alpha) {
            if (React.startTransition !== undefined) {
              didWarnOld18Alpha = true;
              error('You are using an outdated, pre-release alpha of React 18 that ' + 'does not support useSyncExternalStore. The ' + 'use-sync-external-store shim will not work correctly. Upgrade ' + 'to a newer pre-release.');
            }
          }
        } // Read the current snapshot from the store on every render. Again, this
        // breaks the rules of React, and only works here because of specific
        // implementation details, most importantly that updates are
        // always synchronous.

        var value = getSnapshot();
        {
          if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            if (!objectIs(value, cachedValue)) {
              error('The result of getSnapshot should be cached to avoid an infinite loop');
              didWarnUncachedGetSnapshot = true;
            }
          }
        } // Because updates are synchronous, we don't queue them. Instead we force a
        // re-render whenever the subscribed state changes by updating an some
        // arbitrary useState hook. Then, during render, we call getSnapshot to read
        // the current value.
        //
        // Because we don't actually use the state returned by the useState hook, we
        // can save a bit of memory by storing other stuff in that slot.
        //
        // To implement the early bailout, we need to track some things on a mutable
        // object. Usually, we would put that in a useRef hook, but we can stash it in
        // our useState hook instead.
        //
        // To force a re-render, we call forceUpdate({inst}). That works because the
        // new object always fails an equality check.

        var _useState = useState({
            inst: {
              value: value,
              getSnapshot: getSnapshot
            }
          }),
          inst = _useState[0].inst,
          forceUpdate = _useState[1]; // Track the latest getSnapshot function with a ref. This needs to be updated
        // in the layout phase so we can access it during the tearing check that
        // happens on subscribe.

        useLayoutEffect(function () {
          inst.value = value;
          inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
          // commit phase if there was an interleaved mutation. In concurrent mode
          // this can happen all the time, but even in synchronous mode, an earlier
          // effect may have mutated the store.

          if (checkIfSnapshotChanged(inst)) {
            // Force a re-render.
            forceUpdate({
              inst: inst
            });
          }
        }, [subscribe, value, getSnapshot]);
        useEffect(function () {
          // Check for changes right before subscribing. Subsequent changes will be
          // detected in the subscription handler.
          if (checkIfSnapshotChanged(inst)) {
            // Force a re-render.
            forceUpdate({
              inst: inst
            });
          }
          var handleStoreChange = function handleStoreChange() {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) {
              // Force a re-render.
              forceUpdate({
                inst: inst
              });
            }
          }; // Subscribe to the store and return a clean-up function.

          return subscribe(handleStoreChange);
        }, [subscribe]);
        useDebugValue(value);
        return value;
      }
      function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
          var nextValue = latestGetSnapshot();
          return !objectIs(prevValue, nextValue);
        } catch (error) {
          return true;
        }
      }
      function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
        // Note: The shim does not use getServerSnapshot, because pre-18 versions of
        // React do not expose a way to check if we're hydrating. So users of the shim
        // will need to track that themselves and return the correct value
        // from `getSnapshot`.
        return getSnapshot();
      }
      var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
      var isServerEnvironment = !canUseDOM;
      var shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
      var useSyncExternalStore$2 = React.useSyncExternalStore !== undefined ? React.useSyncExternalStore : shim;
      useSyncExternalStoreShim_development.useSyncExternalStore = useSyncExternalStore$2;
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return useSyncExternalStoreShim_development;
}
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim.exports;
  hasRequiredShim = 1;
  if (browser$1.env.NODE_ENV === 'production') {
    shim.exports = requireUseSyncExternalStoreShim_production_min();
  } else {
    shim.exports = requireUseSyncExternalStoreShim_development();
  }
  return shim.exports;
}

/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_production_min;
function requireWithSelector_production_min() {
  if (hasRequiredWithSelector_production_min) return withSelector_production_min;
  hasRequiredWithSelector_production_min = 1;
  var h = React$1,
    n = requireShim();
  function p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
  }
  var q = "function" === typeof Object.is ? Object.is : p,
    r = n.useSyncExternalStore,
    t = h.useRef,
    u = h.useEffect,
    v = h.useMemo,
    w = h.useDebugValue;
  withSelector_production_min.useSyncExternalStoreWithSelector = function (a, b, e, l, g) {
    var c = t(null);
    if (null === c.current) {
      var f = {
        hasValue: !1,
        value: null
      };
      c.current = f;
    } else f = c.current;
    c = v(function () {
      function a(a) {
        if (!c) {
          c = !0;
          d = a;
          a = l(a);
          if (void 0 !== g && f.hasValue) {
            var b = f.value;
            if (g(b, a)) return k = b;
          }
          return k = a;
        }
        b = k;
        if (q(d, a)) return b;
        var e = l(a);
        if (void 0 !== g && g(b, e)) return b;
        d = a;
        return k = e;
      }
      var c = !1,
        d,
        k,
        m = void 0 === e ? null : e;
      return [function () {
        return a(b());
      }, null === m ? void 0 : function () {
        return a(m());
      }];
    }, [b, e, l, g]);
    var d = r(a, c[0], c[1]);
    u(function () {
      f.hasValue = !0;
      f.value = d;
    }, [d]);
    w(d);
    return d;
  };
  return withSelector_production_min;
}
var withSelector_development = {};
var hasRequiredWithSelector_development;
function requireWithSelector_development() {
  if (hasRequiredWithSelector_development) return withSelector_development;
  hasRequiredWithSelector_development = 1;
  if (browser$1.env.NODE_ENV !== "production") {
    (function () {
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React = React$1;
      var shim = requireShim();

      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */
      function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
      }
      var objectIs = typeof Object.is === 'function' ? Object.is : is;
      var useSyncExternalStore = shim.useSyncExternalStore;

      // for CommonJS interop.

      var useRef = React.useRef,
        useEffect = React.useEffect,
        useMemo = React.useMemo,
        useDebugValue = React.useDebugValue; // Same as useSyncExternalStore, but supports selector and isEqual arguments.

      function useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
        // Use this to track the rendered snapshot.
        var instRef = useRef(null);
        var inst;
        if (instRef.current === null) {
          inst = {
            hasValue: false,
            value: null
          };
          instRef.current = inst;
        } else {
          inst = instRef.current;
        }
        var _useMemo = useMemo(function () {
            // Track the memoized state using closure variables that are local to this
            // memoized instance of a getSnapshot function. Intentionally not using a
            // useRef hook, because that state would be shared across all concurrent
            // copies of the hook/component.
            var hasMemo = false;
            var memoizedSnapshot;
            var memoizedSelection;
            var memoizedSelector = function memoizedSelector(nextSnapshot) {
              if (!hasMemo) {
                // The first time the hook is called, there is no memoized result.
                hasMemo = true;
                memoizedSnapshot = nextSnapshot;
                var _nextSelection = selector(nextSnapshot);
                if (isEqual !== undefined) {
                  // Even if the selector has changed, the currently rendered selection
                  // may be equal to the new selection. We should attempt to reuse the
                  // current value if possible, to preserve downstream memoizations.
                  if (inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, _nextSelection)) {
                      memoizedSelection = currentSelection;
                      return currentSelection;
                    }
                  }
                }
                memoizedSelection = _nextSelection;
                return _nextSelection;
              } // We may be able to reuse the previous invocation's result.

              // We may be able to reuse the previous invocation's result.
              var prevSnapshot = memoizedSnapshot;
              var prevSelection = memoizedSelection;
              if (objectIs(prevSnapshot, nextSnapshot)) {
                // The snapshot is the same as last time. Reuse the previous selection.
                return prevSelection;
              } // The snapshot has changed, so we need to compute a new selection.

              // The snapshot has changed, so we need to compute a new selection.
              var nextSelection = selector(nextSnapshot); // If a custom isEqual function is provided, use that to check if the data
              // has changed. If it hasn't, return the previous selection. That signals
              // to React that the selections are conceptually equal, and we can bail
              // out of rendering.

              // If a custom isEqual function is provided, use that to check if the data
              // has changed. If it hasn't, return the previous selection. That signals
              // to React that the selections are conceptually equal, and we can bail
              // out of rendering.
              if (isEqual !== undefined && isEqual(prevSelection, nextSelection)) {
                return prevSelection;
              }
              memoizedSnapshot = nextSnapshot;
              memoizedSelection = nextSelection;
              return nextSelection;
            }; // Assigning this to a constant so that Flow knows it can't change.

            // Assigning this to a constant so that Flow knows it can't change.
            var maybeGetServerSnapshot = getServerSnapshot === undefined ? null : getServerSnapshot;
            var getSnapshotWithSelector = function getSnapshotWithSelector() {
              return memoizedSelector(getSnapshot());
            };
            var getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? undefined : function () {
              return memoizedSelector(maybeGetServerSnapshot());
            };
            return [getSnapshotWithSelector, getServerSnapshotWithSelector];
          }, [getSnapshot, getServerSnapshot, selector, isEqual]),
          getSelection = _useMemo[0],
          getServerSelection = _useMemo[1];
        var value = useSyncExternalStore(subscribe, getSelection, getServerSelection);
        useEffect(function () {
          inst.hasValue = true;
          inst.value = value;
        }, [value]);
        useDebugValue(value);
        return value;
      }
      withSelector_development.useSyncExternalStoreWithSelector = useSyncExternalStoreWithSelector;
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return withSelector_development;
}
if (browser$1.env.NODE_ENV === 'production') {
  withSelector.exports = requireWithSelector_production_min();
} else {
  withSelector.exports = requireWithSelector_development();
}
var withSelectorExports = withSelector.exports;
var useSyncExternalStoreExports = /*@__PURE__*/getDefaultExportFromCjs(withSelectorExports);
const {
  useSyncExternalStoreWithSelector
} = useSyncExternalStoreExports;
function useStore$1(api) {
  let selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : api.getState;
  let equalityFn = arguments.length > 2 ? arguments[2] : undefined;
  const slice = useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
  React$1.useDebugValue(slice);
  return slice;
}
const createImpl = createState => {
  if ((undefined && undefined.MODE) !== "production" && typeof createState !== "function") {
    console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
  }
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore$1(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = createState => createState ? createImpl(createState) : createImpl;
var initialState$1 = {
  currentScreen: 1,
  language: 'en',
  env: 'test',
  request: null,
  error: '',
  contractError: '',
  isLoading: false,
  isLoggedIn: false,
  cookieData: null,
  contractData: null
};
var useStore = create(function (set) {
  return Object.assign(Object.assign({}, initialState$1), {
    setCurrentScreen: function setCurrentScreen(screenNumber) {
      return set({
        currentScreen: screenNumber
      });
    },
    setLanguage: function setLanguage(lang) {
      return set({
        language: lang
      });
    },
    setEnv: function setEnv(environment) {
      return set({
        env: environment
      });
    },
    setError: function setError(value) {
      return set({
        error: value
      });
    },
    setContractError: function setContractError(value) {
      return set({
        contractError: value
      });
    },
    setRequest: function setRequest(value) {
      return set({
        request: value
      });
    },
    setIsLoading: function setIsLoading(loading) {
      return set({
        isLoading: loading
      });
    },
    setIsLoggedIn: function setIsLoggedIn(isLoggedInValue) {
      return set({
        isLoggedIn: isLoggedInValue
      });
    },
    resetState: function resetState() {
      return set(Object.assign({}, initialState$1));
    },
    setCookieData: function setCookieData(data) {
      return set({
        cookieData: data
      });
    },
    setContract: function setContract(data) {
      return set({
        contractData: data
      });
    }
  });
});
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z$9 = ".e1mau7jd{text-align:center;}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9idWlsZHMvb3BwYS9zYWxlcy9wcm9zcGVjdHMvbGlicmFyaWVzL2ZlLXBlcnNvbmFsLXNwYWNlL3NyYy9jb21wb25lbnRzL3NjcmVlbnMvRXJyb3IudHN4Il0sIm5hbWVzIjpbIi5lMW1hdTdqZCJdLCJtYXBwaW5ncyI6IkFBTXVCQSIsImZpbGUiOiIvYnVpbGRzL29wcGEvc2FsZXMvcHJvc3BlY3RzL2xpYnJhcmllcy9mZS1wZXJzb25hbC1zcGFjZS9zcmMvY29tcG9uZW50cy9zY3JlZW5zL0Vycm9yLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFNwYW4gfSBmcm9tICdAa2V5dHJhZGUvY29tcG9uZW50cy1zcGFuJztcbmltcG9ydCB7IFRpdGxlIH0gZnJvbSAnQGtleXRyYWRlL2NvbXBvbmVudHMtdGl0bGUnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IHN0eWxlZCB9IGZyb20gJ0BsaW5hcmlhL3JlYWN0JztcbmltcG9ydCBsb2NhbGVzIGZyb20gJy4uLy4uL2xvY2FsZXMnO1xuaW1wb3J0IHVzZVN0b3JlIGZyb20gJy4uLy4uL3N0b3JlJztcbmNvbnN0IEVycm9yQ29udGFpbmVyID0gc3R5bGVkLmRpdiBgXG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbmA7XG5leHBvcnQgY29uc3QgRXJyb3IgPSAoKSA9PiB7XG4gICAgY29uc3QgeyBsYW5ndWFnZSB9ID0gdXNlU3RvcmUoKTtcbiAgICBjb25zdCBsYWJlbHMgPSBsb2NhbGVzW2xhbmd1YWdlXTtcbiAgICByZXR1cm4gKFJlYWN0LmNyZWF0ZUVsZW1lbnQoRXJyb3JDb250YWluZXIsIG51bGwsXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoVGl0bGUsIHsgbGV2ZWw6ICdoMScsIHNpemU6ICdsZycsIG1hcmdpbjogJzFyZW0nIH0sIGxhYmVscy5lcnJvciksXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoU3BhbiwgeyBzaXplOiAnYm9keVNtJywgY29sb3I6IG51bGwsIHdlaWdodDogJ3NlbWlCb2xkJyB9LCBsYWJlbHMuZXJyb3Jfb2NjdXJyZWQpKSk7XG59O1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9RXJyb3IuanMubWFwIl19*/\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$9);
var ErrorContainer = /*#__PURE__*/styled_default('div')({
  name: "ErrorContainer",
  "class": "e1mau7jd",
  propsAsIs: false
});
var Error$1 = function Error() {
  var _useStore = useStore(),
    language = _useStore.language;
  var labels = locales[language];
  return /*#__PURE__*/React$1.createElement(ErrorContainer, null, /*#__PURE__*/React$1.createElement(componentsTitle.Title, {
    level: 'h1',
    size: 'lg',
    margin: '1rem'
  }, labels.error), /*#__PURE__*/React$1.createElement(componentsSpan.Span, {
    size: 'bodySm',
    color: null,
    weight: 'semiBold'
  }, labels.error_occurred));
};
var SCREENS = {
  HOME: 1,
  INVALID: 2,
  SUCCESS: 3,
  ERROR: 4
};
var REQUEST_TYPES = {
  5: 'OPEN_ACCOUNT',
  6: 'JOINT_ACCOUNT',
  7: 'MINOR_ACCOUNT'
};
var REQUEST_STATUSES = {
  1: 'DOC_MISSING',
  2: 'IN_REVIEW',
  3: 'REJECTED',
  4: 'VALIDATED'
};
// export const REQUEST_STATUSES = {
//   1: 'DOC_MISSING', 
//   2: 'IN_REVIEW',
//   3: 'VALIDATED',// swap those
//   4: 'REJECTED'  // swap those 
// } as const
var FILE_REQUESTED = 1;
var FILE_SUBMITTED = 2;
var FILE_INVALID = 3;
var FILE_PROCESSED = 4;
var FILE_IN_PROGRESS = 5;
var FILE_TYPES = {
  0: 'UNSPECIFIED',
  1: 'POWER_OF_ATTORNEY',
  2: 'PROXY_IDENTITY_DOCUMENT',
  3: 'ID_CARD',
  4: 'LEGAL_ADDRESS_OFFICIAL_PROOF',
  5: 'FISCAL_ADDRESS_OFFICIAL_PROOF',
  6: 'WITHHOLDING_TAX_DECLARATION_FOR_NON_RESIDENT_FORM',
  7: 'W8BEN_CERTIFICATE_FOR_INDIVIDUALS_FORM',
  8: 'CONTRACT',
  9: 'STUDENT_CARD',
  10: 'WITHDRAWAL_AMERICAN_CITIZEN_PROOF',
  11: 'BIRTH_CERTIFICATE',
  12: 'PASSPORT',
  13: 'ID_CARD_MINOR',
  14: 'RETIREMENT_PROOF'
};
var FILE_REFUSAL_REASON = ['UNSPECIFIED', 'FREE_TEXT', 'UNREADABLE_DOCUMENT', 'MISSING_SIGNATURE', 'SIGNATURE_NOT_MATCHING_ID_SIGNATURE', 'INFORMATION_MISSING', 'INVALID_ID', 'INVALID_PASSPORT', 'OUTDATED_OR_CUT_ID', 'OUTDATED_OR_CUT_DOCUMENT', 'DOCUMENT_EXPIRED', 'NON_OFFICIAL_DOCUMENT', 'LANGUAGE_NOT_ACCEPTED', 'MISMATCH_TIN_AND_LEGAL_ADDRESS', 'TIN_MISSING'];
var mockedRequest = [{
  id: '537959396804861954',
  status: 1,
  type: 5,
  filesList: [{
    id: '538002232510193665',
    type: 2,
    status: 1,
    createdOn: {
      seconds: 1706106528,
      nanos: 0
    },
    refusalReason: 1,
    refusalReasonComment: ''
  }, {
    id: '538002232510193666',
    type: 3,
    status: 2,
    createdOn: {
      seconds: 1706106528,
      nanos: 0
    },
    refusalReason: 1,
    refusalReasonComment: ''
  }, {
    id: '538002232510193667',
    type: 4,
    status: 3,
    createdOn: {
      seconds: 1706106528,
      nanos: 0
    },
    refusalReason: 1,
    refusalReasonComment: ''
  }, {
    id: '538002232510193668',
    type: 5,
    status: 4,
    createdOn: {
      seconds: 1706106528,
      nanos: 0
    },
    refusalReason: 1,
    refusalReasonComment: ''
  }, {
    id: '538002232510193669',
    type: 6,
    status: 5,
    createdOn: {
      seconds: 1706106528,
      nanos: 0
    },
    refusalReason: 1,
    refusalReasonComment: ''
  }],
  createdOn: {
    seconds: 1706107231,
    nanos: 0
  },
  updatedOn: {
    seconds: 1706107353,
    nanos: 0
  },
  refusalReason: 1,
  refusalReasonComment: 'this is a test'
}];
var UPLOAD_FILE_TYPES = ['image/png', 'image/jpeg', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
var DISPLAY_FORMATS = {
  'image/png': 'PNG',
  'image/jpeg': 'JPEG',
  'application/pdf': 'PDF',
  'application/msword': 'DOC',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX'
};
var BACKEND_URL_TEST = 'https://www.test.w.keytradebank.be/node/backend/cldprxy/onboarding-bff';
var BACKEND_URL_PROD = 'https://www.keytradebank.be/node/backend/cldprxy/onboarding-bff';
var UPLOAD_BASE_TEST_URL = 'https://www.test.w.keytradebank.be';
var UPLOAD_BASE_PROD_URL = 'https://www.keytradebank.be';
var BFF_LOCALHOST_3000 = 'http://localhost:3000';
var isValidBaseUrl = function isValidBaseUrl(url, validBaseOrigins) {
  try {
    var parsedUrl = new URL(url);
    return validBaseOrigins.includes(parsedUrl.origin);
  } catch (error) {
    throw new Error('Invalid url');
  }
};
var removePort = function removePort(url, env) {
  if (env !== 'local') {
    try {
      var parsedUrl = new URL(url);
      parsedUrl.port = '';
      var urlWithoutPort = parsedUrl.toString();
      if (urlWithoutPort.endsWith('/')) {
        return urlWithoutPort.slice(0, -1);
      }
      return urlWithoutPort;
    } catch (e) {
      throw new Error('Invalid url when validating');
    }
  }
  return url;
};
function downloadByURL(url, name) {
  var a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  a.remove();
}
/**
 * Constants for 404 page configuration
 */
var DEFAULT_LANGUAGE = "en";
var PAGE_404_URLS = {
  fr: "fr",
  nl: "nl",
  en: "en"
};
/**
 * Safely checks if we're in a browser environment
 * This is crucial for Gatsby which does server-side rendering
 */
var isBrowser = function isBrowser() {
  return typeof window !== "undefined";
};
/**
 * Checks if the current URL has an error parameter
 * Safe to use in Gatsby (checks for browser environment)
 */
function hasErrorParam() {
  if (!isBrowser()) return false;
  return new URLSearchParams(window.location.search).has("error");
}
/**
 * Get the current hostname safely (Gatsby-compatible)
 */
function getHostname() {
  if (!isBrowser()) return "";
  return window.location.hostname;
}
/**
 * Creates a URL for the 404 page based on language and hostname
 */
function create404Url(language, hostname) {
  var safeLanguage = language in PAGE_404_URLS ? language : DEFAULT_LANGUAGE;
  return "https://".concat(hostname, "/").concat(safeLanguage, "/404.html");
}
/**
 * Handles redirection to 404 page
 * Gatsby-compatible - checks for browser environment
 */
function redirectToPage404(language) {
  // Don't run on server-side rendering
  if (!isBrowser()) return;
  // Don't redirect if error param exists
  if (hasErrorParam()) return;
  var hostname = getHostname();
  var url = create404Url(language, hostname);
  // Perform the redirect
  window.location.href = url;
}
var headers = {
  'Content-Type': 'application/json'
};
var URLS = {
  prod: {
    BFF_SALES: BACKEND_URL_PROD,
    UPLOAD: UPLOAD_BASE_PROD_URL
  },
  test: {
    BFF_SALES: BACKEND_URL_TEST,
    UPLOAD: UPLOAD_BASE_TEST_URL
  },
  local: {
    BFF_SALES: BFF_LOCALHOST_3000,
    UPLOAD: UPLOAD_BASE_TEST_URL
  },
  mock: {
    BFF_SALES: BFF_LOCALHOST_3000,
    UPLOAD: UPLOAD_BASE_TEST_URL
  }
};
var MOCK_RESPONSES = {
  uploadFileCall: function uploadFileCall() {
    return {
      errorCode: '',
      id: '12345'
    };
  },
  postGuisCall: function postGuisCall() {
    return {
      success: true
    };
  },
  signout: function signout() {
    return {
      success: true
    };
  },
  getContract: function getContract() {
    return {
      contractId: 0,
      filename: '',
      content: '',
      signUrl: ''
    };
  },
  getRequest: function getRequest() {
    return {
      error: '',
      success: true,
      requestListList: mockedRequest
    };
  },
  checkValidityCall: function checkValidityCall() {},
  getUserData: function getUserData() {
    return {
      success: true,
      user: {
        username: 'mockUsername',
        nationalNumber: '1234567890',
        email: 'mockemail@example.com',
        firstName: 'Mock',
        lastName: 'User',
        phone: '123-456-7890',
        lang: 'en',
        origin: 'web',
        reference: 'mockReference123'
      }
    };
  }
};
var REQUESTS = {
  uploadFileCall: function () {
    var _uploadFileCall = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(file, env) {
      var body;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(env === 'mock')) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", new Promise(function (resolve) {
              return resolve(MOCK_RESPONSES.uploadFileCall(file, env));
            }));
          case 2:
            body = new FormData();
            body.append('selectedFile', file);
            body.append('module', 'careers');
            return _context.abrupt("return", fetchWrapper({
              url: "".concat(URLS[env].UPLOAD, "/upload/rest/1.0/file.json"),
              env: env,
              params: body
            }));
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function uploadFileCall(_x, _x2) {
      return _uploadFileCall.apply(this, arguments);
    }
    return uploadFileCall;
  }(),
  postGuisCall: function () {
    var _postGuisCall = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params, env) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(env === 'mock')) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", new Promise(function (resolve) {
              return resolve(MOCK_RESPONSES.postGuisCall(params, env));
            }));
          case 2:
            return _context2.abrupt("return", fetchWrapper({
              url: "".concat(URLS[env].BFF_SALES, "/prospect/link-edoc"),
              env: env,
              params: params
            }));
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function postGuisCall(_x3, _x4) {
      return _postGuisCall.apply(this, arguments);
    }
    return postGuisCall;
  }(),
  getRequest: function () {
    var _getRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(env) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(env === 'mock')) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return", new Promise(function (resolve) {
              return resolve(MOCK_RESPONSES.getRequest(env));
            }));
          case 2:
            return _context3.abrupt("return", fetchWrapper({
              url: "".concat(URLS[env].BFF_SALES, "/prospect/onboarding/request"),
              env: env,
              params: null,
              method: 'GET'
            }));
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function getRequest(_x5) {
      return _getRequest.apply(this, arguments);
    }
    return getRequest;
  }(),
  getContract: function () {
    var _getContract = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(env) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!(env === 'mock')) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return", new Promise(function (resolve) {
              return resolve(MOCK_RESPONSES.getContract(env));
            }));
          case 2:
            return _context4.abrupt("return", fetchWrapper({
              url: "".concat(URLS[env].BFF_SALES, "/prospect/onboarding/contract"),
              env: env,
              params: null,
              method: 'GET'
            }));
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function getContract(_x6) {
      return _getContract.apply(this, arguments);
    }
    return getContract;
  }(),
  checkValidityCall: function () {
    var _checkValidityCall = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(reference, env) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", fetchWrapper({
              url: "".concat(URLS[env].BFF_SALES, "/prospect/magicLink/checkValidity?reference=").concat(reference),
              env: env,
              params: null,
              method: 'GET'
            }));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function checkValidityCall(_x7, _x8) {
      return _checkValidityCall.apply(this, arguments);
    }
    return checkValidityCall;
  }(),
  getUserData: function () {
    var _getUserData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(env) {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!(env === 'mock')) {
              _context6.next = 2;
              break;
            }
            return _context6.abrupt("return", new Promise(function (resolve) {
              return resolve(MOCK_RESPONSES.getUserData(env));
            }));
          case 2:
            return _context6.abrupt("return", fetchWrapper({
              url: "".concat(URLS[env].BFF_SALES, "/prospect/user/data"),
              env: env,
              params: null,
              method: 'GET'
            }));
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    function getUserData(_x9) {
      return _getUserData.apply(this, arguments);
    }
    return getUserData;
  }(),
  signout: function () {
    var _signout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(env) {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", fetchWrapper({
              url: "".concat(URLS[env].BFF_SALES, "/prospect/user/signout"),
              env: env,
              params: null,
              method: 'GET'
            }));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    function signout(_x10) {
      return _signout.apply(this, arguments);
    }
    return signout;
  }()
};
var fetchWrapper = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(_ref) {
    var url, env, params, _ref$method, method, envUrls, bffSalesBaseApiUrl, uploadBaseUrl, validUrls, getState, isFormData, response;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          url = _ref.url, env = _ref.env, params = _ref.params, _ref$method = _ref.method, method = _ref$method === void 0 ? 'POST' : _ref$method;
          envUrls = URLS[env];
          bffSalesBaseApiUrl = envUrls.BFF_SALES;
          uploadBaseUrl = envUrls.UPLOAD;
          validUrls = [removePort(bffSalesBaseApiUrl, env), removePort(uploadBaseUrl, env)];
          getState = useStore.getState;
          if (!isValidBaseUrl(url, validUrls)) {
            _context8.next = 16;
            break;
          }
          isFormData = params instanceof FormData;
          _context8.next = 10;
          return fetch(url, {
            method: method,
            credentials: 'include',
            headers: isFormData ? undefined : headers,
            body: method === 'GET' ? null : isFormData ? params : JSON.stringify(params)
          });
        case 10:
          response = _context8.sent;
          if (response.ok) {
            _context8.next = 14;
            break;
          }
          if (response.status === 401) {
            redirectToPage404(getState().language);
          }
          throw new Error('Network response was not ok');
        case 14:
          if (response.redirected) {
            if (response.url) {
              window.location.href = response.url;
            }
          }
          return _context8.abrupt("return", response.json());
        case 16:
          throw new Error('Invalid url');
        case 17:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function fetchWrapper(_x11) {
    return _ref2.apply(this, arguments);
  };
}();
var useFetchContract$1 = function useFetchContract(env, canFetch) {
  var _useStore = useStore(),
    contractData = _useStore.contractData,
    setContract = _useStore.setContract,
    setError = _useStore.setError,
    setContractError = _useStore.setContractError;
  React$1.useEffect(function () {
    var getContractCall = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return REQUESTS.getContract(env);
            case 3:
              result = _context.sent;
              if (!(result.contractId <= 0)) {
                _context.next = 7;
                break;
              }
              setError("Contract not found");
              return _context.abrupt("return");
            case 7:
              setContract(result);
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              setContractError(_context.t0.message);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 10]]);
      }));
      return function getContractCall() {
        return _ref.apply(this, arguments);
      };
    }();
    if (canFetch == 8) {
      getContractCall();
    }
  }, [canFetch]);
  return contractData;
};
var useFetchRequest = function useFetchRequest(env) {
  var _useStore2 = useStore(),
    request = _useStore2.request,
    setRequest = _useStore2.setRequest,
    setError = _useStore2.setError;
  React$1.useEffect(function () {
    var getRequestCall = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return REQUESTS.getRequest(env);
            case 3:
              result = _context2.sent;
              if (!result.error) {
                _context2.next = 7;
                break;
              }
              setError(result.error);
              return _context2.abrupt("return");
            case 7:
              setRequest(result.requestListList[0]);
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              setError(_context2.t0.message);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 10]]);
      }));
      return function getRequestCall() {
        return _ref2.apply(this, arguments);
      };
    }();
    getRequestCall();
  }, []);
  return request;
};

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
  } else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") {
    // TODO: Can we get rid of as?
    return new Date(argument);
  } else {
    // TODO: Can we get rid of as?
    return new Date(NaN);
  }
}

/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}

/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */

/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */
const millisecondsInWeek = 604800000;

/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */
const millisecondsInDay = 86400000;
let defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

/**
 * The {@link startOfWeek} function options.
 */

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek$1(date, options) {
  const defaultOptions = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek$1(date) {
  return startOfWeek$1(date, {
    weekStartsOn: 1
  });
}

/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = constructFrom(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek$1(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = constructFrom(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek$1(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay$1(date) {
  const _date = toDate(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays$1(dateLeft, dateRight) {
  const startOfDayLeft = startOfDay$1(dateLeft);
  const startOfDayRight = startOfDay$1(dateRight);
  const timestampLeft = +startOfDayLeft - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  const timestampRight = +startOfDayRight - getTimezoneOffsetInMilliseconds(startOfDayRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a day is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round((timestampLeft - timestampRight) / millisecondsInDay);
}

/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek$1(fourthOfJanuary);
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate$1(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid$4(date) {
  if (!isDate$1(date) && typeof date !== "number") {
    return false;
  }
  const _date = toDate(date);
  return !isNaN(Number(_date));
}

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear$1(date) {
  const cleanDate = toDate(date);
  const _date = constructFrom(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
const formatDistance = (token, count, options) => {
  let result;
  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn(args) {
  return function () {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
const formatRelative = (token, _date, _baseDate, _options) => formatRelativeLocale[token];

/* eslint-disable no-unused-vars */

/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */

/**
 * The map of localized values for each width.
 */

/**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */

/**
 * Converts the unit value to the tuple of values.
 */

/**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */

/**
 * The tuple of localized quarter values. The first element represents Q1.
 */

/**
 * The tuple of localized day values. The first element represents Sunday.
 */

/**
 * The tuple of localized month values. The first element represents January.
 */

function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: quarter => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return function (string) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const width = options.width;
    const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, pattern => pattern.test(matchedString)) :
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    findKey(parsePatterns, pattern => pattern.test(matchedString));
    let value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey(object, predicate) {
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
function buildMatchPatternFn(args) {
  return function (string) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];
    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: value => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: index => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};

/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
const enUS = {
  code: "en-US",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};

/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear$1(date) {
  const _date = toDate(date);
  const diff = differenceInCalendarDays$1(_date, startOfYear$1(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek$1(date) {
  const _date = toDate(date);
  const diff = +startOfISOWeek$1(_date) - +startOfISOWeekYear(_date);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}

/**
 * The {@link getWeekYear} function options.
 */

/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(date, options) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const defaultOptions = getDefaultOptions();
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
  const firstWeekOfNextYear = constructFrom(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek$1(firstWeekOfNextYear, options);
  const firstWeekOfThisYear = constructFrom(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek$1(firstWeekOfThisYear, options);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * The {@link startOfWeekYear} function options.
 */

/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(date, options) {
  const defaultOptions = getDefaultOptions();
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek$1(firstWeek, options);
  return _date;
}

/**
 * The {@link getWeek} function options.
 */

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(date, options) {
  const _date = toDate(date);
  const diff = +startOfWeek$1(_date, options) - +startOfWeekYear(_date, options);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}
function addLeadingZeros$1(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

const lightFormatters = {
  // Year
  y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    const signedYear = date.getFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros$1(token === "yy" ? year % 100 : year, token.length);
  },
  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros$1(month + 1, 2);
  },
  // Day of the month
  d(date, token) {
    return addLeadingZeros$1(date.getDate(), token.length);
  },
  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros$1(date.getHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros$1(date.getHours(), token.length);
  },
  // Minute
  m(date, token) {
    return addLeadingZeros$1(date.getMinutes(), token.length);
  },
  // Second
  s(date, token) {
    return addLeadingZeros$1(date.getSeconds(), token.length);
  },
  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros$1(fractionalSeconds, token.length);
  }
};
const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

const formatters$1 = {
  // Era
  G: function (date, token, localize) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize.era(era, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return localize.era(era, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize.era(era, {
          width: "wide"
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === "yo") {
      const signedYear = date.getFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: "year"
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    const signedWeekYear = getWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros$1(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === "Yo") {
      return localize.ordinalNumber(weekYear, {
        unit: "year"
      });
    }

    // Padding
    return addLeadingZeros$1(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    const isoWeekYear = getISOWeekYear(date);

    // Padding
    return addLeadingZeros$1(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    const year = date.getFullYear();
    return addLeadingZeros$1(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros$1(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize.ordinalNumber(quarter, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros$1(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize.ordinalNumber(quarter, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize.ordinalNumber(month + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return localize.month(month, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros$1(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize.ordinalNumber(month + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return localize.month(month, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    const week = getWeek(date, options);
    if (token === "wo") {
      return localize.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros$1(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    const isoWeek = getISOWeek$1(date);
    if (token === "Io") {
      return localize.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros$1(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === "do") {
      return localize.ordinalNumber(date.getDate(), {
        unit: "date"
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    const dayOfYear = getDayOfYear$1(date);
    if (token === "Do") {
      return localize.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros$1(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros$1(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros$1(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros$1(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      // Tue
      case "iii":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === "Ho") {
      return localize.ordinalNumber(date.getHours(), {
        unit: "hour"
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    const hours = date.getHours() % 12;
    if (token === "Ko") {
      return localize.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros$1(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;
    if (token === "ko") {
      return localize.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros$1(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === "mo") {
      return localize.ordinalNumber(date.getMinutes(), {
        unit: "minute"
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === "so") {
      return localize.ordinalNumber(date.getSeconds(), {
        unit: "second"
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        // Hours and minutes without `:` delimiter
        return formatTimezone$1(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        // Hours and minutes without `:` delimiter
        return formatTimezone$1(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1000);
    return addLeadingZeros$1(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize) {
    const timestamp = date.getTime();
    return addLeadingZeros$1(timestamp, token.length);
  }
};
function formatTimezoneShort(offset) {
  let delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros$1(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros$1(Math.abs(offset) / 60, 2);
  }
  return formatTimezone$1(offset, delimiter);
}
function formatTimezone$1(offset) {
  let delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros$1(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros$1(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
const dateLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "P":
      return formatLong.date({
        width: "short"
      });
    case "PP":
      return formatLong.date({
        width: "medium"
      });
    case "PPP":
      return formatLong.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong.date({
        width: "full"
      });
  }
};
const timeLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "p":
      return formatLong.time({
        width: "short"
      });
    case "pp":
      return formatLong.time({
        width: "medium"
      });
    case "ppp":
      return formatLong.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong.time({
        width: "full"
      });
  }
};
const dateTimeLongFormatter = (pattern, formatLong) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = ["D", "DD", "YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}
function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * The {@link format} function options.
 */

/**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format$3(date, formatStr, options) {
  const defaultOptions = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions.locale ?? enUS;
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
  const originalDate = toDate(date);
  if (!isValid$4(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts = formatStr.match(longFormattingTokensRegExp).map(substring => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map(substring => {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return {
        isToken: false,
        value: "'"
      };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return {
        isToken: false,
        value: cleanEscapedString(substring)
      };
    }
    if (formatters$1[firstCharacter]) {
      return {
        isToken: true,
        value: substring
      };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return {
      isToken: false,
      value: substring
    };
  });

  // invoke localize preprocessor (only for french locales at the moment)
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  return parts.map(part => {
    if (!part.isToken) return part.value;
    const token = part.value;
    if (!options?.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token) || !options?.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, String(date));
    }
    const formatter = formatters$1[token[0]];
    return formatter(originalDate, token, locale.localize, formatterOptions);
  }).join("");
}
function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */
function fromUnixTime(unixTime) {
  return toDate(unixTime * 1000);
}
var css_248z$8 = ".t11qb2pq{text-align:left;margin-bottom:2rem;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:space-between;-webkit-justify-content:space-between;justify-content:space-between;gap:2rem;font-family:Averta,sans-serif;font-size:1.6rem;color:#2C3B45;}@media (max-width: 991px){.t11qb2pq{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;font-size:1.8rem;}}\n.r11jrndi{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:space-between;-webkit-justify-content:space-between;justify-content:space-between;row-gap:1rem;}\n.r1jgz2d1{margin:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}\n.r17pbo74{font-size:1.6rem!important;font-family:Averta,sans-serif;font-weight:600;}@media (max-width: 991px){.r17pbo74{font-size:1.8rem!important;}}\n\n.ruya83z{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;max-width:33%;row-gap:0.5rem;-webkit-box-pack:justify;-ms-flex-pack:space-between;-webkit-justify-content:space-between;justify-content:space-between;}@media (max-width: 991px){.ruya83z{max-width:100%;}}\n.r1a35u9a{gap:0.5rem;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}\n.r14691a3{font-weight:600;}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9idWlsZHMvb3BwYS9zYWxlcy9wcm9zcGVjdHMvbGlicmFyaWVzL2ZlLXBlcnNvbmFsLXNwYWNlL3NyYy9jb21wb25lbnRzL3NoYXJlZC9HcmVldGluZ0xhYmVscy50c3giXSwibmFtZXMiOlsiLnQxMXFiMnBxIiwiLnIxMWpybmRpIiwiLnIxamd6MmQxIiwiLnIxN3Bibzc0IiwiLnI3cWhuMXMiLCIucnV5YTgzeiIsIi5yMWEzNXU5YSIsIi5yMTQ2OTFhMyJdLCJtYXBwaW5ncyI6IkFBV3FCQTtBQWdCREM7QUFNU0M7QUFLSkM7QUFVTUM7QUFXTEM7QUFZSkM7QUFJTUMiLCJmaWxlIjoiL2J1aWxkcy9vcHBhL3NhbGVzL3Byb3NwZWN0cy9saWJyYXJpZXMvZmUtcGVyc29uYWwtc3BhY2Uvc3JjL2NvbXBvbmVudHMvc2hhcmVkL0dyZWV0aW5nTGFiZWxzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEJhZGdlIH0gZnJvbSAnQGtleXRyYWRlL2NvbXBvbmVudHMtYmFkZ2UnO1xuaW1wb3J0IHsgY29uZmlnIH0gZnJvbSAnQGtleXRyYWRlL2Z1bmN0aW9ucyc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgc3R5bGVkIH0gZnJvbSAnQGxpbmFyaWEvcmVhY3QnO1xuaW1wb3J0IHsgZm9ybWF0IH0gZnJvbSAnZGF0ZS1mbnMnO1xuaW1wb3J0IHsgUkVRVUVTVF9TVEFUVVNFUywgUkVRVUVTVF9UWVBFUyB9IGZyb20gJy4uLy4uL2NvbnN0YW50cyc7XG5pbXBvcnQgbG9jYWxlcyBmcm9tICcuLi8uLi9sb2NhbGVzJztcbmltcG9ydCB1c2VTdG9yZSBmcm9tICcuLi8uLi9zdG9yZSc7XG5jb25zdCB7IGRldmljZURvd24gfSA9IGNvbmZpZy5icmVha3BvaW50cztcbmNvbnN0IHsgZ2V0Rm9udCB9ID0gY29uZmlnLmZvbnRzO1xuY29uc3QgeyBsaXN0OiBjb2xvcnMgfSA9IGNvbmZpZy5jb2xvcnM7XG5jb25zdCBUb3BDb250YWluZXIgPSBzdHlsZWQuZGl2IGBcbiAgdGV4dC1hbGlnbjogbGVmdDtcbiAgbWFyZ2luLWJvdHRvbTogMnJlbTtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBnYXA6IDJyZW07XG4gIGZvbnQtZmFtaWx5OiBBdmVydGEsIHNhbnMtc2VyaWY7XG4gIGZvbnQtc2l6ZTogMS42cmVtO1xuICBjb2xvcjogIzJDM0I0NTtcblxuXG4gIEBtZWRpYSAke2RldmljZURvd24udGFibGV0fSB7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBmb250LXNpemU6IDEuOHJlbTtcbiAgfVxuYDtcbmNvbnN0IFJlcXVlc3RJbmZvID0gc3R5bGVkLmRpdiBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgcm93LWdhcDogMXJlbTtcbmA7XG5jb25zdCBSZXF1ZXN0SW5mb0NvbnRhaW5lciA9IHN0eWxlZC5kaXYgYFxuICBtYXJnaW46IDA7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG5gO1xuY29uc3QgUmVxdWVzdEluZm9UaXRsZSA9IHN0eWxlZC5kaXYgYFxuICBmb250LXNpemU6IDEuNnJlbSAhaW1wb3J0YW50O1xuICBmb250LWZhbWlseTogQXZlcnRhLCBzYW5zLXNlcmlmO1xuICBmb250LXdlaWdodDogNjAwO1xuXG5cbiAgQG1lZGlhICR7ZGV2aWNlRG93bi50YWJsZXR9IHtcbiAgICBmb250LXNpemU6IDEuOHJlbSAhaW1wb3J0YW50O1xuICB9XG5gO1xuY29uc3QgUmVxdWVzdEluZm9EZXNjcmlwdGlvbiA9IHN0eWxlZC5kaXYgYFxuYDtcbmNvbnN0IFN0eWxlZEJhZGdlID0gc3R5bGVkKEJhZGdlKSBgXG4gIGZvbnQtZmFtaWx5OiAke2dldEZvbnQoe30sICdhdmVydGFCb2xkJyl9ICFpbXBvcnRhbnQ7XG4gIGZvbnQtc2l6ZTogMS42cmVtICFpbXBvcnRhbnQ7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9ycy5HcmV5V2hpdGV9ICFpbXBvcnRhbnQ7XG4gIGJvcmRlcjogbm9uZSAhaW1wb3J0YW50O1xuICBwYWRkaW5nOiAwLjVyZW0gIWltcG9ydGFudDtcbiAgY29sb3I6ICR7Y29sb3JzLkJsdWVNb29ufSAhaW1wb3J0YW50O1xuYDtcbmNvbnN0IFJlZkRhdGVzQ29udGFpbmVyID0gc3R5bGVkLmRpdiBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIG1heC13aWR0aDogMzMlO1xuICByb3ctZ2FwOiAwLjVyZW07XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcblxuXG4gIEBtZWRpYSAke2RldmljZURvd24udGFibGV0fSB7XG4gICAgbWF4LXdpZHRoOiAxMDAlO1xuICB9XG5gO1xuY29uc3QgUmVmRGF0ZXNGaWVsZCA9IHN0eWxlZC5kaXYgYFxuICBnYXA6IDAuNXJlbTtcbiAgZGlzcGxheTogZmxleDtcbmA7XG5jb25zdCBSZWZEYXRlc0ZpZWxkQm9sZGVyID0gc3R5bGVkLmRpdiBgXG4gIGZvbnQtd2VpZ2h0OiA2MDBcbmA7XG5leHBvcnQgY29uc3QgR3JlZXRpbmdMYWJlbHMgPSAoeyByZXF1ZXN0IH0pID0+IHtcbiAgICBjb25zdCB7IGxhbmd1YWdlLCBjb29raWVEYXRhIH0gPSB1c2VTdG9yZSgpO1xuICAgIGNvbnN0IGxhYmVscyA9IGxvY2FsZXNbbGFuZ3VhZ2VdO1xuICAgIGNvbnN0IHJlcXVlc3RUeXBlbmFtZSA9IHJlcXVlc3QgPyBSRVFVRVNUX1RZUEVTW3JlcXVlc3QudHlwZV0gOiAnJztcbiAgICBjb25zdCByZXF1ZXN0U3RhdHVzTmFtZSA9IHJlcXVlc3QgPyBSRVFVRVNUX1NUQVRVU0VTW3JlcXVlc3Quc3RhdHVzXSA6ICcnO1xuICAgIGNvbnN0IHJlcXVlc3RDcmVhdGlvbkRhdGUgPSByZXF1ZXN0ID8gZm9ybWF0KHJlcXVlc3QuY3JlYXRlZE9uLnNlY29uZHMgKiAxMDAwLCAnZGQvTU0veXl5eScpIDogJyc7XG4gICAgcmV0dXJuIChSZWFjdC5jcmVhdGVFbGVtZW50KFRvcENvbnRhaW5lciwgbnVsbCxcbiAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChSZXF1ZXN0SW5mbywgbnVsbCxcbiAgICAgICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoUmVxdWVzdEluZm9Db250YWluZXIsIG51bGwsXG4gICAgICAgICAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChSZXF1ZXN0SW5mb1RpdGxlLCBudWxsLCByZXF1ZXN0XG4gICAgICAgICAgICAgICAgICAgID8gKGxhYmVsc1tgcmVxdWVzdF90eXBlXyR7cmVxdWVzdFR5cGVuYW1lfWBdXG4gICAgICAgICAgICAgICAgICAgICAgICArIFwiIC0gXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICsgKGxhYmVsc1tgcmVxdWVzdF9zdGF0dXNfJHtyZXF1ZXN0U3RhdHVzTmFtZX1gXSkpXG4gICAgICAgICAgICAgICAgICAgIDogJycpKSxcbiAgICAgICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoUmVxdWVzdEluZm9EZXNjcmlwdGlvbiwgbnVsbCwgbGFiZWxzLnJlcXVlc3RfdHlwZV9vcGVuaW5nX2FjY291bnRfZGVzY3JpcHRpb24pKSxcbiAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChSZWZEYXRlc0NvbnRhaW5lciwgbnVsbCxcbiAgICAgICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoUmVmRGF0ZXNGaWVsZCwgbnVsbCxcbiAgICAgICAgICAgICAgICBsYWJlbHMuY3JlYXRpb25fZGF0ZSxcbiAgICAgICAgICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFJlZkRhdGVzRmllbGRCb2xkZXIsIG51bGwsIHJlcXVlc3RDcmVhdGlvbkRhdGUpKSxcbiAgICAgICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoUmVmRGF0ZXNGaWVsZCwgbnVsbCxcbiAgICAgICAgICAgICAgICBsYWJlbHMucmVmZXJlbmNlLFxuICAgICAgICAgICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoUmVmRGF0ZXNGaWVsZEJvbGRlciwgbnVsbCwgY29va2llRGF0YSA9PT0gbnVsbCB8fCBjb29raWVEYXRhID09PSB2b2lkIDAgPyB2b2lkIDAgOiBjb29raWVEYXRhLnJlZmVyZW5jZSkpKSkpO1xufTtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUdyZWV0aW5nTGFiZWxzLmpzLm1hcCJdfQ==*/\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$8);
var TopContainer = /*#__PURE__*/styled_default('div')({
  name: "TopContainer",
  "class": "t11qb2pq",
  propsAsIs: false
});
var RequestInfo = /*#__PURE__*/styled_default('div')({
  name: "RequestInfo",
  "class": "r11jrndi",
  propsAsIs: false
});
var RequestInfoContainer = /*#__PURE__*/styled_default('div')({
  name: "RequestInfoContainer",
  "class": "r1jgz2d1",
  propsAsIs: false
});
var RequestInfoTitle = /*#__PURE__*/styled_default('div')({
  name: "RequestInfoTitle",
  "class": "r17pbo74",
  propsAsIs: false
});
var RequestInfoDescription = /*#__PURE__*/styled_default('div')({
  name: "RequestInfoDescription",
  "class": "r7qhn1s",
  propsAsIs: false
});
var RefDatesContainer = /*#__PURE__*/styled_default('div')({
  name: "RefDatesContainer",
  "class": "ruya83z",
  propsAsIs: false
});
var RefDatesField = /*#__PURE__*/styled_default('div')({
  name: "RefDatesField",
  "class": "r1a35u9a",
  propsAsIs: false
});
var RefDatesFieldBolder = /*#__PURE__*/styled_default('div')({
  name: "RefDatesFieldBolder",
  "class": "r14691a3",
  propsAsIs: false
});
var GreetingLabels = function GreetingLabels(_ref) {
  var request = _ref.request;
  var _useStore = useStore(),
    language = _useStore.language,
    cookieData = _useStore.cookieData;
  var labels = locales[language];
  var requestTypename = request ? REQUEST_TYPES[request.type] : '';
  var requestStatusName = request ? REQUEST_STATUSES[request.status] : '';
  var requestCreationDate = request ? format$3(request.createdOn.seconds * 1000, 'dd/MM/yyyy') : '';
  return /*#__PURE__*/React$1.createElement(TopContainer, null, /*#__PURE__*/React$1.createElement(RequestInfo, null, /*#__PURE__*/React$1.createElement(RequestInfoContainer, null, /*#__PURE__*/React$1.createElement(RequestInfoTitle, null, request ? labels["request_type_".concat(requestTypename)] + " - " + labels["request_status_".concat(requestStatusName)] : '')), /*#__PURE__*/React$1.createElement(RequestInfoDescription, null, labels.request_type_opening_account_description)), /*#__PURE__*/React$1.createElement(RefDatesContainer, null, /*#__PURE__*/React$1.createElement(RefDatesField, null, labels.creation_date, /*#__PURE__*/React$1.createElement(RefDatesFieldBolder, null, requestCreationDate)), /*#__PURE__*/React$1.createElement(RefDatesField, null, labels.reference, /*#__PURE__*/React$1.createElement(RefDatesFieldBolder, null, cookieData === null || cookieData === void 0 ? void 0 : cookieData.reference))));
};
var bundle = {};
var sharedFunctions = {};
var config_1;
Object.defineProperty(sharedFunctions, "__esModule", {
  value: !0
});
var SIZE_XS = 320,
  SIZE_SM = 576,
  SIZE_MD = 768,
  SIZE_LG = 992,
  SIZE_XL = 1200,
  SIZES = {
    SIZE_XS: SIZE_XS,
    SIZE_SM: SIZE_SM,
    SIZE_MD: SIZE_MD,
    SIZE_LG: SIZE_LG,
    SIZE_XL: SIZE_XL
  },
  device = {
    mobile: "(min-width: " + SIZE_XS + "px)",
    mobileL: "(min-width: " + SIZE_SM + "px)",
    tablet: "(min-width: " + SIZE_MD + "px)",
    tabletL: "(min-width: " + SIZE_LG + "px)",
    desktop: "(min-width: " + SIZE_XL + "px)"
  },
  deviceDown = {
    mobile: "(max-width: " + (SIZE_SM - 1) + "px)",
    mobileL: "(max-width: " + (SIZE_MD - 1) + "px)",
    tablet: "(max-width: " + (SIZE_LG - 1) + "px)",
    tabletL: "(max-width: " + (SIZE_XL - 1) + "px)"
  },
  deviceOnly = {
    mobile: "(max-width: " + SIZE_SM + "px)",
    mobileL: "(min-width: " + SIZE_SM + "px) and (max-width: " + (SIZE_MD - 1) + "px)",
    tablet: "(min-width: " + SIZE_MD + "px) and (max-width: " + (SIZE_LG - 1) + "px)",
    tabletL: "(min-width: " + SIZE_LG + "px) and (max-width: " + (SIZE_XL - 1) + "px)",
    desktop: "(min-width: " + SIZE_XL + "px)"
  },
  breakpoints = {
    device: device,
    deviceDown: deviceDown,
    deviceOnly: deviceOnly
  },
  colors$3 = {
    AeroBlue: "#c6eada",
    AzureX: "#e6f7fb",
    AzureXDark: "#0a1f26",
    BabyPink: "#f8c9c5",
    Black: "#000000",
    BlackTransparent: "rgba(0,0,0,0.7)",
    BlackTransparentLight: "rgba(0,0,0,0.2)",
    BlackTransparentMedium: "rgba(0,0,0,0.35)",
    BlizzardBlue: "#b3e8f4",
    BlueCloudy: "#a7bdcc",
    BlueCloudyTransparent: "rgba(167,189,204,0.5)",
    BlueDark: "#2c3b45",
    BlueDarkGradient: "linear-gradient(-225deg, rgb(44, 59, 69) 0%, rgb(78, 98, 110) 100%)",
    BlueDawn: "#007f9e",
    BlueFog: "#CEDAE1",
    BlueHeaven: "#64dfff",
    BlueLight: "#E4EBEF",
    BlueLightGradient: "linear-gradient(-225deg, rgb(235, 249, 252) 0%, rgb(191, 240, 247) 100%)",
    BlueMoon: "#3c5463",
    BlueNight: "#1D6478",
    BlueSky: "#00b3db",
    BlueSkyVivid: "#33c2e2",
    BlueSmoke: "#F1F5F7",
    Bittersweet: "#ed7064",
    Bunker: "#171E24",
    DeepChampagne: "#fbd38d",
    GreenDark: "#19a568",
    GreenFlash: "#44DB5E",
    GreenGarden: "#029231",
    GreenLight: "#52cb95",
    GreenMedium: "#1AAF5D",
    GreenOcean: "#67c89d",
    GreenSeafoam: "#41ba84",
    Grey: "#e6e8e9",
    GreyBackground: "#ebf0f2",
    GreyBlue: "#5A7A8E",
    GreyBright: "#f7f7f7",
    GreyDark: "#5e6467",
    GreyLight: "#d8d8d8",
    GreyMedium: "#b7b7b7",
    GreyWarm: "#959da2",
    GreyWhite: "#efefef",
    HoneyDew: "#d9f1e6",
    HoneyDewDark: "#153127",
    LavenderBlush: "#fdedec",
    LavenderBlushDark: "#201516",
    LightCyan: "#ccf0f8",
    LightCyanDark: "#07313A",
    MagicMint: "#b3e3ce",
    Melon: "#f6b7b1",
    MintCream: "#ecf8f3",
    MintCreamDark: "#10201D",
    MistyRose: "#fadbd8",
    MistyRoseDark: "#361B1A",
    NonPhotoBlue: "#99e1f1",
    OldLace: "#fef6e8",
    OldLaceDark: "#221E13",
    Orange: "#f7a71a",
    OrangeDark: "#ff860f",
    PapayaWhip: "#fdedd1",
    PapayaWhipDark: "#392D13",
    Peach: "#fde5da",
    Purple: "#b90059",
    Sunary: "#f9c15f",
    Tomato: "#e84c3d",
    TomatoDark: "#ca4036",
    TomatoLight: "#eb8b84",
    TomatoFlash: "#CB1212",
    Transparent: "transparent",
    VisaGold: "#a18950",
    VisaPlatinum: "#86898b",
    White: "#ffffff",
    WhiteTransparent: "rgba(255,255,255,0.3)",
    YellowVanilla: "#fbf4d3",
    Grey10Ghost: "#F7F9FA",
    Grey20Smoke: "#F2F5F7",
    Grey30Mist: "#E6EDF0",
    Grey40Haze: "#DAE3E8",
    Grey50Fog: "#CEDAE0",
    Grey60Smog: "#BAC8CF",
    Grey70Cloudy: "#A9BAC4",
    Grey80Concrete: "#A0B1BA",
    Grey90Silver: "#94A7B0",
    Grey100Steel: "#889CA6",
    Grey200Slate: "#7C919C",
    Grey300Lead: "#7C919C",
    Grey400Iron: "#677C87",
    Grey500Titanium: "#5C727D",
    Grey600Graphite: "#536673",
    Grey700Obsidian: "#495C69",
    Grey800Darkblue: "#2C3B45",
    Grey850Shadow: "#24323C",
    Grey900Night: "#1E2A33",
    Grey950Pitchdark: "#172026",
    Grey1000Black: "#000000",
    Red100: "#FAE9E7",
    Red200: "#F6D2CE",
    Red300: "#EDA59D",
    Red400: "#E3786D",
    Red500: "#DA4B3C",
    Red600: "#D11E0B",
    Red700: "#A71809",
    Red800: "#7D1207",
    Orange100: "#FEF6E8",
    Orange200: "#FDEDD1",
    Orange300: "#FCDCA3",
    Orange400: "#FACA76",
    Orange500: "#F9B948",
    Orange600: "#F7A71A",
    Orange700: "#DE9617",
    Orange800: "#C68615",
    Orange900: "#8A6628",
    Green100: "#E6F3EE",
    Green200: "#CDE8DE",
    Green300: "#9AD0BD",
    Green400: "#35A17A",
    Green500: "#1C9166",
    Green600: "#038153",
    Green700: "#026E47",
    Green800: "#025335",
    Blue100: "#E6F7FB",
    Blue200: "#CCF0F8",
    Blue300: "#B3E8F4",
    Blue400: "#99E1F1",
    Blue500: "#33C2E2",
    Blue600Sky: "#00B3DB",
    Blue700Dawn: "#007F9E",
    Blue800: "#006480"
  },
  isValid = function isValid(e) {
    if (void 0 === colors$3[e]) throw new Error("Unknown color " + e);
    return !0;
  },
  hexToTransparentRGBA = function hexToTransparentRGBA(e, n) {
    isValid(e);
    var e = colors$3[e];
    return 7 < e.length || "#" !== e.substr(0, 1) ? null : (e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e), "rgba(" + parseInt(e[1], 16) + ", " + parseInt(e[2], 16) + ", " + parseInt(e[3], 16) + ", " + (n || 0) + ")");
  },
  colors$1$2 = {
    hexToTransparentRGBA: hexToTransparentRGBA,
    list: colors$3
  },
  countries = {
    af: {
      phone: "+93",
      isSepa: !1
    },
    ax: {
      phone: "+358",
      isSepa: !1
    },
    al: {
      phone: "+355",
      isSepa: !1
    },
    dz: {
      phone: "+213",
      isSepa: !1
    },
    as: {
      phone: "+1684",
      isSepa: !1
    },
    ad: {
      phone: "+376",
      isSepa: !0
    },
    ao: {
      phone: "+244",
      isSepa: !1
    },
    ai: {
      phone: "+1264",
      isSepa: !1
    },
    aq: {
      phone: "+672",
      isSepa: !1
    },
    ag: {
      phone: "+1268",
      isSepa: !1
    },
    ar: {
      phone: "+54",
      isSepa: !1
    },
    am: {
      phone: "+374",
      isSepa: !1
    },
    aw: {
      phone: "+297",
      isSepa: !1
    },
    au: {
      phone: "+61",
      isSepa: !1
    },
    at: {
      phone: "+43",
      isSepa: !0
    },
    az: {
      phone: "+994",
      isSepa: !1
    },
    bs: {
      phone: "+1242",
      isSepa: !1
    },
    bh: {
      phone: "+973",
      isSepa: !1
    },
    bd: {
      phone: "+880",
      isSepa: !1
    },
    bb: {
      phone: "+1246",
      isSepa: !1
    },
    by: {
      phone: "+375",
      isSepa: !1
    },
    be: {
      phone: "+32",
      isSepa: !0
    },
    bz: {
      phone: "+501",
      isSepa: !1
    },
    bj: {
      phone: "+229",
      isSepa: !1
    },
    bm: {
      phone: "+1441",
      isSepa: !1
    },
    bt: {
      phone: "+975",
      isSepa: !1
    },
    bo: {
      phone: "+591",
      isSepa: !1
    },
    ba: {
      phone: "+387",
      isSepa: !1
    },
    bw: {
      phone: "+267",
      isSepa: !1
    },
    bv: {
      phone: "+47",
      isSepa: !1
    },
    br: {
      phone: "+55",
      isSepa: !1
    },
    io: {
      phone: "+246",
      isSepa: !1
    },
    bn: {
      phone: "+673",
      isSepa: !1
    },
    bg: {
      phone: "+359",
      isSepa: !0
    },
    bf: {
      phone: "+226",
      isSepa: !1
    },
    bi: {
      phone: "+257",
      isSepa: !1
    },
    kh: {
      phone: "+855",
      isSepa: !1
    },
    cm: {
      phone: "+237",
      isSepa: !1
    },
    ca: {
      phone: "+1",
      isSepa: !1
    },
    cv: {
      phone: "+238",
      isSepa: !1
    },
    ky: {
      phone: "+345",
      isSepa: !1
    },
    cf: {
      phone: "+236",
      isSepa: !1
    },
    td: {
      phone: "+235",
      isSepa: !1
    },
    cl: {
      phone: "+56",
      isSepa: !1
    },
    cn: {
      phone: "+86",
      isSepa: !1
    },
    cx: {
      phone: "+61",
      isSepa: !1
    },
    cc: {
      phone: "+61",
      isSepa: !1
    },
    co: {
      phone: "+57",
      isSepa: !1
    },
    km: {
      phone: "+269",
      isSepa: !1
    },
    cg: {
      phone: "+242",
      isSepa: !1
    },
    cd: {
      phone: "+243",
      isSepa: !1
    },
    ck: {
      phone: "+682",
      isSepa: !1
    },
    cr: {
      phone: "+506",
      isSepa: !1
    },
    ci: {
      phone: "+225",
      isSepa: !1
    },
    hr: {
      phone: "+385",
      isSepa: !0
    },
    cu: {
      phone: "+53",
      isSepa: !1
    },
    cy: {
      phone: "+357",
      isSepa: !0
    },
    cz: {
      phone: "+420",
      isSepa: !0
    },
    dk: {
      phone: "+45",
      isSepa: !0
    },
    dj: {
      phone: "+253",
      isSepa: !1
    },
    dm: {
      phone: "+1767",
      isSepa: !1
    },
    "do": {
      phone: "+1849",
      isSepa: !1
    },
    ec: {
      phone: "+593",
      isSepa: !1
    },
    eg: {
      phone: "+20",
      isSepa: !1
    },
    sv: {
      phone: "+503",
      isSepa: !1
    },
    gq: {
      phone: "+240",
      isSepa: !1
    },
    er: {
      phone: "+291",
      isSepa: !1
    },
    ee: {
      phone: "+372",
      isSepa: !0
    },
    et: {
      phone: "+251",
      isSepa: !1
    },
    fk: {
      phone: "+500",
      isSepa: !1
    },
    fo: {
      phone: "+298",
      isSepa: !1
    },
    fj: {
      phone: "+679",
      isSepa: !1
    },
    fi: {
      phone: "+358",
      isSepa: !0
    },
    fr: {
      phone: "+33",
      isSepa: !0
    },
    gf: {
      phone: "+594",
      isSepa: !1
    },
    pf: {
      phone: "+689",
      isSepa: !1
    },
    tf: {
      phone: "+262",
      isSepa: !1
    },
    ga: {
      phone: "+241",
      isSepa: !1
    },
    gm: {
      phone: "+220",
      isSepa: !1
    },
    ge: {
      phone: "+995",
      isSepa: !1
    },
    de: {
      phone: "+49",
      isSepa: !0
    },
    gh: {
      phone: "+233",
      isSepa: !1
    },
    gi: {
      phone: "+350",
      isSepa: !0
    },
    gr: {
      phone: "+30",
      isSepa: !0
    },
    gl: {
      phone: "+299",
      isSepa: !1
    },
    gd: {
      phone: "+1473",
      isSepa: !1
    },
    gp: {
      phone: "+590",
      isSepa: !1
    },
    gu: {
      phone: "+1671",
      isSepa: !1
    },
    gt: {
      phone: "+502",
      isSepa: !1
    },
    gg: {
      phone: "+44",
      isSepa: !1
    },
    gn: {
      phone: "+224",
      isSepa: !1
    },
    gw: {
      phone: "+245",
      isSepa: !1
    },
    gy: {
      phone: "+592",
      isSepa: !1
    },
    ht: {
      phone: "+509",
      isSepa: !1
    },
    hm: {
      phone: "+0",
      isSepa: !1
    },
    hn: {
      phone: "+504",
      isSepa: !1
    },
    hk: {
      phone: "+852",
      isSepa: !1
    },
    hu: {
      phone: "+36",
      isSepa: !0
    },
    is: {
      phone: "+354",
      isSepa: !0
    },
    "in": {
      phone: "+91",
      isSepa: !1
    },
    id: {
      phone: "+62",
      isSepa: !1
    },
    ir: {
      phone: "+98",
      isSepa: !1
    },
    iq: {
      phone: "+964",
      isSepa: !1
    },
    ie: {
      phone: "+353",
      isSepa: !0
    },
    im: {
      phone: "+44",
      isSepa: !1
    },
    il: {
      phone: "+972",
      isSepa: !1
    },
    it: {
      phone: "+39",
      isSepa: !0
    },
    jm: {
      phone: "+1876",
      isSepa: !1
    },
    jp: {
      phone: "+81",
      isSepa: !1
    },
    je: {
      phone: "+44",
      isSepa: !1
    },
    jo: {
      phone: "+962",
      isSepa: !1
    },
    kz: {
      phone: "+7",
      isSepa: !1
    },
    ke: {
      phone: "+254",
      isSepa: !1
    },
    ki: {
      phone: "+686",
      isSepa: !1
    },
    kp: {
      phone: "+850",
      isSepa: !1
    },
    kr: {
      phone: "+82",
      isSepa: !1
    },
    xk: {
      phone: "+383",
      isSepa: !1
    },
    kw: {
      phone: "+965",
      isSepa: !1
    },
    kg: {
      phone: "+996",
      isSepa: !1
    },
    la: {
      phone: "+856",
      isSepa: !1
    },
    lv: {
      phone: "+371",
      isSepa: !0
    },
    lb: {
      phone: "+961",
      isSepa: !1
    },
    ls: {
      phone: "+266",
      isSepa: !1
    },
    lr: {
      phone: "+231",
      isSepa: !1
    },
    ly: {
      phone: "+218",
      isSepa: !1
    },
    li: {
      phone: "+423",
      isSepa: !0
    },
    lt: {
      phone: "+370",
      isSepa: !0
    },
    lu: {
      phone: "+352",
      isSepa: !0
    },
    mo: {
      phone: "+853",
      isSepa: !1
    },
    mk: {
      phone: "+389",
      isSepa: !1
    },
    mg: {
      phone: "+261",
      isSepa: !1
    },
    mw: {
      phone: "+265",
      isSepa: !1
    },
    my: {
      phone: "+60",
      isSepa: !1
    },
    mv: {
      phone: "+960",
      isSepa: !1
    },
    ml: {
      phone: "+223",
      isSepa: !1
    },
    mt: {
      phone: "+356",
      isSepa: !0
    },
    mh: {
      phone: "+692",
      isSepa: !1
    },
    mq: {
      phone: "+596",
      isSepa: !1
    },
    mr: {
      phone: "+222",
      isSepa: !1
    },
    mu: {
      phone: "+230",
      isSepa: !1
    },
    yt: {
      phone: "+262",
      isSepa: !1
    },
    mx: {
      phone: "+52",
      isSepa: !1
    },
    fm: {
      phone: "+691",
      isSepa: !1
    },
    md: {
      phone: "+373",
      isSepa: !1
    },
    mc: {
      phone: "+377",
      isSepa: !0
    },
    mn: {
      phone: "+976",
      isSepa: !1
    },
    me: {
      phone: "+382",
      isSepa: !1
    },
    ms: {
      phone: "+1664",
      isSepa: !1
    },
    ma: {
      phone: "+212",
      isSepa: !1
    },
    mz: {
      phone: "+258",
      isSepa: !1
    },
    mm: {
      phone: "+95",
      isSepa: !1
    },
    na: {
      phone: "+264",
      isSepa: !1
    },
    nr: {
      phone: "+674",
      isSepa: !1
    },
    np: {
      phone: "+977",
      isSepa: !1
    },
    nl: {
      phone: "+31",
      isSepa: !0
    },
    nc: {
      phone: "+687",
      isSepa: !1
    },
    nz: {
      phone: "+64",
      isSepa: !1
    },
    ni: {
      phone: "+505",
      isSepa: !1
    },
    ne: {
      phone: "+227",
      isSepa: !1
    },
    ng: {
      phone: "+234",
      isSepa: !1
    },
    nu: {
      phone: "+683",
      isSepa: !1
    },
    nf: {
      phone: "+672",
      isSepa: !1
    },
    mp: {
      phone: "+1670",
      isSepa: !1
    },
    no: {
      phone: "+47",
      isSepa: !0
    },
    om: {
      phone: "+968",
      isSepa: !1
    },
    pk: {
      phone: "+92",
      isSepa: !1
    },
    pw: {
      phone: "+680",
      isSepa: !1
    },
    ps: {
      phone: "+970",
      isSepa: !1
    },
    pa: {
      phone: "+507",
      isSepa: !1
    },
    pg: {
      phone: "+675",
      isSepa: !1
    },
    py: {
      phone: "+595",
      isSepa: !1
    },
    pe: {
      phone: "+51",
      isSepa: !1
    },
    ph: {
      phone: "+63",
      isSepa: !1
    },
    pn: {
      phone: "+64",
      isSepa: !1
    },
    pl: {
      phone: "+48",
      isSepa: !0
    },
    pt: {
      phone: "+351",
      isSepa: !0
    },
    pr: {
      phone: "+1939",
      isSepa: !1
    },
    qa: {
      phone: "+974",
      isSepa: !1
    },
    ro: {
      phone: "+40",
      isSepa: !0
    },
    ru: {
      phone: "+7",
      isSepa: !1
    },
    rw: {
      phone: "+250",
      isSepa: !1
    },
    re: {
      phone: "+262",
      isSepa: !1
    },
    bl: {
      phone: "+590",
      isSepa: !1
    },
    sh: {
      phone: "+290",
      isSepa: !1
    },
    kn: {
      phone: "+1869",
      isSepa: !1
    },
    lc: {
      phone: "+1758",
      isSepa: !1
    },
    mf: {
      phone: "+590",
      isSepa: !1
    },
    pm: {
      phone: "+508",
      isSepa: !1
    },
    vc: {
      phone: "+1784",
      isSepa: !1
    },
    ws: {
      phone: "+685",
      isSepa: !1
    },
    sm: {
      phone: "+378",
      isSepa: !0
    },
    st: {
      phone: "+239",
      isSepa: !1
    },
    sa: {
      phone: "+966",
      isSepa: !1
    },
    sn: {
      phone: "+221",
      isSepa: !1
    },
    rs: {
      phone: "+381",
      isSepa: !1
    },
    sc: {
      phone: "+248",
      isSepa: !1
    },
    sl: {
      phone: "+232",
      isSepa: !1
    },
    sg: {
      phone: "+65",
      isSepa: !1
    },
    sk: {
      phone: "+421",
      isSepa: !0
    },
    si: {
      phone: "+386",
      isSepa: !0
    },
    sb: {
      phone: "+677",
      isSepa: !1
    },
    so: {
      phone: "+252",
      isSepa: !1
    },
    za: {
      phone: "+27",
      isSepa: !1
    },
    ss: {
      phone: "+211",
      isSepa: !1
    },
    gs: {
      phone: "+500",
      isSepa: !1
    },
    es: {
      phone: "+34",
      isSepa: !0
    },
    lk: {
      phone: "+94",
      isSepa: !1
    },
    sd: {
      phone: "+249",
      isSepa: !1
    },
    sr: {
      phone: "+597",
      isSepa: !1
    },
    sj: {
      phone: "+47",
      isSepa: !1
    },
    sz: {
      phone: "+268",
      isSepa: !1
    },
    se: {
      phone: "+46",
      isSepa: !0
    },
    ch: {
      phone: "+41",
      isSepa: !0
    },
    sy: {
      phone: "+963",
      isSepa: !1
    },
    tw: {
      phone: "+886",
      isSepa: !1
    },
    tj: {
      phone: "+992",
      isSepa: !1
    },
    tz: {
      phone: "+255",
      isSepa: !1
    },
    th: {
      phone: "+66",
      isSepa: !1
    },
    tl: {
      phone: "+670",
      isSepa: !1
    },
    tg: {
      phone: "+228",
      isSepa: !1
    },
    tk: {
      phone: "+690",
      isSepa: !1
    },
    to: {
      phone: "+676",
      isSepa: !1
    },
    tt: {
      phone: "+1868",
      isSepa: !1
    },
    tn: {
      phone: "+216",
      isSepa: !1
    },
    tr: {
      phone: "+90",
      isSepa: !1
    },
    tm: {
      phone: "+993",
      isSepa: !1
    },
    tc: {
      phone: "+1649",
      isSepa: !1
    },
    tv: {
      phone: "+688",
      isSepa: !1
    },
    ug: {
      phone: "+256",
      isSepa: !1
    },
    ua: {
      phone: "+380",
      isSepa: !1
    },
    ae: {
      phone: "+971",
      isSepa: !1
    },
    gb: {
      phone: "+44",
      isSepa: !0
    },
    us: {
      phone: "+1",
      isSepa: !1
    },
    uy: {
      phone: "+598",
      isSepa: !1
    },
    uz: {
      phone: "+998",
      isSepa: !1
    },
    va: {
      phone: "+379",
      isSepa: !0
    },
    vu: {
      phone: "+678",
      isSepa: !1
    },
    ve: {
      phone: "+58",
      isSepa: !1
    },
    vn: {
      phone: "+84",
      isSepa: !1
    },
    vg: {
      phone: "+1284",
      isSepa: !1
    },
    vi: {
      phone: "+1340",
      isSepa: !1
    },
    wf: {
      phone: "+681",
      isSepa: !1
    },
    ye: {
      phone: "+967",
      isSepa: !1
    },
    zm: {
      phone: "+260",
      isSepa: !1
    },
    zw: {
      phone: "+263",
      isSepa: !1
    }
  },
  isoList = Object.keys(countries),
  countryList = {
    isoList: isoList,
    list: countries
  },
  currencies = {
    EUR: {
      value: "EUR",
      isDefault: !0,
      exceptions: [],
      moneyWire: !0,
      conversion: !0
    },
    AUD: {
      value: "AUD",
      isDefault: !1,
      exceptions: ["AU"],
      moneyWire: !0,
      conversions: !0
    },
    CAD: {
      value: "CAD",
      isDefault: !1,
      exceptions: ["CA"],
      moneyWire: !0,
      conversion: !0
    },
    CHF: {
      value: "CHF",
      isDefault: !1,
      exceptions: ["CH", "LI"],
      moneyWire: !0,
      conversion: !0
    },
    DKK: {
      value: "DKK",
      isDefault: !1,
      exceptions: ["DK"],
      moneyWire: !0,
      conversion: !0
    },
    GBP: {
      value: "GBP",
      isDefault: !1,
      exceptions: ["GB"],
      moneyWire: !0,
      conversion: !0
    },
    HUF: {
      value: "HUF",
      isDefault: !1,
      exceptions: [],
      moneyWire: !1,
      conversion: !0
    },
    JPY: {
      value: "JPY",
      isDefault: !1,
      exceptions: [],
      moneyWire: !1,
      conversion: !0
    },
    NOK: {
      value: "NOK",
      isDefault: !1,
      exceptions: ["NO"],
      moneyWire: !0,
      conversion: !0
    },
    NZD: {
      value: "NZD",
      isDefault: !1,
      exceptions: ["NZ"],
      moneyWire: !0,
      conversion: !0
    },
    SEK: {
      value: "SEK",
      isDefault: !1,
      exceptions: ["SE"],
      moneyWire: !0,
      conversion: !0
    },
    USD: {
      value: "USD",
      isDefault: !0,
      exceptions: [],
      moneyWire: !0,
      conversion: !0
    },
    ZAR: {
      value: "ZAR",
      isDefault: !1,
      exceptions: ["ZA", "NA"],
      moneyWire: !0,
      conversion: !0
    },
    TRY: {
      value: "TRY",
      isDefault: !1,
      exceptions: [],
      moneyWire: !1,
      conversion: !0
    }
  },
  currencies$1 = {
    list: currencies
  },
  fontList = {
    bold: '"OpenSans Bold",sans-serif',
    extraBold: '"OpenSans ExtraBold",sans-serif',
    light: '"OpenSans Light",sans-serif',
    regular: '"OpenSans",sans-serif',
    semiBold: '"OpenSans SemiBold",sans-serif',
    boldItalic: '"OpenSans BoldItalic",sans-serif',
    regularItalic: '"OpenSans Italic",sans-serif',
    semiBoldItalic: '"OpenSans SemiBoldItalic",sans-serif',
    avertaBold: '"Averta Bold",sans-serif',
    avertaExtraBold: '"Averta ExtraBold",sans-serif',
    avertaLight: '"Averta Light",sans-serif',
    avertaRegular: '"Averta",sans-serif',
    avertaSemiBold: '"Averta SemiBold",sans-serif',
    avertaBoldItalic: '"Averta BoldItalic",sans-serif',
    avertaRegularItalic: '"Averta Italic",sans-serif',
    avertaSemiBoldItalic: '"Averta SemiBoldItalic",sans-serif'
  },
  getFont$1 = function getFont(e, n) {
    return (e.fonts && e.fonts[n] ? e.fonts : fontList)[n];
  },
  fonts = {
    getFont: getFont$1
  },
  fontSizes = {
    mobile: {
      xs: "1.0rem",
      sm: "1.2rem",
      md: "1.4rem",
      df: "1.6rem",
      lg: "1.8rem",
      xl: "2.0rem",
      gt: "2.4rem",
      xg: "3.0rem"
    },
    mobileTitle: {
      xs: "1.8rem",
      sm: "2.3rem",
      md: "3.0rem",
      df: "3.3rem",
      lg: "4.0rem",
      xl: "4.8rem",
      gt: "5.2rem",
      xg: "5.6rem"
    },
    tablet: {
      xs: "1.0rem",
      sm: "1.2rem",
      md: "1.4rem",
      df: "1.6rem",
      lg: "1.8rem",
      xl: "2.0rem",
      gt: "2.4rem",
      xg: "3.0rem"
    },
    tabletTitle: {
      xs: "1.8rem",
      sm: "2.3rem",
      md: "3.0rem",
      df: "3.3rem",
      lg: "4.0rem",
      xl: "4.8rem",
      gt: "5.2rem",
      xg: "5.6rem"
    },
    desktop: {
      xs: "1.0rem",
      sm: "1.2rem",
      md: "1.4rem",
      df: "1.6rem",
      lg: "1.8rem",
      xl: "2.0rem",
      gt: "3.0rem",
      xg: "5.0rem"
    },
    desktopTitle: {
      xs: "2.0rem",
      sm: "2.6rem",
      md: "3.0rem",
      df: "3.6rem",
      lg: "4.2rem",
      xl: "5.0rem",
      gt: "6.0rem",
      xg: "7.0rem"
    }
  },
  spacings = {
    zero: "0",
    xs: "0.5rem",
    sm: "1rem",
    md: "2rem",
    lg: "3rem",
    xl: "4rem",
    gt: "5rem",
    xg: "6rem",
    auto: "auto"
  },
  config = {
    breakpoints: breakpoints,
    colors: colors$1$2,
    countries: countryList,
    currencies: currencies$1,
    fonts: fonts,
    fontSizes: fontSizes,
    spacings: spacings
  },
  commonjsGlobal$1 = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof commonjsGlobal$2 ? commonjsGlobal$2 : "undefined" != typeof self ? self : {};
function createCommonjsModule$1(e, n) {
  return e(n = {
    exports: {}
  }, n.exports), n.exports;
}
var iban = createCommonjsModule$1(function (e, n) {
    var r, t;
    r = commonjsGlobal$1, t = function t(e) {
      Array.prototype.map || (Array.prototype.map = function (e) {
        if (null == this) throw new TypeError();
        var n = Object(this),
          r = n.length >>> 0;
        if ("function" != typeof e) throw new TypeError();
        for (var t = new Array(r), a = 2 <= arguments.length ? arguments[1] : void 0, s = 0; s < r; s++) s in n && (t[s] = e.call(a, n[s], s, n));
        return t;
      });
      var r = "A".charCodeAt(0),
        t = "Z".charCodeAt(0);
      function a(e) {
        return (e = (e = e.toUpperCase()).substr(4) + e.substr(0, 4)).split("").map(function (e) {
          var n = e.charCodeAt(0);
          return r <= n && n <= t ? n - r + 10 : e;
        }).join("");
      }
      function s(e) {
        for (var n, r = e; 2 < r.length;) n = r.slice(0, 9), r = parseInt(n, 10) % 97 + r.slice(n.length);
        return parseInt(r, 10) % 97;
      }
      function i(e) {
        return e.replace(d, "").toUpperCase();
      }
      function n(e, n, r, t) {
        this.countryCode = e, this.length = n, this.structure = r, this.example = t;
      }
      n.prototype._regex = function () {
        return this._cachedRegex || (this._cachedRegex = (e = (e = this.structure).match(/(.{3})/g).map(function (e) {
          var n,
            r = e.slice(0, 1),
            e = parseInt(e.slice(1), 10);
          switch (r) {
            case "A":
              n = "0-9A-Za-z";
              break;
            case "B":
              n = "0-9A-Z";
              break;
            case "C":
              n = "A-Za-z";
              break;
            case "F":
              n = "0-9";
              break;
            case "L":
              n = "a-z";
              break;
            case "U":
              n = "A-Z";
              break;
            case "W":
              n = "0-9a-z";
          }
          return "([" + n + "]{" + e + "})";
        }), new RegExp("^" + e.join("") + "$")));
        var e;
      }, n.prototype.isValid = function (e) {
        return this.length == e.length && this.countryCode === e.slice(0, 2) && this._regex().test(e.slice(4)) && 1 == s(a(e));
      }, n.prototype.toBBAN = function (e, n) {
        return this._regex().exec(e.slice(4)).slice(1).join(n);
      }, n.prototype.fromBBAN = function (e) {
        var n;
        if (this.isValidBBAN(e)) return n = ("0" + (98 - s(a(this.countryCode + "00" + e)))).slice(-2), this.countryCode + n + e;
        throw new Error("Invalid BBAN");
      }, n.prototype.isValidBBAN = function (e) {
        return this.length - 4 == e.length && this._regex().test(e);
      };
      var o = {};
      function u(e) {
        o[e.countryCode] = e;
      }
      u(new n("AD", 24, "F04F04A12", "AD1200012030200359100100")), u(new n("AE", 23, "F03F16", "AE070331234567890123456")), u(new n("AL", 28, "F08A16", "AL47212110090000000235698741")), u(new n("AT", 20, "F05F11", "AT611904300234573201")), u(new n("AZ", 28, "U04A20", "AZ21NABZ00000000137010001944")), u(new n("BA", 20, "F03F03F08F02", "BA391290079401028494")), u(new n("BE", 16, "F03F07F02", "BE68539007547034")), u(new n("BG", 22, "U04F04F02A08", "BG80BNBG96611020345678")), u(new n("BH", 22, "U04A14", "BH67BMAG00001299123456")), u(new n("BR", 29, "F08F05F10U01A01", "BR9700360305000010009795493P1")), u(new n("BY", 28, "A04F04A16", "BY13NBRB3600900000002Z00AB00")), u(new n("CH", 21, "F05A12", "CH9300762011623852957")), u(new n("CR", 22, "F04F14", "CR72012300000171549015")), u(new n("CY", 28, "F03F05A16", "CY17002001280000001200527600")), u(new n("CZ", 24, "F04F06F10", "CZ6508000000192000145399")), u(new n("DE", 22, "F08F10", "DE89370400440532013000")), u(new n("DK", 18, "F04F09F01", "DK5000400440116243")), u(new n("DO", 28, "U04F20", "DO28BAGR00000001212453611324")), u(new n("EE", 20, "F02F02F11F01", "EE382200221020145685")), u(new n("EG", 29, "F04F04F17", "EG800002000156789012345180002")), u(new n("ES", 24, "F04F04F01F01F10", "ES9121000418450200051332")), u(new n("FI", 18, "F06F07F01", "FI2112345600000785")), u(new n("FO", 18, "F04F09F01", "FO6264600001631634")), u(new n("FR", 27, "F05F05A11F02", "FR1420041010050500013M02606")), u(new n("GB", 22, "U04F06F08", "GB29NWBK60161331926819")), u(new n("GE", 22, "U02F16", "GE29NB0000000101904917")), u(new n("GI", 23, "U04A15", "GI75NWBK000000007099453")), u(new n("GL", 18, "F04F09F01", "GL8964710001000206")), u(new n("GR", 27, "F03F04A16", "GR1601101250000000012300695")), u(new n("GT", 28, "A04A20", "GT82TRAJ01020000001210029690")), u(new n("HR", 21, "F07F10", "HR1210010051863000160")), u(new n("HU", 28, "F03F04F01F15F01", "HU42117730161111101800000000")), u(new n("IE", 22, "U04F06F08", "IE29AIBK93115212345678")), u(new n("IL", 23, "F03F03F13", "IL620108000000099999999")), u(new n("IS", 26, "F04F02F06F10", "IS140159260076545510730339")), u(new n("IT", 27, "U01F05F05A12", "IT60X0542811101000000123456")), u(new n("IQ", 23, "U04F03A12", "IQ98NBIQ850123456789012")), u(new n("JO", 30, "A04F22", "JO15AAAA1234567890123456789012")), u(new n("KW", 30, "U04A22", "KW81CBKU0000000000001234560101")), u(new n("KZ", 20, "F03A13", "KZ86125KZT5004100100")), u(new n("LB", 28, "F04A20", "LB62099900000001001901229114")), u(new n("LC", 32, "U04F24", "LC07HEMM000100010012001200013015")), u(new n("LI", 21, "F05A12", "LI21088100002324013AA")), u(new n("LT", 20, "F05F11", "LT121000011101001000")), u(new n("LU", 20, "F03A13", "LU280019400644750000")), u(new n("LV", 21, "U04A13", "LV80BANK0000435195001")), u(new n("MC", 27, "F05F05A11F02", "MC5811222000010123456789030")), u(new n("MD", 24, "U02A18", "MD24AG000225100013104168")), u(new n("ME", 22, "F03F13F02", "ME25505000012345678951")), u(new n("MK", 19, "F03A10F02", "MK07250120000058984")), u(new n("MR", 27, "F05F05F11F02", "MR1300020001010000123456753")), u(new n("MT", 31, "U04F05A18", "MT84MALT011000012345MTLCAST001S")), u(new n("MU", 30, "U04F02F02F12F03U03", "MU17BOMM0101101030300200000MUR")), u(new n("NL", 18, "U04F10", "NL91ABNA0417164300")), u(new n("NO", 15, "F04F06F01", "NO9386011117947")), u(new n("PK", 24, "U04A16", "PK36SCBL0000001123456702")), u(new n("PL", 28, "F08F16", "PL61109010140000071219812874")), u(new n("PS", 29, "U04A21", "PS92PALS000000000400123456702")), u(new n("PT", 25, "F04F04F11F02", "PT50000201231234567890154")), u(new n("QA", 29, "U04A21", "QA30AAAA123456789012345678901")), u(new n("RO", 24, "U04A16", "RO49AAAA1B31007593840000")), u(new n("RS", 22, "F03F13F02", "RS35260005601001611379")), u(new n("SA", 24, "F02A18", "SA0380000000608010167519")), u(new n("SC", 31, "U04F04F16U03", "SC18SSCB11010000000000001497USD")), u(new n("SE", 24, "F03F16F01", "SE4550000000058398257466")), u(new n("SI", 19, "F05F08F02", "SI56263300012039086")), u(new n("SK", 24, "F04F06F10", "SK3112000000198742637541")), u(new n("SM", 27, "U01F05F05A12", "SM86U0322509800000000270100")), u(new n("ST", 25, "F08F11F02", "ST68000100010051845310112")), u(new n("SV", 28, "U04F20", "SV62CENR00000000000000700025")), u(new n("TL", 23, "F03F14F02", "TL380080012345678910157")), u(new n("TN", 24, "F02F03F13F02", "TN5910006035183598478831")), u(new n("TR", 26, "F05F01A16", "TR330006100519786457841326")), u(new n("UA", 29, "F25", "UA511234567890123456789012345")), u(new n("VA", 22, "F18", "VA59001123000012345678")), u(new n("VG", 24, "U04F16", "VG96VPVG0000012345678901")), u(new n("XK", 20, "F04F10F02", "XK051212012345678906")), u(new n("AO", 25, "F21", "AO69123456789012345678901")), u(new n("BF", 27, "F23", "BF2312345678901234567890123")), u(new n("BI", 16, "F12", "BI41123456789012")), u(new n("BJ", 28, "F24", "BJ39123456789012345678901234")), u(new n("CI", 28, "U02F22", "CI70CI1234567890123456789012")), u(new n("CM", 27, "F23", "CM9012345678901234567890123")), u(new n("CV", 25, "F21", "CV30123456789012345678901")), u(new n("DZ", 24, "F20", "DZ8612345678901234567890")), u(new n("IR", 26, "F22", "IR861234568790123456789012")), u(new n("MG", 27, "F23", "MG1812345678901234567890123")), u(new n("ML", 28, "U01F23", "ML15A12345678901234567890123")), u(new n("MZ", 25, "F21", "MZ25123456789012345678901")), u(new n("SN", 28, "U01F23", "SN52A12345678901234567890123")), u(new n("GF", 27, "F05F05A11F02", "GF121234512345123456789AB13")), u(new n("GP", 27, "F05F05A11F02", "GP791234512345123456789AB13")), u(new n("MQ", 27, "F05F05A11F02", "MQ221234512345123456789AB13")), u(new n("RE", 27, "F05F05A11F02", "RE131234512345123456789AB13")), u(new n("PF", 27, "F05F05A11F02", "PF281234512345123456789AB13")), u(new n("TF", 27, "F05F05A11F02", "TF891234512345123456789AB13")), u(new n("YT", 27, "F05F05A11F02", "YT021234512345123456789AB13")), u(new n("NC", 27, "F05F05A11F02", "NC551234512345123456789AB13")), u(new n("BL", 27, "F05F05A11F02", "BL391234512345123456789AB13")), u(new n("MF", 27, "F05F05A11F02", "MF551234512345123456789AB13")), u(new n("PM", 27, "F05F05A11F02", "PM071234512345123456789AB13")), u(new n("WF", 27, "F05F05A11F02", "WF621234512345123456789AB13"));
      var d = /[^a-zA-Z0-9]/g,
        f = /(.{4})(?!$)/g;
      function _(e) {
        return "string" == typeof e || e instanceof String;
      }
      e.isValid = function (e) {
        if (!_(e)) return !1;
        e = i(e);
        var n = o[e.slice(0, 2)];
        return !!n && n.isValid(e);
      }, e.toBBAN = function (e, n) {
        void 0 === n && (n = " "), e = i(e);
        var r = o[e.slice(0, 2)];
        if (r) return r.toBBAN(e, n);
        throw new Error("No country with code " + e.slice(0, 2));
      }, e.fromBBAN = function (e, n) {
        var r = o[e];
        if (r) return r.fromBBAN(i(n));
        throw new Error("No country with code " + e);
      }, e.isValidBBAN = function (e, n) {
        return !!_(n) && (e = o[e]) && e.isValidBBAN(i(n));
      }, e.printFormat = function (e, n) {
        return void 0 === n && (n = " "), i(e).replace(f, "$1" + n);
      }, e.electronicFormat = i, e.countries = o;
    }, "string" != typeof n.nodeName ? t(n) : t(r.IBAN = {});
  }),
  format = function format(e) {
    return iban.printFormat(e, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : " ");
  },
  mod97 = function mod97(e) {
    return e - 97 * Math.floor(e / 97);
  };
function twoDigits(e) {
  return e < 10 ? "0" + e : "" + e;
}
var KT_ACCOUNT_PREFIX = {
    BEL: 651,
    LUX: 359
  },
  SITE_BRANCH = {
    BEL: "BEL",
    LUX: "LUX"
  },
  IBAN_PREFIX = {
    BEL: "BE",
    LUX: "LU"
  },
  ACCOUNTID_LENGTH = 7,
  getBBANfromAccountId = function getBBANfromAccountId(e) {
    var n,
      r = (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}).country,
      r = void 0 === r ? SITE_BRANCH.BEL : r;
    return r in SITE_BRANCH && r in KT_ACCOUNT_PREFIX ? r === SITE_BRANCH.LUX ? (n = 0 === (n = mod97(parseInt(e))) ? "97" : twoDigits(n), (1e3 * (359e10 + parseInt("" + e + n))).toString()) : (n = "" + KT_ACCOUNT_PREFIX[r] + e) + (r = 0 === (r = mod97(parseInt(n, 10))) ? "97" : twoDigits(r)) : e.toString();
  },
  getIBANfromAccountId = function getIBANfromAccountId(e) {
    var n,
      r = (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}).country,
      r = void 0 === r ? SITE_BRANCH.BEL : r;
    return r in SITE_BRANCH ? (n = getBBANfromAccountId(e, {
      country: r
    }), r === SITE_BRANCH.LUX ? iban.fromBBAN(IBAN_PREFIX.LUX, n) : iban.fromBBAN(IBAN_PREFIX.BEL, n)) : e.toString();
  },
  getAccountIdFromIBAN = function getAccountIdFromIBAN(e) {
    return +e.replace(/[\W_]+/g, "").slice(7, 7 + ACCOUNTID_LENGTH);
  },
  iban$1 = {
    format: format,
    getBBANfromAccountId: getBBANfromAccountId,
    getIBANfromAccountId: getIBANfromAccountId,
    getAccountIdFromIBAN: getAccountIdFromIBAN
  },
  CARD_VISA = "5071",
  CARD_VISA_GOLD = "5072",
  BENEFICIARY = "beneficiaries";
function maskIBAN(e, n) {
  return [CARD_VISA, CARD_VISA_GOLD].includes(n) ? e.substr(0, 7) + "** ****" + e.substr(14) : e;
}
var removeSpecialChars = function removeSpecialChars(e) {
    return e ? e.replace(/[^a-zA-Z0-9- ]/g, "") : "";
  },
  getCustomerFriendlyAccountNumber = function getCustomerFriendlyAccountNumber(e) {
    var n = 1 < arguments.length && void 0 !== arguments[1] && arguments[1],
      r = e.isTrading,
      t = e.isInvestment,
      a = e.isTreeTop,
      s = e.accountID,
      i = e.contractNumber,
      o = e.IBAN,
      u = e.type,
      d = e.accountNum;
    return i ? e.contractNumber : (i = r || t || a ? s : removeSpecialChars(u === BENEFICIARY ? d : o), maskIBAN(n ? format(i.toString()) : i.toString(), e.accountType));
  },
  _typeof = "function" == typeof Symbol && "symbol" == _typeof$1(Symbol.iterator) ? function (e) {
    return _typeof$1(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof$1(e);
  },
  slicedToArray = function slicedToArray(e, n) {
    if (Array.isArray(e)) return e;
    if (Symbol.iterator in Object(e)) {
      var r = n,
        t = [],
        a = !0,
        n = !1,
        s = void 0;
      try {
        for (var i, o = e[Symbol.iterator](); !(a = (i = o.next()).done) && (t.push(i.value), !r || t.length !== r); a = !0);
      } catch (e) {
        n = !0, s = e;
      } finally {
        try {
          !a && o["return"] && o["return"]();
        } finally {
          if (n) throw s;
        }
      }
      return t;
    }
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  },
  toArray = function toArray(e) {
    return Array.isArray(e) ? e : Array.from(e);
  },
  MASK = "*",
  REGEX_ALLOWED_CHARS = /[^0-9A-Z]/g,
  creditCardNumber = function creditCardNumber(e, n, r) {
    var t = {
        startMaskPos: 6,
        endMaskPos: 12
      },
      r = (null !== r && "object" === (void 0 === r ? "undefined" : _typeof(r)) && (t = Object.assign(t, r)), String(e).replace(REGEX_ALLOWED_CHARS, ""));
    return r ? (r = n ? r : "" + r.substring(0, t.startMaskPos) + MASK.repeat(t.endMaskPos - t.startMaskPos) + r.substring(t.endMaskPos)).replace(/(?!^)(?=(?:[A-Z0-9*]{4})+(?:\.|$))/gm, " ") : "";
  },
  dateTime = {
    convertLocalToUniversalTimeStamp: function convertLocalToUniversalTimeStamp(e) {
      return null === e ? e : ((e = new Date(1e3 * e)).getTime() + 6e4 * e.getTimezoneOffset()) / 1e3;
    }
  },
  SEPARATOR_THOUSANDS = " ",
  SEPARATOR_DECIMALS = ",",
  REGEX_NUMBERS = /[^0-9 .,-]/g,
  REGEX_THOUSANDS = /\B(?=(\d{3})+(?!\d))/g;
function number(e) {
  var n,
    r,
    t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 2,
    a = arguments[2],
    s = {
      forceCommas: !1,
      forceFloat: !0,
      zeroValue: 0,
      limitDecimals: !0,
      thousandsSeparator: SEPARATOR_THOUSANDS,
      decimalSeparator: SEPARATOR_DECIMALS,
      allowPrecision: !1
    },
    a = (null !== a && "object" === (void 0 === a ? "undefined" : _typeof(a)) && (s = Object.assign(s, a)), String(e).replace(REGEX_NUMBERS, "")),
    i = a.includes(",") || a.includes("."),
    o = 1 / Math.pow(10, t || 1);
  return String(e).match(REGEX_NUMBERS) || (e = String(a).replace(s.decimalSeparator, ".").replace(/\s/g, ""), n = Math.pow(10, t), r = void 0, r = s.forceFloat && s.limitDecimals ? (Math.round(e + "e+" + t) / n).toFixed(t) : s.limitDecimals && !s.allowPrecision ? (Math.round(e + "e+" + t) / n).toString() : e, !a && 0 !== a) || isNaN(parseFloat(r)) ? "" : 0 !== s.zeroValue && parseFloat(a) < o ? s.zeroValue : (n = r.split(/[.,]/), a = (e = slicedToArray(n, 2))[0], r = void 0 === (o = e[1]) ? "" : o, 4 < (a = a.replace(/\s/gi, "")).replace("-", "").length && (a = a.replace(REGEX_THOUSANDS, s.thousandsSeparator)), s.limitDecimals && (r = r ? r.substr(0, t) : ""), s.forceCommas ? [a, r].join(s.decimalSeparator) : s.allowPrecision ? i ? [a, r].join(s.decimalSeparator) : a : r.length ? [a, r].join(s.decimalSeparator) : a);
}
function convertAmountFromCentsToEuros(e) {
  return e / 100;
}
var money = function money(e) {
    var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "EUR";
    return number(e, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 2, arguments[3]) + " " + n;
  },
  DEFAULT_INT_PREFIX = "00";
function formatBelgianMobileNumber(e) {
  var n;
  return !!(e && 10 < e.length) && "+" + (n = (n = e).substr(0, 2) === DEFAULT_INT_PREFIX ? e.substr(2) : n).substr(0, 2) + " " + n.substr(2, 3) + " " + n.substr(5, 2) + " " + n.substr(7, 2) + " " + n.substr(9, 2);
}
var phone = {
    formatBelgianMobileNumber: formatBelgianMobileNumber
  },
  formatTradingPrice = function formatTradingPrice(e) {
    var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 2,
      r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0,
      t = !(3 < arguments.length && void 0 !== arguments[3]) || arguments[3];
    if (null === n && (n = 2), !e) {
      if (isNaN(r)) return r;
      e = r;
    }
    return number(e, n, t ? {} : {
      thousandsSeparator: "",
      decimalSeparator: "."
    });
  },
  price = {
    formatTradingPrice: formatTradingPrice
  },
  SPACES_REGEX = /\s*/g,
  DECIMAL_SEPARATOR_REGEX = /[,.]/g,
  stringToNumber = function stringToNumber(e) {
    return parseFloat(("" + e).replace(SPACES_REGEX, "").replace(DECIMAL_SEPARATOR_REGEX, "."));
  },
  structuredMessage = function structuredMessage(e) {
    var n, r;
    return e ? (r = (e = e.replace(/[^0-9]/g, "")).slice(0, 3), n = e.slice(3, 7), e = e.slice(7, 12), "" + r + (r = function r(e) {
      return e ? "/" : "";
    })(n) + n + r(e) + e) : "";
  };
function isDate(e) {
  return e instanceof Date;
}
var is_date = isDate,
  MILLISECONDS_IN_HOUR = 36e5,
  MILLISECONDS_IN_MINUTE = 6e4,
  DEFAULT_ADDITIONAL_DIGITS = 2,
  parseTokenDateTimeDelimeter = /[T ]/,
  parseTokenPlainTime = /:/,
  parseTokenYY = /^(\d{2})$/,
  parseTokensYYY = [/^([+-]\d{2})$/, /^([+-]\d{3})$/, /^([+-]\d{4})$/],
  parseTokenYYYY = /^(\d{4})/,
  parseTokensYYYYY = [/^([+-]\d{4})/, /^([+-]\d{5})/, /^([+-]\d{6})/],
  parseTokenMM = /^-(\d{2})$/,
  parseTokenDDD = /^-?(\d{3})$/,
  parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/,
  parseTokenWww = /^-?W(\d{2})$/,
  parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/,
  parseTokenHH = /^(\d{2}([.,]\d*)?)$/,
  parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  parseTokenTimezone = /([Z+-].*)$/,
  parseTokenTimezoneZ = /^(Z)$/,
  parseTokenTimezoneHH = /^([+-])(\d{2})$/,
  parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/;
function parse(e, n) {
  var r, t, a;
  return is_date(e) ? new Date(e.getTime()) : "string" == typeof e && (n = null == (n = (n || {}).additionalDigits) ? DEFAULT_ADDITIONAL_DIGITS : Number(n), t = (n = parseYear((r = splitDateString(e)).date, n)).year, n = parseDate(n.restDateString, t)) ? (t = n.getTime(), n = 0, r.time && (n = parseTime(r.time)), a = r.timezone ? parseTimezone(r.timezone) : (a = new Date(t + n).getTimezoneOffset(), new Date(t + n + a * MILLISECONDS_IN_MINUTE).getTimezoneOffset()), new Date(t + n + a * MILLISECONDS_IN_MINUTE)) : new Date(e);
}
function splitDateString(e) {
  var n,
    r = {},
    e = e.split(parseTokenDateTimeDelimeter),
    e = parseTokenPlainTime.test(e[0]) ? (r.date = null, e[0]) : (r.date = e[0], e[1]);
  return e && ((n = parseTokenTimezone.exec(e)) ? (r.time = e.replace(n[1], ""), r.timezone = n[1]) : r.time = e), r;
}
function parseYear(e, n) {
  var r,
    t = parseTokensYYY[n],
    n = parseTokensYYYYY[n],
    n = parseTokenYYYY.exec(e) || n.exec(e);
  return n ? (r = n[1], {
    year: parseInt(r, 10),
    restDateString: e.slice(r.length)
  }) : (n = parseTokenYY.exec(e) || t.exec(e)) ? (r = n[1], {
    year: 100 * parseInt(r, 10),
    restDateString: e.slice(r.length)
  }) : {
    year: null
  };
}
function parseDate(e, n) {
  var r, t, a, s;
  return null === n ? null : 0 === e.length ? ((t = new Date(0)).setUTCFullYear(n), t) : (r = parseTokenMM.exec(e)) ? (t = new Date(0), a = parseInt(r[1], 10) - 1, t.setUTCFullYear(n, a), t) : (r = parseTokenDDD.exec(e)) ? (t = new Date(0), s = parseInt(r[1], 10), t.setUTCFullYear(n, 0, s), t) : (r = parseTokenMMDD.exec(e)) ? (t = new Date(0), a = parseInt(r[1], 10) - 1, s = parseInt(r[2], 10), t.setUTCFullYear(n, a, s), t) : (r = parseTokenWww.exec(e)) ? dayOfISOYear(n, parseInt(r[1], 10) - 1) : (r = parseTokenWwwD.exec(e)) ? dayOfISOYear(n, parseInt(r[1], 10) - 1, parseInt(r[2], 10) - 1) : null;
}
function parseTime(e) {
  var n,
    r,
    t = parseTokenHH.exec(e);
  return t ? (n = parseFloat(t[1].replace(",", "."))) % 24 * MILLISECONDS_IN_HOUR : (t = parseTokenHHMM.exec(e)) ? (n = parseInt(t[1], 10), r = parseFloat(t[2].replace(",", ".")), n % 24 * MILLISECONDS_IN_HOUR + r * MILLISECONDS_IN_MINUTE) : (t = parseTokenHHMMSS.exec(e)) ? (n = parseInt(t[1], 10), r = parseInt(t[2], 10), e = parseFloat(t[3].replace(",", ".")), n % 24 * MILLISECONDS_IN_HOUR + r * MILLISECONDS_IN_MINUTE + 1e3 * e) : null;
}
function parseTimezone(e) {
  var n,
    r = parseTokenTimezoneZ.exec(e);
  return r ? 0 : (r = parseTokenTimezoneHH.exec(e)) ? (n = 60 * parseInt(r[2], 10), "+" === r[1] ? -n : n) : (r = parseTokenTimezoneHHMM.exec(e)) ? (n = 60 * parseInt(r[2], 10) + parseInt(r[3], 10), "+" === r[1] ? -n : n) : 0;
}
function dayOfISOYear(e, n, r) {
  n = n || 0, r = r || 0;
  var t = new Date(0);
  t.setUTCFullYear(e, 0, 4);
  e = 7 * n + r + 1 - (t.getUTCDay() || 7);
  return t.setUTCDate(t.getUTCDate() + e), t;
}
var parse_1 = parse;
function addDays(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setDate(e.getDate() + n), e;
}
var add_days = addDays;
function addMilliseconds(e, n) {
  e = parse_1(e).getTime(), n = Number(n);
  return new Date(e + n);
}
var add_milliseconds = addMilliseconds,
  MILLISECONDS_IN_HOUR$1 = 36e5;
function addHours(e, n) {
  n = Number(n);
  return add_milliseconds(e, n * MILLISECONDS_IN_HOUR$1);
}
var add_hours = addHours;
function startOfWeek(e, n) {
  var n = n && Number(n.weekStartsOn) || 0,
    e = parse_1(e),
    r = e.getDay(),
    r = (r < n ? 7 : 0) + r - n;
  return e.setDate(e.getDate() - r), e.setHours(0, 0, 0, 0), e;
}
var start_of_week = startOfWeek;
function startOfISOWeek(e) {
  return start_of_week(e, {
    weekStartsOn: 1
  });
}
var start_of_iso_week = startOfISOWeek;
function getISOYear(e) {
  var e = parse_1(e),
    n = e.getFullYear(),
    r = new Date(0),
    r = (r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0), start_of_iso_week(r)),
    t = new Date(0),
    t = (t.setFullYear(n, 0, 4), t.setHours(0, 0, 0, 0), start_of_iso_week(t));
  return e.getTime() >= r.getTime() ? n + 1 : e.getTime() >= t.getTime() ? n : n - 1;
}
var get_iso_year = getISOYear;
function startOfISOYear(e) {
  var e = get_iso_year(e),
    n = new Date(0);
  return n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0), start_of_iso_week(n);
}
var start_of_iso_year = startOfISOYear;
function startOfDay(e) {
  e = parse_1(e);
  return e.setHours(0, 0, 0, 0), e;
}
var start_of_day = startOfDay,
  MILLISECONDS_IN_MINUTE$1 = 6e4,
  MILLISECONDS_IN_DAY = 864e5;
function differenceInCalendarDays(e, n) {
  e = start_of_day(e), n = start_of_day(n), e = e.getTime() - e.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$1, n = n.getTime() - n.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$1;
  return Math.round((e - n) / MILLISECONDS_IN_DAY);
}
var difference_in_calendar_days = differenceInCalendarDays;
function setISOYear(e, n) {
  var e = parse_1(e),
    n = Number(n),
    r = difference_in_calendar_days(e, start_of_iso_year(e)),
    t = new Date(0);
  return t.setFullYear(n, 0, 4), t.setHours(0, 0, 0, 0), (e = start_of_iso_year(t)).setDate(e.getDate() + r), e;
}
var set_iso_year = setISOYear;
function addISOYears(e, n) {
  n = Number(n);
  return set_iso_year(e, get_iso_year(e) + n);
}
var add_iso_years = addISOYears,
  MILLISECONDS_IN_MINUTE$2 = 6e4;
function addMinutes(e, n) {
  n = Number(n);
  return add_milliseconds(e, n * MILLISECONDS_IN_MINUTE$2);
}
var add_minutes = addMinutes;
function getDaysInMonth(e) {
  var e = parse_1(e),
    n = e.getFullYear(),
    e = e.getMonth(),
    r = new Date(0);
  return r.setFullYear(n, e + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
var get_days_in_month = getDaysInMonth;
function addMonths(e, n) {
  var e = parse_1(e),
    n = Number(n),
    n = e.getMonth() + n,
    r = new Date(0),
    r = (r.setFullYear(e.getFullYear(), n, 1), r.setHours(0, 0, 0, 0), get_days_in_month(r));
  return e.setMonth(n, Math.min(r, e.getDate())), e;
}
var add_months = addMonths;
function addQuarters(e, n) {
  n = Number(n);
  return add_months(e, 3 * n);
}
var add_quarters = addQuarters;
function addSeconds(e, n) {
  n = Number(n);
  return add_milliseconds(e, 1e3 * n);
}
var add_seconds = addSeconds;
function addWeeks(e, n) {
  n = Number(n);
  return add_days(e, 7 * n);
}
var add_weeks = addWeeks;
function addYears(e, n) {
  n = Number(n);
  return add_months(e, 12 * n);
}
var add_years = addYears;
function areRangesOverlapping(e, n, r, t) {
  e = parse_1(e).getTime(), n = parse_1(n).getTime(), r = parse_1(r).getTime(), t = parse_1(t).getTime();
  if (n < e || t < r) throw new Error("The start of the range cannot be after the end of the range");
  return e < t && r < n;
}
var are_ranges_overlapping = areRangesOverlapping;
function closestIndexTo(e, n) {
  var r, t, a;
  if (n instanceof Array) return r = parse_1(e).getTime(), n.forEach(function (e, n) {
    e = parse_1(e), e = Math.abs(r - e.getTime());
    (void 0 === t || e < a) && (t = n, a = e);
  }), t;
  throw new TypeError(toString.call(n) + " is not an instance of Array");
}
var closest_index_to = closestIndexTo;
function closestTo(e, n) {
  var r, t, a;
  if (n instanceof Array) return r = parse_1(e).getTime(), n.forEach(function (e) {
    var e = parse_1(e),
      n = Math.abs(r - e.getTime());
    (void 0 === t || n < a) && (t = e, a = n);
  }), t;
  throw new TypeError(toString.call(n) + " is not an instance of Array");
}
var closest_to = closestTo;
function compareAsc(e, n) {
  e = parse_1(e).getTime(), n = parse_1(n).getTime();
  return e < n ? -1 : n < e ? 1 : 0;
}
var compare_asc = compareAsc;
function compareDesc(e, n) {
  e = parse_1(e).getTime(), n = parse_1(n).getTime();
  return n < e ? -1 : e < n ? 1 : 0;
}
var compare_desc = compareDesc,
  MILLISECONDS_IN_MINUTE$3 = 6e4,
  MILLISECONDS_IN_WEEK = 6048e5;
function differenceInCalendarISOWeeks(e, n) {
  e = start_of_iso_week(e), n = start_of_iso_week(n), e = e.getTime() - e.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$3, n = n.getTime() - n.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$3;
  return Math.round((e - n) / MILLISECONDS_IN_WEEK);
}
var difference_in_calendar_iso_weeks = differenceInCalendarISOWeeks;
function differenceInCalendarISOYears(e, n) {
  return get_iso_year(e) - get_iso_year(n);
}
var difference_in_calendar_iso_years = differenceInCalendarISOYears;
function differenceInCalendarMonths(e, n) {
  e = parse_1(e), n = parse_1(n);
  return 12 * (e.getFullYear() - n.getFullYear()) + (e.getMonth() - n.getMonth());
}
var difference_in_calendar_months = differenceInCalendarMonths;
function getQuarter(e) {
  e = parse_1(e);
  return Math.floor(e.getMonth() / 3) + 1;
}
var get_quarter = getQuarter;
function differenceInCalendarQuarters(e, n) {
  e = parse_1(e), n = parse_1(n);
  return 4 * (e.getFullYear() - n.getFullYear()) + (get_quarter(e) - get_quarter(n));
}
var difference_in_calendar_quarters = differenceInCalendarQuarters,
  MILLISECONDS_IN_MINUTE$4 = 6e4,
  MILLISECONDS_IN_WEEK$1 = 6048e5;
function differenceInCalendarWeeks(e, n, r) {
  e = start_of_week(e, r), n = start_of_week(n, r), r = e.getTime() - e.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$4, e = n.getTime() - n.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$4;
  return Math.round((r - e) / MILLISECONDS_IN_WEEK$1);
}
var difference_in_calendar_weeks = differenceInCalendarWeeks;
function differenceInCalendarYears(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getFullYear() - n.getFullYear();
}
var difference_in_calendar_years = differenceInCalendarYears;
function differenceInDays(e, n) {
  var e = parse_1(e),
    n = parse_1(n),
    r = compare_asc(e, n),
    t = Math.abs(difference_in_calendar_days(e, n));
  return e.setDate(e.getDate() - r * t), r * (t - (compare_asc(e, n) === -r));
}
var difference_in_days = differenceInDays;
function differenceInMilliseconds(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getTime() - n.getTime();
}
var difference_in_milliseconds = differenceInMilliseconds,
  MILLISECONDS_IN_HOUR$2 = 36e5;
function differenceInHours(e, n) {
  e = difference_in_milliseconds(e, n) / MILLISECONDS_IN_HOUR$2;
  return 0 < e ? Math.floor(e) : Math.ceil(e);
}
var difference_in_hours = differenceInHours;
function subISOYears(e, n) {
  n = Number(n);
  return add_iso_years(e, -n);
}
var sub_iso_years = subISOYears;
function differenceInISOYears(e, n) {
  var e = parse_1(e),
    n = parse_1(n),
    r = compare_asc(e, n),
    t = Math.abs(difference_in_calendar_iso_years(e, n)),
    e = sub_iso_years(e, r * t);
  return r * (t - (compare_asc(e, n) === -r));
}
var difference_in_iso_years = differenceInISOYears,
  MILLISECONDS_IN_MINUTE$5 = 6e4;
function differenceInMinutes(e, n) {
  e = difference_in_milliseconds(e, n) / MILLISECONDS_IN_MINUTE$5;
  return 0 < e ? Math.floor(e) : Math.ceil(e);
}
var difference_in_minutes = differenceInMinutes;
function differenceInMonths(e, n) {
  var e = parse_1(e),
    n = parse_1(n),
    r = compare_asc(e, n),
    t = Math.abs(difference_in_calendar_months(e, n));
  return e.setMonth(e.getMonth() - r * t), r * (t - (compare_asc(e, n) === -r));
}
var difference_in_months = differenceInMonths;
function differenceInQuarters(e, n) {
  e = difference_in_months(e, n) / 3;
  return 0 < e ? Math.floor(e) : Math.ceil(e);
}
var difference_in_quarters = differenceInQuarters;
function differenceInSeconds(e, n) {
  e = difference_in_milliseconds(e, n) / 1e3;
  return 0 < e ? Math.floor(e) : Math.ceil(e);
}
var difference_in_seconds = differenceInSeconds;
function differenceInWeeks(e, n) {
  e = difference_in_days(e, n) / 7;
  return 0 < e ? Math.floor(e) : Math.ceil(e);
}
var difference_in_weeks = differenceInWeeks;
function differenceInYears(e, n) {
  var e = parse_1(e),
    n = parse_1(n),
    r = compare_asc(e, n),
    t = Math.abs(difference_in_calendar_years(e, n));
  return e.setFullYear(e.getFullYear() - r * t), r * (t - (compare_asc(e, n) === -r));
}
var difference_in_years = differenceInYears;
function buildDistanceInWordsLocale() {
  var t = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  };
  return {
    localize: function localize(e, n, r) {
      return r = r || {}, e = "string" == typeof t[e] ? t[e] : 1 === n ? t[e].one : t[e].other.replace("{{count}}", n), r.addSuffix ? 0 < r.comparison ? "in " + e : e + " ago" : e;
    }
  };
}
var commonFormatterKeys = ["M", "MM", "Q", "D", "DD", "DDD", "DDDD", "d", "E", "W", "WW", "YY", "YYYY", "GG", "GGGG", "H", "HH", "h", "hh", "m", "mm", "s", "ss", "S", "SS", "SSS", "Z", "ZZ", "X", "x"];
function buildFormattingTokensRegExp(e) {
  var n,
    r = [];
  for (n in e) e.hasOwnProperty(n) && r.push(n);
  var t = commonFormatterKeys.concat(r).sort().reverse();
  return new RegExp("(\\[[^\\[]*\\])|(\\\\)?(" + t.join("|") + "|.)", "g");
}
var build_formatting_tokens_reg_exp = buildFormattingTokensRegExp;
function buildFormatLocale() {
  var n = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    r = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    t = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    a = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    s = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    i = ["AM", "PM"],
    o = ["am", "pm"],
    u = ["a.m.", "p.m."],
    e = {
      MMM: function MMM(e) {
        return n[e.getMonth()];
      },
      MMMM: function MMMM(e) {
        return r[e.getMonth()];
      },
      dd: function dd(e) {
        return t[e.getDay()];
      },
      ddd: function ddd(e) {
        return a[e.getDay()];
      },
      dddd: function dddd(e) {
        return s[e.getDay()];
      },
      A: function A(e) {
        return 1 <= e.getHours() / 12 ? i[1] : i[0];
      },
      a: function a(e) {
        return 1 <= e.getHours() / 12 ? o[1] : o[0];
      },
      aa: function aa(e) {
        return 1 <= e.getHours() / 12 ? u[1] : u[0];
      }
    };
  return ["M", "D", "DDD", "d", "Q", "W"].forEach(function (r) {
    e[r + "o"] = function (e, n) {
      return ordinal(n[r](e));
    };
  }), {
    formatters: e,
    formattingTokensRegExp: build_formatting_tokens_reg_exp(e)
  };
}
function ordinal(e) {
  var n = e % 100;
  if (20 < n || n < 10) switch (n % 10) {
    case 1:
      return e + "st";
    case 2:
      return e + "nd";
    case 3:
      return e + "rd";
  }
  return e + "th";
}
var build_format_locale = buildFormatLocale,
  en = {
    distanceInWords: buildDistanceInWordsLocale(),
    format: build_format_locale()
  },
  MINUTES_IN_DAY = 1440,
  MINUTES_IN_ALMOST_TWO_DAYS = 2520,
  MINUTES_IN_MONTH = 43200,
  MINUTES_IN_TWO_MONTHS = 86400;
function distanceInWords(e, n, r) {
  var t,
    a,
    r = r || {},
    s = compare_desc(e, n),
    i = r.locale,
    o = en.distanceInWords.localize,
    i = (i && i.distanceInWords && i.distanceInWords.localize && (o = i.distanceInWords.localize), {
      addSuffix: Boolean(r.addSuffix),
      comparison: s
    }),
    s = 0 < s ? (t = parse_1(e), parse_1(n)) : (t = parse_1(n), parse_1(e)),
    n = difference_in_seconds(s, t),
    e = s.getTimezoneOffset() - t.getTimezoneOffset(),
    e = Math.round(n / 60) - e;
  return e < 2 ? r.includeSeconds ? n < 5 ? o("lessThanXSeconds", 5, i) : n < 10 ? o("lessThanXSeconds", 10, i) : n < 20 ? o("lessThanXSeconds", 20, i) : n < 40 ? o("halfAMinute", null, i) : o(n < 60 ? "lessThanXMinutes" : "xMinutes", 1, i) : 0 == e ? o("lessThanXMinutes", 1, i) : o("xMinutes", e, i) : e < 45 ? o("xMinutes", e, i) : e < 90 ? o("aboutXHours", 1, i) : e < MINUTES_IN_DAY ? o("aboutXHours", Math.round(e / 60), i) : e < MINUTES_IN_ALMOST_TWO_DAYS ? o("xDays", 1, i) : e < MINUTES_IN_MONTH ? o("xDays", Math.round(e / MINUTES_IN_DAY), i) : e < MINUTES_IN_TWO_MONTHS ? o("aboutXMonths", a = Math.round(e / MINUTES_IN_MONTH), i) : (a = difference_in_months(s, t)) < 12 ? o("xMonths", Math.round(e / MINUTES_IN_MONTH), i) : (r = a % 12, n = Math.floor(a / 12), r < 3 ? o("aboutXYears", n, i) : r < 9 ? o("overXYears", n, i) : o("almostXYears", n + 1, i));
}
var distance_in_words = distanceInWords,
  MINUTES_IN_DAY$1 = 1440,
  MINUTES_IN_MONTH$1 = 43200,
  MINUTES_IN_YEAR = 525600;
function distanceInWordsStrict(e, n, r) {
  var r = r || {},
    t = compare_desc(e, n),
    a = r.locale,
    s = en.distanceInWords.localize,
    a = (a && a.distanceInWords && a.distanceInWords.localize && (s = a.distanceInWords.localize), {
      addSuffix: Boolean(r.addSuffix),
      comparison: t
    }),
    t = 0 < t ? (i = parse_1(e), parse_1(n)) : (i = parse_1(n), parse_1(e)),
    n = Math[r.partialMethod ? String(r.partialMethod) : "floor"],
    e = difference_in_seconds(t, i),
    t = t.getTimezoneOffset() - i.getTimezoneOffset(),
    i = n(e / 60) - t,
    t = r.unit ? String(r.unit) : i < 1 ? "s" : i < 60 ? "m" : i < MINUTES_IN_DAY$1 ? "h" : i < MINUTES_IN_MONTH$1 ? "d" : i < MINUTES_IN_YEAR ? "M" : "Y";
  if ("s" === t) return s("xSeconds", e, a);
  if ("m" === t) return s("xMinutes", i, a);
  if ("h" === t) return s("xHours", n(i / 60), a);
  if ("d" === t) return s("xDays", n(i / MINUTES_IN_DAY$1), a);
  if ("M" === t) return s("xMonths", n(i / MINUTES_IN_MONTH$1), a);
  if ("Y" === t) return s("xYears", n(i / MINUTES_IN_YEAR), a);
  throw new Error("Unknown unit: " + t);
}
function distanceInWordsToNow(e, n) {
  return distance_in_words(Date.now(), e, n);
}
function eachDay(e, n, r) {
  var e = parse_1(e),
    t = void 0 !== r ? r : 1,
    a = parse_1(n).getTime();
  if (e.getTime() > a) throw new Error("The first date cannot be after the second date");
  var s = [],
    i = e;
  for (i.setHours(0, 0, 0, 0); i.getTime() <= a;) s.push(parse_1(i)), i.setDate(i.getDate() + t);
  return s;
}
function endOfDay(e) {
  e = parse_1(e);
  return e.setHours(23, 59, 59, 999), e;
}
var end_of_day = endOfDay;
function endOfHour(e) {
  e = parse_1(e);
  return e.setMinutes(59, 59, 999), e;
}
function endOfWeek(e, n) {
  var n = n && Number(n.weekStartsOn) || 0,
    e = parse_1(e),
    r = e.getDay(),
    r = 6 + (r < n ? -7 : 0) - (r - n);
  return e.setDate(e.getDate() + r), e.setHours(23, 59, 59, 999), e;
}
var end_of_week = endOfWeek;
function endOfISOWeek(e) {
  return end_of_week(e, {
    weekStartsOn: 1
  });
}
function endOfISOYear(e) {
  var e = get_iso_year(e),
    n = new Date(0),
    e = (n.setFullYear(e + 1, 0, 4), n.setHours(0, 0, 0, 0), start_of_iso_week(n));
  return e.setMilliseconds(e.getMilliseconds() - 1), e;
}
function endOfMinute(e) {
  e = parse_1(e);
  return e.setSeconds(59, 999), e;
}
function endOfMonth(e) {
  var e = parse_1(e),
    n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
}
var end_of_month = endOfMonth;
function endOfQuarter(e) {
  var e = parse_1(e),
    n = e.getMonth();
  return e.setMonth(n - n % 3 + 3, 0), e.setHours(23, 59, 59, 999), e;
}
function endOfSecond(e) {
  e = parse_1(e);
  return e.setMilliseconds(999), e;
}
function endOfToday() {
  return end_of_day(new Date());
}
function endOfTomorrow() {
  var e = new Date(),
    n = e.getFullYear(),
    r = e.getMonth(),
    e = e.getDate(),
    t = new Date(0);
  return t.setFullYear(n, r, e + 1), t.setHours(23, 59, 59, 999), t;
}
function endOfYear(e) {
  var e = parse_1(e),
    n = e.getFullYear();
  return e.setFullYear(n + 1, 0, 0), e.setHours(23, 59, 59, 999), e;
}
function endOfYesterday() {
  var e = new Date(),
    n = e.getFullYear(),
    r = e.getMonth(),
    e = e.getDate(),
    t = new Date(0);
  return t.setFullYear(n, r, e - 1), t.setHours(23, 59, 59, 999), t;
}
function startOfYear(e) {
  var e = parse_1(e),
    n = new Date(0);
  return n.setFullYear(e.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
var start_of_year = startOfYear;
function getDayOfYear(e) {
  e = parse_1(e);
  return difference_in_calendar_days(e, start_of_year(e)) + 1;
}
var get_day_of_year = getDayOfYear,
  MILLISECONDS_IN_WEEK$2 = 6048e5;
function getISOWeek(e) {
  e = parse_1(e), e = start_of_iso_week(e).getTime() - start_of_iso_year(e).getTime();
  return Math.round(e / MILLISECONDS_IN_WEEK$2) + 1;
}
var get_iso_week = getISOWeek;
function isValid$1(e) {
  if (is_date(e)) return !isNaN(e);
  throw new TypeError(toString.call(e) + " is not an instance of Date");
}
var is_valid = isValid$1;
function format$1(e, n, r) {
  var n = n ? String(n) : "YYYY-MM-DDTHH:mm:ss.SSSZ",
    r = (r || {}).locale,
    t = en.format.formatters,
    a = en.format.formattingTokensRegExp,
    r = (r && r.format && r.format.formatters && (t = r.format.formatters, r.format.formattingTokensRegExp) && (a = r.format.formattingTokensRegExp), parse_1(e));
  return is_valid(r) ? buildFormatFn(n, t, a)(r) : "Invalid Date";
}
var formatters = {
  M: function M(e) {
    return e.getMonth() + 1;
  },
  MM: function MM(e) {
    return addLeadingZeros(e.getMonth() + 1, 2);
  },
  Q: function Q(e) {
    return Math.ceil((e.getMonth() + 1) / 3);
  },
  D: function D(e) {
    return e.getDate();
  },
  DD: function DD(e) {
    return addLeadingZeros(e.getDate(), 2);
  },
  DDD: function DDD(e) {
    return get_day_of_year(e);
  },
  DDDD: function DDDD(e) {
    return addLeadingZeros(get_day_of_year(e), 3);
  },
  d: function d(e) {
    return e.getDay();
  },
  E: function E(e) {
    return e.getDay() || 7;
  },
  W: function W(e) {
    return get_iso_week(e);
  },
  WW: function WW(e) {
    return addLeadingZeros(get_iso_week(e), 2);
  },
  YY: function YY(e) {
    return addLeadingZeros(e.getFullYear(), 4).substr(2);
  },
  YYYY: function YYYY(e) {
    return addLeadingZeros(e.getFullYear(), 4);
  },
  GG: function GG(e) {
    return String(get_iso_year(e)).substr(2);
  },
  GGGG: function GGGG(e) {
    return get_iso_year(e);
  },
  H: function H(e) {
    return e.getHours();
  },
  HH: function HH(e) {
    return addLeadingZeros(e.getHours(), 2);
  },
  h: function h(e) {
    e = e.getHours();
    return 0 === e ? 12 : 12 < e ? e % 12 : e;
  },
  hh: function hh(e) {
    return addLeadingZeros(formatters.h(e), 2);
  },
  m: function m(e) {
    return e.getMinutes();
  },
  mm: function mm(e) {
    return addLeadingZeros(e.getMinutes(), 2);
  },
  s: function s(e) {
    return e.getSeconds();
  },
  ss: function ss(e) {
    return addLeadingZeros(e.getSeconds(), 2);
  },
  S: function S(e) {
    return Math.floor(e.getMilliseconds() / 100);
  },
  SS: function SS(e) {
    return addLeadingZeros(Math.floor(e.getMilliseconds() / 10), 2);
  },
  SSS: function SSS(e) {
    return addLeadingZeros(e.getMilliseconds(), 3);
  },
  Z: function Z(e) {
    return formatTimezone(e.getTimezoneOffset(), ":");
  },
  ZZ: function ZZ(e) {
    return formatTimezone(e.getTimezoneOffset());
  },
  X: function X(e) {
    return Math.floor(e.getTime() / 1e3);
  },
  x: function x(e) {
    return e.getTime();
  }
};
function buildFormatFn(e, n, r) {
  for (var t, a = e.match(r), s = a.length, i = 0; i < s; i++) t = n[a[i]] || formatters[a[i]], a[i] = t || removeFormattingTokens(a[i]);
  return function (e) {
    for (var n = "", r = 0; r < s; r++) a[r] instanceof Function ? n += a[r](e, formatters) : n += a[r];
    return n;
  };
}
function removeFormattingTokens(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|]$/g, "") : e.replace(/\\/g, "");
}
function formatTimezone(e, n) {
  n = n || "";
  var r = 0 < e ? "-" : "+",
    e = Math.abs(e),
    t = e % 60;
  return r + addLeadingZeros(Math.floor(e / 60), 2) + n + addLeadingZeros(t, 2);
}
function addLeadingZeros(e, n) {
  for (var r = Math.abs(e).toString(); r.length < n;) r = "0" + r;
  return r;
}
function getDate(e) {
  return parse_1(e).getDate();
}
function getDay(e) {
  return parse_1(e).getDay();
}
function isLeapYear(e) {
  e = parse_1(e).getFullYear();
  return e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
}
var is_leap_year = isLeapYear;
function getDaysInYear(e) {
  return is_leap_year(e) ? 366 : 365;
}
function getHours(e) {
  return parse_1(e).getHours();
}
function getISODay(e) {
  e = parse_1(e).getDay();
  return e = 0 === e ? 7 : e;
}
var get_iso_day = getISODay,
  MILLISECONDS_IN_WEEK$3 = 6048e5;
function getISOWeeksInYear(e) {
  e = start_of_iso_year(e), e = start_of_iso_year(add_weeks(e, 60)).valueOf() - e.valueOf();
  return Math.round(e / MILLISECONDS_IN_WEEK$3);
}
function getMilliseconds(e) {
  return parse_1(e).getMilliseconds();
}
function getMinutes(e) {
  return parse_1(e).getMinutes();
}
function getMonth(e) {
  return parse_1(e).getMonth();
}
var MILLISECONDS_IN_DAY$1 = 864e5;
function getOverlappingDaysInRanges(e, n, r, t) {
  e = parse_1(e).getTime(), n = parse_1(n).getTime(), r = parse_1(r).getTime(), t = parse_1(t).getTime();
  if (n < e || t < r) throw new Error("The start of the range cannot be after the end of the range");
  return e < t && r < n ? Math.ceil(((n < t ? n : t) - (r < e ? e : r)) / MILLISECONDS_IN_DAY$1) : 0;
}
function getSeconds(e) {
  return parse_1(e).getSeconds();
}
function getTime(e) {
  return parse_1(e).getTime();
}
function getYear(e) {
  return parse_1(e).getFullYear();
}
function isAfter(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getTime() > n.getTime();
}
function isBefore(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getTime() < n.getTime();
}
function isEqual(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getTime() === n.getTime();
}
function isFirstDayOfMonth(e) {
  return 1 === parse_1(e).getDate();
}
function isFriday(e) {
  return 5 === parse_1(e).getDay();
}
function isFuture(e) {
  return parse_1(e).getTime() > new Date().getTime();
}
function isLastDayOfMonth(e) {
  e = parse_1(e);
  return end_of_day(e).getTime() === end_of_month(e).getTime();
}
function isMonday(e) {
  return 1 === parse_1(e).getDay();
}
function isPast(e) {
  return parse_1(e).getTime() < new Date().getTime();
}
function isSameDay(e, n) {
  e = start_of_day(e), n = start_of_day(n);
  return e.getTime() === n.getTime();
}
function startOfHour(e) {
  e = parse_1(e);
  return e.setMinutes(0, 0, 0), e;
}
var start_of_hour = startOfHour;
function isSameHour(e, n) {
  e = start_of_hour(e), n = start_of_hour(n);
  return e.getTime() === n.getTime();
}
var is_same_hour = isSameHour;
function isSameWeek(e, n, r) {
  e = start_of_week(e, r), n = start_of_week(n, r);
  return e.getTime() === n.getTime();
}
var is_same_week = isSameWeek;
function isSameISOWeek(e, n) {
  return is_same_week(e, n, {
    weekStartsOn: 1
  });
}
var is_same_iso_week = isSameISOWeek;
function isSameISOYear(e, n) {
  e = start_of_iso_year(e), n = start_of_iso_year(n);
  return e.getTime() === n.getTime();
}
var is_same_iso_year = isSameISOYear;
function startOfMinute(e) {
  e = parse_1(e);
  return e.setSeconds(0, 0), e;
}
var start_of_minute = startOfMinute;
function isSameMinute(e, n) {
  e = start_of_minute(e), n = start_of_minute(n);
  return e.getTime() === n.getTime();
}
var is_same_minute = isSameMinute;
function isSameMonth(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getFullYear() === n.getFullYear() && e.getMonth() === n.getMonth();
}
var is_same_month = isSameMonth;
function startOfQuarter(e) {
  var e = parse_1(e),
    n = e.getMonth();
  return e.setMonth(n - n % 3, 1), e.setHours(0, 0, 0, 0), e;
}
var start_of_quarter = startOfQuarter;
function isSameQuarter(e, n) {
  e = start_of_quarter(e), n = start_of_quarter(n);
  return e.getTime() === n.getTime();
}
var is_same_quarter = isSameQuarter;
function startOfSecond(e) {
  e = parse_1(e);
  return e.setMilliseconds(0), e;
}
var start_of_second = startOfSecond;
function isSameSecond(e, n) {
  e = start_of_second(e), n = start_of_second(n);
  return e.getTime() === n.getTime();
}
var is_same_second = isSameSecond;
function isSameYear(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getFullYear() === n.getFullYear();
}
var is_same_year = isSameYear;
function isSaturday(e) {
  return 6 === parse_1(e).getDay();
}
function isSunday(e) {
  return 0 === parse_1(e).getDay();
}
function isThisHour(e) {
  return is_same_hour(new Date(), e);
}
function isThisISOWeek(e) {
  return is_same_iso_week(new Date(), e);
}
function isThisISOYear(e) {
  return is_same_iso_year(new Date(), e);
}
function isThisMinute(e) {
  return is_same_minute(new Date(), e);
}
function isThisMonth(e) {
  return is_same_month(new Date(), e);
}
function isThisQuarter(e) {
  return is_same_quarter(new Date(), e);
}
function isThisSecond(e) {
  return is_same_second(new Date(), e);
}
function isThisWeek(e, n) {
  return is_same_week(new Date(), e, n);
}
function isThisYear(e) {
  return is_same_year(new Date(), e);
}
function isThursday(e) {
  return 4 === parse_1(e).getDay();
}
function isToday(e) {
  return start_of_day(e).getTime() === start_of_day(new Date()).getTime();
}
function isTomorrow(e) {
  var n = new Date();
  return n.setDate(n.getDate() + 1), start_of_day(e).getTime() === start_of_day(n).getTime();
}
function isTuesday(e) {
  return 2 === parse_1(e).getDay();
}
function isWednesday(e) {
  return 3 === parse_1(e).getDay();
}
function isWeekend(e) {
  e = parse_1(e).getDay();
  return 0 === e || 6 === e;
}
function isWithinRange(e, n, r) {
  e = parse_1(e).getTime(), n = parse_1(n).getTime(), r = parse_1(r).getTime();
  if (r < n) throw new Error("The start of the range cannot be after the end of the range");
  return n <= e && e <= r;
}
function isYesterday(e) {
  var n = new Date();
  return n.setDate(n.getDate() - 1), start_of_day(e).getTime() === start_of_day(n).getTime();
}
function lastDayOfWeek(e, n) {
  var n = n && Number(n.weekStartsOn) || 0,
    e = parse_1(e),
    r = e.getDay(),
    r = 6 + (r < n ? -7 : 0) - (r - n);
  return e.setHours(0, 0, 0, 0), e.setDate(e.getDate() + r), e;
}
var last_day_of_week = lastDayOfWeek;
function lastDayOfISOWeek(e) {
  return last_day_of_week(e, {
    weekStartsOn: 1
  });
}
function lastDayOfISOYear(e) {
  var e = get_iso_year(e),
    n = new Date(0),
    e = (n.setFullYear(e + 1, 0, 4), n.setHours(0, 0, 0, 0), start_of_iso_week(n));
  return e.setDate(e.getDate() - 1), e;
}
function lastDayOfMonth(e) {
  var e = parse_1(e),
    n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function lastDayOfQuarter(e) {
  var e = parse_1(e),
    n = e.getMonth();
  return e.setMonth(n - n % 3 + 3, 0), e.setHours(0, 0, 0, 0), e;
}
function lastDayOfYear(e) {
  var e = parse_1(e),
    n = e.getFullYear();
  return e.setFullYear(n + 1, 0, 0), e.setHours(0, 0, 0, 0), e;
}
function max$1() {
  var e = Array.prototype.slice.call(arguments).map(function (e) {
      return parse_1(e);
    }),
    e = Math.max.apply(null, e);
  return new Date(e);
}
function min$1() {
  var e = Array.prototype.slice.call(arguments).map(function (e) {
      return parse_1(e);
    }),
    e = Math.min.apply(null, e);
  return new Date(e);
}
function setDate(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setDate(n), e;
}
function setDay(e, n, r) {
  var r = r && Number(r.weekStartsOn) || 0,
    e = parse_1(e),
    n = Number(n),
    t = e.getDay();
  return add_days(e, ((7 + n % 7) % 7 < r ? 7 : 0) + n - t);
}
function setDayOfYear(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setMonth(0), e.setDate(n), e;
}
function setHours(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setHours(n), e;
}
function setISODay(e, n) {
  var e = parse_1(e),
    n = Number(n),
    r = get_iso_day(e);
  return add_days(e, n - r);
}
function setISOWeek(e, n) {
  e = parse_1(e), n = Number(n), n = get_iso_week(e) - n;
  return e.setDate(e.getDate() - 7 * n), e;
}
function setMilliseconds(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setMilliseconds(n), e;
}
function setMinutes(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setMinutes(n), e;
}
function setMonth(e, n) {
  var e = parse_1(e),
    n = Number(n),
    r = e.getFullYear(),
    t = e.getDate(),
    a = new Date(0),
    r = (a.setFullYear(r, n, 15), a.setHours(0, 0, 0, 0), get_days_in_month(a));
  return e.setMonth(n, Math.min(t, r)), e;
}
var set_month = setMonth;
function setQuarter(e, n) {
  e = parse_1(e), n = Number(n) - (Math.floor(e.getMonth() / 3) + 1);
  return set_month(e, e.getMonth() + 3 * n);
}
function setSeconds(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setSeconds(n), e;
}
function setYear(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setFullYear(n), e;
}
function startOfMonth(e) {
  e = parse_1(e);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function startOfToday() {
  return start_of_day(new Date());
}
function startOfTomorrow() {
  var e = new Date(),
    n = e.getFullYear(),
    r = e.getMonth(),
    e = e.getDate(),
    t = new Date(0);
  return t.setFullYear(n, r, e + 1), t.setHours(0, 0, 0, 0), t;
}
function startOfYesterday() {
  var e = new Date(),
    n = e.getFullYear(),
    r = e.getMonth(),
    e = e.getDate(),
    t = new Date(0);
  return t.setFullYear(n, r, e - 1), t.setHours(0, 0, 0, 0), t;
}
function subDays(e, n) {
  n = Number(n);
  return add_days(e, -n);
}
function subHours(e, n) {
  n = Number(n);
  return add_hours(e, -n);
}
function subMilliseconds(e, n) {
  n = Number(n);
  return add_milliseconds(e, -n);
}
function subMinutes(e, n) {
  n = Number(n);
  return add_minutes(e, -n);
}
function subMonths(e, n) {
  n = Number(n);
  return add_months(e, -n);
}
function subQuarters(e, n) {
  n = Number(n);
  return add_quarters(e, -n);
}
function subSeconds(e, n) {
  n = Number(n);
  return add_seconds(e, -n);
}
function subWeeks(e, n) {
  n = Number(n);
  return add_weeks(e, -n);
}
function subYears(e, n) {
  n = Number(n);
  return add_years(e, -n);
}
var dateFns = {
    addDays: add_days,
    addHours: add_hours,
    addISOYears: add_iso_years,
    addMilliseconds: add_milliseconds,
    addMinutes: add_minutes,
    addMonths: add_months,
    addQuarters: add_quarters,
    addSeconds: add_seconds,
    addWeeks: add_weeks,
    addYears: add_years,
    areRangesOverlapping: are_ranges_overlapping,
    closestIndexTo: closest_index_to,
    closestTo: closest_to,
    compareAsc: compare_asc,
    compareDesc: compare_desc,
    differenceInCalendarDays: difference_in_calendar_days,
    differenceInCalendarISOWeeks: difference_in_calendar_iso_weeks,
    differenceInCalendarISOYears: difference_in_calendar_iso_years,
    differenceInCalendarMonths: difference_in_calendar_months,
    differenceInCalendarQuarters: difference_in_calendar_quarters,
    differenceInCalendarWeeks: difference_in_calendar_weeks,
    differenceInCalendarYears: difference_in_calendar_years,
    differenceInDays: difference_in_days,
    differenceInHours: difference_in_hours,
    differenceInISOYears: difference_in_iso_years,
    differenceInMilliseconds: difference_in_milliseconds,
    differenceInMinutes: difference_in_minutes,
    differenceInMonths: difference_in_months,
    differenceInQuarters: difference_in_quarters,
    differenceInSeconds: difference_in_seconds,
    differenceInWeeks: difference_in_weeks,
    differenceInYears: difference_in_years,
    distanceInWords: distance_in_words,
    distanceInWordsStrict: distanceInWordsStrict,
    distanceInWordsToNow: distanceInWordsToNow,
    eachDay: eachDay,
    endOfDay: end_of_day,
    endOfHour: endOfHour,
    endOfISOWeek: endOfISOWeek,
    endOfISOYear: endOfISOYear,
    endOfMinute: endOfMinute,
    endOfMonth: end_of_month,
    endOfQuarter: endOfQuarter,
    endOfSecond: endOfSecond,
    endOfToday: endOfToday,
    endOfTomorrow: endOfTomorrow,
    endOfWeek: end_of_week,
    endOfYear: endOfYear,
    endOfYesterday: endOfYesterday,
    format: format$1,
    getDate: getDate,
    getDay: getDay,
    getDayOfYear: get_day_of_year,
    getDaysInMonth: get_days_in_month,
    getDaysInYear: getDaysInYear,
    getHours: getHours,
    getISODay: get_iso_day,
    getISOWeek: get_iso_week,
    getISOWeeksInYear: getISOWeeksInYear,
    getISOYear: get_iso_year,
    getMilliseconds: getMilliseconds,
    getMinutes: getMinutes,
    getMonth: getMonth,
    getOverlappingDaysInRanges: getOverlappingDaysInRanges,
    getQuarter: get_quarter,
    getSeconds: getSeconds,
    getTime: getTime,
    getYear: getYear,
    isAfter: isAfter,
    isBefore: isBefore,
    isDate: is_date,
    isEqual: isEqual,
    isFirstDayOfMonth: isFirstDayOfMonth,
    isFriday: isFriday,
    isFuture: isFuture,
    isLastDayOfMonth: isLastDayOfMonth,
    isLeapYear: is_leap_year,
    isMonday: isMonday,
    isPast: isPast,
    isSameDay: isSameDay,
    isSameHour: is_same_hour,
    isSameISOWeek: is_same_iso_week,
    isSameISOYear: is_same_iso_year,
    isSameMinute: is_same_minute,
    isSameMonth: is_same_month,
    isSameQuarter: is_same_quarter,
    isSameSecond: is_same_second,
    isSameWeek: is_same_week,
    isSameYear: is_same_year,
    isSaturday: isSaturday,
    isSunday: isSunday,
    isThisHour: isThisHour,
    isThisISOWeek: isThisISOWeek,
    isThisISOYear: isThisISOYear,
    isThisMinute: isThisMinute,
    isThisMonth: isThisMonth,
    isThisQuarter: isThisQuarter,
    isThisSecond: isThisSecond,
    isThisWeek: isThisWeek,
    isThisYear: isThisYear,
    isThursday: isThursday,
    isToday: isToday,
    isTomorrow: isTomorrow,
    isTuesday: isTuesday,
    isValid: is_valid,
    isWednesday: isWednesday,
    isWeekend: isWeekend,
    isWithinRange: isWithinRange,
    isYesterday: isYesterday,
    lastDayOfISOWeek: lastDayOfISOWeek,
    lastDayOfISOYear: lastDayOfISOYear,
    lastDayOfMonth: lastDayOfMonth,
    lastDayOfQuarter: lastDayOfQuarter,
    lastDayOfWeek: last_day_of_week,
    lastDayOfYear: lastDayOfYear,
    max: max$1,
    min: min$1,
    parse: parse_1,
    setDate: setDate,
    setDay: setDay,
    setDayOfYear: setDayOfYear,
    setHours: setHours,
    setISODay: setISODay,
    setISOWeek: setISOWeek,
    setISOYear: set_iso_year,
    setMilliseconds: setMilliseconds,
    setMinutes: setMinutes,
    setMonth: set_month,
    setQuarter: setQuarter,
    setSeconds: setSeconds,
    setYear: setYear,
    startOfDay: start_of_day,
    startOfHour: start_of_hour,
    startOfISOWeek: start_of_iso_week,
    startOfISOYear: start_of_iso_year,
    startOfMinute: start_of_minute,
    startOfMonth: startOfMonth,
    startOfQuarter: start_of_quarter,
    startOfSecond: start_of_second,
    startOfToday: startOfToday,
    startOfTomorrow: startOfTomorrow,
    startOfWeek: start_of_week,
    startOfYear: start_of_year,
    startOfYesterday: startOfYesterday,
    subDays: subDays,
    subHours: subHours,
    subISOYears: sub_iso_years,
    subMilliseconds: subMilliseconds,
    subMinutes: subMinutes,
    subMonths: subMonths,
    subQuarters: subQuarters,
    subSeconds: subSeconds,
    subWeeks: subWeeks,
    subYears: subYears
  },
  dateFns_50 = dateFns.format,
  FORMAT_SOAP = "YYYY-MM-DDTHH:mm:ss",
  formatTimestamp = function formatTimestamp(e) {
    var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : FORMAT_SOAP;
    return dateFns_50(new Date(1e3 * e), n);
  },
  format$2 = {
    accountNumber: getCustomerFriendlyAccountNumber,
    creditCardNumber: creditCardNumber,
    dateTime: dateTime,
    iban: iban$1,
    money: money,
    number: number,
    convertAmountFromCentsToEuros: convertAmountFromCentsToEuros,
    phone: phone,
    price: price,
    stringToNumber: stringToNumber,
    structuredMessage: structuredMessage,
    timestamp: formatTimestamp
  },
  MOBILE = "mobile",
  TABLET = "tablet",
  DESKTOP = "desktop",
  getCurrentResolution = function getCurrentResolution() {
    return window.innerWidth < SIZES.SIZE_MD ? MOBILE : window.innerWidth >= SIZES.SIZE_MD && window.innerWidth <= SIZES.SIZE_XL ? TABLET : DESKTOP;
  },
  resolutions = {
    MOBILE: MOBILE,
    TABLET: TABLET,
    DESKTOP: DESKTOP,
    getCurrentResolution: getCurrentResolution
  },
  helpers = {
    resolutions: resolutions
  },
  REGEX_SPECIAL_CHARS = /[‘°µ£€!§@#$%^&*()_+=[\]{};:"\\|,.<>/?]/,
  REGEX_DIGIT = /\d/,
  doesNotContainSpecialCharacters = function doesNotContainSpecialCharacters(e) {
    return !REGEX_SPECIAL_CHARS.test(e);
  },
  doesNotContainDigit = function doesNotContainDigit(e) {
    return !REGEX_DIGIT.test(e);
  },
  common = {
    doesNotContainSpecialCharacters: doesNotContainSpecialCharacters,
    doesNotContainDigit: doesNotContainDigit
  },
  REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  isValid$2 = function isValid$2(e) {
    return REGEX_EMAIL.test(e);
  },
  email = {
    isValid: isValid$2
  },
  PHONE_NUMBER_CHARS = /^[+\d./ ]+$/,
  isValid$3 = function isValid$3(e) {
    return PHONE_NUMBER_CHARS.test(e);
  },
  isBelgianCompliant = function isBelgianCompliant(e) {
    var e = e.split(" "),
      e = toArray(e),
      n = e[0],
      e = e.slice(1);
    return "32" === n && "4" === (n = "0" === (n = e.join("").replace(" ", "")).charAt(0) ? n.substr(1) : n).charAt(0) && 9 === n.length;
  },
  lengthIsValid = function lengthIsValid(e) {
    return !!e && 5 <= (e = e.split(" ")[1]).length && e.length <= 20;
  },
  phone$1 = {
    isValid: isValid$3,
    isBelgianCompliant: isBelgianCompliant,
    lengthIsValid: lengthIsValid
  },
  isMonthInThePast = function isMonthInThePast(e) {
    var n = new Date(),
      r = n.getFullYear(),
      n = n.getMonth() + 1,
      e = (n < 10 && (n = "0" + n), e.split("/")),
      e = slicedToArray(e, 2),
      t = e[0],
      e = e[1];
    return !(!e || !t || 2 !== t.length || 4 !== e.length) && parseInt("" + e + t) < parseInt("" + r + n);
  },
  date = {
    isMonthInThePast: isMonthInThePast
  },
  countries$1 = countryList.list,
  validate = function validate(e) {
    return iban.isValid(e);
  },
  isBelgian = function isBelgian(e) {
    return "BE" === e.substr(0, 2);
  },
  isLuxembourg = function isLuxembourg(e) {
    return "LU" === e.substr(0, 2);
  },
  getIBANPrefix = function getIBANPrefix(e) {
    return e && e.substring(0, 2).toLowerCase();
  },
  isSepa = function isSepa(e) {
    e = getIBANPrefix(e);
    return !e || countries$1[e] && countries$1[e].isSepa;
  },
  isInternational = function isInternational(e, n, r, t) {
    e = isSepa(e), t = !t || countries$1[t.toLowerCase()] && countries$1[t.toLowerCase()].isSepa;
    return !((!r || r === n) && e && t);
  },
  iban$2 = {
    validate: validate,
    isBelgian: isBelgian,
    isLuxembourg: isLuxembourg,
    isSepa: isSepa,
    getIBANPrefix: getIBANPrefix,
    isInternational: isInternational
  },
  validate$1 = function validate$1(e) {
    return iban.isValidBBAN(1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "BE", e);
  },
  bban = {
    validate: validate$1
  },
  validation = {
    common: common,
    email: email,
    phone: phone$1,
    date: date,
    iban: iban$2,
    bban: bban
  },
  index = {
    config: config,
    format: format$2,
    helpers: helpers,
    validation: validation
  };
sharedFunctions["default"] = index, config_1 = sharedFunctions.config = config, sharedFunctions.format = format$2, sharedFunctions.helpers = helpers, sharedFunctions.validation = validation;
var propTypes = {
  exports: {}
};
var reactIs = {
  exports: {}
};
var reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol["for"],
    c = b ? Symbol["for"]("react.element") : 60103,
    d = b ? Symbol["for"]("react.portal") : 60106,
    e = b ? Symbol["for"]("react.fragment") : 60107,
    f = b ? Symbol["for"]("react.strict_mode") : 60108,
    g = b ? Symbol["for"]("react.profiler") : 60114,
    h = b ? Symbol["for"]("react.provider") : 60109,
    k = b ? Symbol["for"]("react.context") : 60110,
    l = b ? Symbol["for"]("react.async_mode") : 60111,
    m = b ? Symbol["for"]("react.concurrent_mode") : 60111,
    n = b ? Symbol["for"]("react.forward_ref") : 60112,
    p = b ? Symbol["for"]("react.suspense") : 60113,
    q = b ? Symbol["for"]("react.suspense_list") : 60120,
    r = b ? Symbol["for"]("react.memo") : 60115,
    t = b ? Symbol["for"]("react.lazy") : 60116,
    v = b ? Symbol["for"]("react.block") : 60121,
    w = b ? Symbol["for"]("react.fundamental") : 60117,
    x = b ? Symbol["for"]("react.responder") : 60118,
    y = b ? Symbol["for"]("react.scope") : 60119;
  function z(a) {
    if ("object" === _typeof$1(a) && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function (a) {
    return "object" === _typeof$1(a) && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === _typeof$1(a) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (browser$1.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || _typeof$1(type) === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (_typeof$1(object) === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return _typeof$1(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (browser$1.env.NODE_ENV === 'production') {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      // Detect buggy property enumeration order in older V8 versions.

      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function printWarning() {};
  if (browser$1.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has = requireHas();
    printWarning = function printWarning(text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {/**/}
    };
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (browser$1.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has(typeSpecs, typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof$1(typeSpecs[typeSpecName]) + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
              err.name = 'Invariant Violation';
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + _typeof$1(error) + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
          }
        }
      }
    }
  }

  /**
   * Resets warning cache when testing.
   *
   * @private
   */
  checkPropTypes.resetWarningCache = function () {
    if (browser$1.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function printWarning() {};
  if (browser$1.env.NODE_ENV !== 'production') {
    printWarning = function printWarning(text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bigint: createPrimitiveTypeChecker('bigint'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && _typeof$1(data) === 'object' ? data : {};
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (browser$1.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (browser$1.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (!manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
            expectedType: expectedType
          });
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (browser$1.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
          } else {
            printWarning('Invalid argument supplied to oneOf, expected an array.');
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === 'symbol') {
            return String(value);
          }
          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (has(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        browser$1.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from props.
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has(shapeTypes, key) && typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (_typeof$1(propValue)) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // falsy value can't be a Symbol
      if (!propValue) {
        return false;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = _typeof$1(propValue);
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function factoryWithThrowingShims() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (browser$1.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
var PropTypes$1 = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);
Object.defineProperty(bundle, '__esModule', {
  value: true
});
function _interopDefault$1(ex) {
  return ex && _typeof$1(ex) === 'object' && 'default' in ex ? ex['default'] : ex;
}
var styled = _interopDefault$1(require$$0);
var functions = sharedFunctions;
var React = _interopDefault$1(React$1);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$2();
}
function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}
function _iterableToArray$2(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread$2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof commonjsGlobal$2 !== 'undefined' ? commonjsGlobal$2 : typeof self !== 'undefined' ? self : {};
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    factory();
  })(commonjsGlobal, function () {
    /**
     * Applies the :focus-visible polyfill at the given scope.
     * A scope in this case is either the top-level Document or a Shadow Root.
     *
     * @param {(Document|ShadowRoot)} scope
     * @see https://github.com/WICG/focus-visible
     */

    function applyFocusVisiblePolyfill(scope) {
      var hadKeyboardEvent = true;
      var hadFocusVisibleRecently = false;
      var hadFocusVisibleRecentlyTimeout = null;
      var inputTypesAllowlist = {
        text: true,
        search: true,
        url: true,
        tel: true,
        email: true,
        password: true,
        number: true,
        date: true,
        month: true,
        week: true,
        time: true,
        datetime: true,
        'datetime-local': true
      };
      /**
       * Helper function for legacy browsers and iframes which sometimes focus
       * elements like document, body, and non-interactive SVG.
       * @param {Element} el
       */

      function isValidFocusTarget(el) {
        if (el && el !== document && el.nodeName !== 'HTML' && el.nodeName !== 'BODY' && 'classList' in el && 'contains' in el.classList) {
          return true;
        }
        return false;
      }
      /**
       * Computes whether the given element should automatically trigger the
       * `focus-visible` class being added, i.e. whether it should always match
       * `:focus-visible` when focused.
       * @param {Element} el
       * @return {boolean}
       */

      function focusTriggersKeyboardModality(el) {
        var type = el.type;
        var tagName = el.tagName;
        if (tagName === 'INPUT' && inputTypesAllowlist[type] && !el.readOnly) {
          return true;
        }
        if (tagName === 'TEXTAREA' && !el.readOnly) {
          return true;
        }
        if (el.isContentEditable) {
          return true;
        }
        return false;
      }
      /**
       * Add the `focus-visible` class to the given element if it was not added by
       * the author.
       * @param {Element} el
       */

      function addFocusVisibleClass(el) {
        if (el.classList.contains('focus-visible')) {
          return;
        }
        el.classList.add('focus-visible');
        el.setAttribute('data-focus-visible-added', '');
      }
      /**
       * Remove the `focus-visible` class from the given element if it was not
       * originally added by the author.
       * @param {Element} el
       */

      function removeFocusVisibleClass(el) {
        if (!el.hasAttribute('data-focus-visible-added')) {
          return;
        }
        el.classList.remove('focus-visible');
        el.removeAttribute('data-focus-visible-added');
      }
      /**
       * If the most recent user interaction was via the keyboard;
       * and the key press did not include a meta, alt/option, or control key;
       * then the modality is keyboard. Otherwise, the modality is not keyboard.
       * Apply `focus-visible` to any current active element and keep track
       * of our keyboard modality state with `hadKeyboardEvent`.
       * @param {KeyboardEvent} e
       */

      function onKeyDown(e) {
        if (e.metaKey || e.altKey || e.ctrlKey) {
          return;
        }
        if (isValidFocusTarget(scope.activeElement)) {
          addFocusVisibleClass(scope.activeElement);
        }
        hadKeyboardEvent = true;
      }
      /**
       * If at any point a user clicks with a pointing device, ensure that we change
       * the modality away from keyboard.
       * This avoids the situation where a user presses a key on an already focused
       * element, and then clicks on a different element, focusing it with a
       * pointing device, while we still think we're in keyboard modality.
       * @param {Event} e
       */

      function onPointerDown(e) {
        hadKeyboardEvent = false;
      }
      /**
       * On `focus`, add the `focus-visible` class to the target if:
       * - the target received focus as a result of keyboard navigation, or
       * - the event target is an element that will likely require interaction
       *   via the keyboard (e.g. a text box)
       * @param {Event} e
       */

      function onFocus(e) {
        // Prevent IE from focusing the document or HTML element.
        if (!isValidFocusTarget(e.target)) {
          return;
        }
        if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
          addFocusVisibleClass(e.target);
        }
      }
      /**
       * On `blur`, remove the `focus-visible` class from the target.
       * @param {Event} e
       */

      function onBlur(e) {
        if (!isValidFocusTarget(e.target)) {
          return;
        }
        if (e.target.classList.contains('focus-visible') || e.target.hasAttribute('data-focus-visible-added')) {
          // To detect a tab/window switch, we look for a blur event followed
          // rapidly by a visibility change.
          // If we don't see a visibility change within 100ms, it's probably a
          // regular focus change.
          hadFocusVisibleRecently = true;
          window.clearTimeout(hadFocusVisibleRecentlyTimeout);
          hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
            hadFocusVisibleRecently = false;
          }, 100);
          removeFocusVisibleClass(e.target);
        }
      }
      /**
       * If the user changes tabs, keep track of whether or not the previously
       * focused element had .focus-visible.
       * @param {Event} e
       */

      function onVisibilityChange(e) {
        if (document.visibilityState === 'hidden') {
          // If the tab becomes active again, the browser will handle calling focus
          // on the element (Safari actually calls it twice).
          // If this tab change caused a blur on an element with focus-visible,
          // re-apply the class when the user switches back to the tab.
          if (hadFocusVisibleRecently) {
            hadKeyboardEvent = true;
          }
          addInitialPointerMoveListeners();
        }
      }
      /**
       * Add a group of listeners to detect usage of any pointing devices.
       * These listeners will be added when the polyfill first loads, and anytime
       * the window is blurred, so that they are active when the window regains
       * focus.
       */

      function addInitialPointerMoveListeners() {
        document.addEventListener('mousemove', onInitialPointerMove);
        document.addEventListener('mousedown', onInitialPointerMove);
        document.addEventListener('mouseup', onInitialPointerMove);
        document.addEventListener('pointermove', onInitialPointerMove);
        document.addEventListener('pointerdown', onInitialPointerMove);
        document.addEventListener('pointerup', onInitialPointerMove);
        document.addEventListener('touchmove', onInitialPointerMove);
        document.addEventListener('touchstart', onInitialPointerMove);
        document.addEventListener('touchend', onInitialPointerMove);
      }
      function removeInitialPointerMoveListeners() {
        document.removeEventListener('mousemove', onInitialPointerMove);
        document.removeEventListener('mousedown', onInitialPointerMove);
        document.removeEventListener('mouseup', onInitialPointerMove);
        document.removeEventListener('pointermove', onInitialPointerMove);
        document.removeEventListener('pointerdown', onInitialPointerMove);
        document.removeEventListener('pointerup', onInitialPointerMove);
        document.removeEventListener('touchmove', onInitialPointerMove);
        document.removeEventListener('touchstart', onInitialPointerMove);
        document.removeEventListener('touchend', onInitialPointerMove);
      }
      /**
       * When the polfyill first loads, assume the user is in keyboard modality.
       * If any event is received from a pointing device (e.g. mouse, pointer,
       * touch), turn off keyboard modality.
       * This accounts for situations where focus enters the page from the URL bar.
       * @param {Event} e
       */

      function onInitialPointerMove(e) {
        // Work around a Safari quirk that fires a mousemove on <html> whenever the
        // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
        if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
          return;
        }
        hadKeyboardEvent = false;
        removeInitialPointerMoveListeners();
      } // For some kinds of state, we are interested in changes at the global scope
      // only. For example, global pointer input, global key presses and global
      // visibility change should affect the state at every scope:

      document.addEventListener('keydown', onKeyDown, true);
      document.addEventListener('mousedown', onPointerDown, true);
      document.addEventListener('pointerdown', onPointerDown, true);
      document.addEventListener('touchstart', onPointerDown, true);
      document.addEventListener('visibilitychange', onVisibilityChange, true);
      addInitialPointerMoveListeners(); // For focus and blur, we specifically care about state changes in the local
      // scope. This is because focus / blur events that originate from within a
      // shadow root are not re-dispatched from the host element if it was already
      // the active element in its own scope:

      scope.addEventListener('focus', onFocus, true);
      scope.addEventListener('blur', onBlur, true); // We detect that a node is a ShadowRoot by ensuring that it is a
      // DocumentFragment and also has a host property. This check covers native
      // implementation and polyfill implementation transparently. If we only cared
      // about the native implementation, we could just check if the scope was
      // an instance of a ShadowRoot.

      if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
        // Since a ShadowRoot is a special kind of DocumentFragment, it does not
        // have a root element to add a class to. So, we add this attribute to the
        // host element instead:
        scope.host.setAttribute('data-js-focus-visible', '');
      } else if (scope.nodeType === Node.DOCUMENT_NODE) {
        document.documentElement.classList.add('js-focus-visible');
        document.documentElement.setAttribute('data-js-focus-visible', '');
      }
    } // It is important to wrap all references to global window and document in
    // these checks to support server-side rendering use cases
    // @see https://github.com/WICG/focus-visible/issues/199

    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      // Make the polyfill helper globally available. This can be used as a signal
      // to interested libraries that wish to coordinate with the polyfill for e.g.,
      // applying the polyfill to a shadow root:
      window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill; // Notify interested libraries of the polyfill's presence, in case the
      // polyfill was loaded lazily:

      var event;
      try {
        event = new CustomEvent('focus-visible-polyfill-ready');
      } catch (error) {
        // IE11 does not support using CustomEvent as a constructor directly:
        event = document.createEvent('CustomEvent');
        event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
      }
      window.dispatchEvent(event);
    }
    if (typeof document !== 'undefined') {
      // Apply the polyfill to the global document, so that no JavaScript
      // coordination is required to use the polyfill in the top-level document:
      applyFocusVisiblePolyfill(document);
    }
  });
});
var colors$2 = functions.config.colors.list;
var getFont = functions.config.fonts.getFont;
var AccordionWrapper = styled.div.withConfig({
  displayName: "Accordionstyled__AccordionWrapper",
  componentId: "arvhyg-0"
})(["margin:", ";> div:nth-child(n+2){margin-top:8px;}"], function (props) {
  return props.margin;
});
var AccordionHeaderWrapper = styled.div.withConfig({
  displayName: "Accordionstyled__AccordionHeaderWrapper",
  componentId: "arvhyg-1"
})(["position:relative;width:100%;display:flex;svg{position:absolute;pointer-events:none;top:12px;z-index:2;transition:0.2s ease-out transform;", " right:3px;@media ", "{top:16px;right:16px;}}"], function (props) {
  return props.isActive && "transform: rotate(180deg);";
}, functions.config.breakpoints.device.tablet);
var AccordionItem = styled.div.withConfig({
  displayName: "Accordionstyled__AccordionItem",
  componentId: "arvhyg-2"
})(["background:", ";border-radius:10px;border:1px solid ", ";", ";"], colors$2.White, colors$2.GreyWhite, function (props) {
  return props.isActive && "\n    box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.05), 0px 2px 5px 0px rgba(0, 0, 0, 0.05);\n  ";
});
var AccordionHeaderButton = styled.button.withConfig({
  displayName: "Accordionstyled__AccordionHeaderButton",
  componentId: "arvhyg-3"
})(["background-color:", ";border:none;color:", ";cursor:pointer;flex:1 1 auto;font-family:", ";text-align:left;border-radius:", ";transition:background-color ease 0.2s;font-size:1.4rem;padding:1.2rem 3.8rem 1.2rem .8rem;@media ", "{font-size:1.6rem;padding:1.6rem 4.6rem 1.6rem 1.6rem;}&:focus{background-color:", ";outline:none;}&:focus:not(.focus-visible),&:not([data-focus-visible-added]):focus{background-color:", ";outline:none;}&.focus-visible:focus,&[data-focus-visible-added]:focus,&.focus-visible,&.focus-visible[data-focus-visible-added]{background-color:", ";outline:none;}"], colors$2.Transparent, colors$2.BlueDark, function (props) {
  return getFont(props.theme, 'bold');
}, function (props) {
  return props.isActive ? '10px 10px 0 0' : '10px';
}, functions.config.breakpoints.device.tablet, colors$2.Transparent, colors$2.Transparent, colors$2.GreyBackground);
var AccordionItemContentWrapper = styled.div.withConfig({
  displayName: "Accordionstyled__AccordionItemContentWrapper",
  componentId: "arvhyg-4"
})(["display:block;color:", ";transition-property:height,padding;transition-duration:1s,0.05s;transition-timing-function:ease,ease;height:", ";overflow:hidden;text-align:left;font-size:1.2rem;padding:", ";@media ", "{font-size:1.4rem;padding:", ";}"], colors$2.BlueDark, function (props) {
  return props.isActive ? 'auto' : '0';
}, function (props) {
  return props.isActive ? '.8rem .8rem 1.2rem' : '0 .8rem';
}, functions.config.breakpoints.device.tablet, function (props) {
  return props.isActive ? '.8rem 1.6rem 1.2rem' : '0 1.6rem';
});
var colors$1$1 = functions.config.colors.list;
var Arrow = function Arrow() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.4rem",
    height: "2.4rem",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: colors$1$1.BlueSky,
    fillRule: "evenodd",
    d: "M11.296 14.998L5.45 9.108a.597.597 0 0 1 0-.85l.358-.355a.609.609 0 0 1 .856 0l5.06 5.115 5.058-5.11a.609.609 0 0 1 .857 0l.357.355a.597.597 0 0 1 0 .85l-5.845 5.89a.613.613 0 0 1-.856-.005z"
  }));
};
var colors$2$1 = functions.config.colors.list;
var Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);
  var _super = _createSuper(Accordion);
  function Accordion(props) {
    var _this;
    _classCallCheck(this, Accordion);
    _this = _super.call(this, props);
    _defineProperty$2(_assertThisInitialized(_this), "areEqualArrays", function (array1, array2) {
      if (array1.length !== array2.length) return false;
      return array1.every(function (value, index) {
        return value === array2[index];
      });
    });
    _defineProperty$2(_assertThisInitialized(_this), "handleAccordionToggle", function (value, byClick, multipleOpen) {
      var newStateArray = _toConsumableArray$2(_this.state.isOpenIndexes);
      if (multipleOpen) {
        if (byClick) {
          if (newStateArray.indexOf(value) > -1) {
            newStateArray.splice(newStateArray.indexOf(value), 1);
          } else {
            newStateArray.push(value);
          }
          newStateArray = newStateArray.sort();
          _this.setState({
            isOpenIndexes: newStateArray
          });
        } else {
          _this.setState({
            isOpenIndexes: _this.props.isOpenIndexes.sort()
          });
        }
      } else {
        if (isNaN(value)) return null;
        if (_this.state.isOpenIndexes.indexOf(value) > -1) {
          var arrayWithoutClickedIndex = _toConsumableArray$2(_this.state.isOpenIndexes);
          /** remove it */

          arrayWithoutClickedIndex.splice(_this.state.isOpenIndexes.indexOf(value), 1);
          _this.setState({
            isOpenIndexes: arrayWithoutClickedIndex
          });
        } else {
          var newArray = [];
          if (byClick) {
            newArray.push(value);
          } else {
            newArray = _toConsumableArray$2(value);
          }
          _this.setState({
            isOpenIndexes: newArray
          });
        }
      }
    });
    _defineProperty$2(_assertThisInitialized(_this), "onClickAccordion", function (index) {
      var byClick = true;
      _this.handleAccordionToggle(index, byClick, _this.props.multipleOpen);
    });
    _this.state = {
      isOpenIndexes: []
    };
    return _this;
  }
  _createClass(Accordion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpenIndexes && this.props.isOpenIndexes.length > 0) {
        this.handleAccordionToggle(this.props.isOpenIndexes, false, this.props.multipleOpen);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpenIndexes && this.props.isOpenIndexes.length > 0 && prevProps.isOpenIndexes !== this.props.isOpenIndexes) {
        this.handleAccordionToggle(this.props.isOpenIndexes, false, this.props.multipleOpen);
      }
    }
    /**
     * Set a new activeIndex in the state based on the clicked tab index.
     */
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var isOpenIndexes = this.state.isOpenIndexes;
      var _this$props = this.props,
        data = _this$props.data,
        multipleOpen = _this$props.multipleOpen;
      if (!data || data.length === 0) {
        return null;
      }
      var AccordionContents = data.map(function (entry, i) {
        var isActive = isOpenIndexes.indexOf(i) > -1;
        var itemHeight = AccordionItem.offsetHeight;
        return /*#__PURE__*/React.createElement(AccordionItem, {
          multipleOpen: multipleOpen,
          key: "Accordion_" + i,
          "aria-expanded": isActive,
          isActive: isActive
        }, /*#__PURE__*/React.createElement(AccordionHeaderWrapper, {
          isActive: isActive
        }, /*#__PURE__*/React.createElement(AccordionHeaderButton, {
          onClick: function onClick() {
            return _this2.onClickAccordion(i);
          },
          isActive: isActive
        }, entry.header), /*#__PURE__*/React.createElement(Arrow, {
          color: isActive && colors$2$1.BlueSky
        })), /*#__PURE__*/React.createElement(AccordionItemContentWrapper, {
          "aria-hidden": !isActive,
          isActive: isActive,
          itemHeight: itemHeight
        }, entry.content));
      });
      return /*#__PURE__*/React.createElement(AccordionWrapper, {
        margin: this.props.margin
      }, data.length > 0 && AccordionContents);
    }
  }]);
  return Accordion;
}(React.Component);
var Accordion_1 = bundle.Accordion = Accordion;
var css_248z$7 = ".hn1xdlw{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:space-between;-webkit-justify-content:space-between;justify-content:space-between;font-family:Averta,sans-serif;font-weight:700;}.hn1xdlw h2{font-weight:700!important;}@media (max-width: 991px){.hn1xdlw{gap:1rem;}.hn1xdlw h2{font-size:2.6rem;}}\n.b8xvpzk{right:0;top:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;gap:1rem;}@media (max-width: 991px){.b8xvpzk{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;gap:0.5rem;-webkit-align-items:flex-end;-webkit-box-align:flex-end;-ms-flex-align:flex-end;align-items:flex-end;}.b8xvpzk button{width:100%;}}\n.skrgzlw{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;font-size:1.6rem!important;background-color:transparent!important;border-color:#007f9e!important;color:#007f9e!important;max-height:80px;min-width:100%;-webkit-transition:all 0.3s ease;transition:all 0.3s ease;}.skrgzlw svg path{fill:#007f9e!important;}.skrgzlw:hover{background-color:#007f9e!important;border-color:#007f9e!important;color:white!important;}.skrgzlw:hover svg path{fill:white!important;}\n/*# sourceMappingURL=data:application/json;base64,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*/\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$7);
var HeaderContainer = /*#__PURE__*/styled_default('div')({
  name: "HeaderContainer",
  "class": "hn1xdlw",
  propsAsIs: false
});
var ButtonsContainer = /*#__PURE__*/styled_default('div')({
  name: "ButtonsContainer",
  "class": "b8xvpzk",
  propsAsIs: false
});
var _exp3$2 = function _exp3() {
  return componentsButton.Button;
};
var StyledButton = /*#__PURE__*/styled_default(_exp3$2())({
  name: "StyledButton",
  "class": "skrgzlw",
  propsAsIs: true
});
var Header = function Header(_ref) {
  _ref.request;
  var _useStore = useStore(),
    language = _useStore.language,
    cookieData = _useStore.cookieData,
    env = _useStore.env;
  var labels = locales[language];
  var contactUrl = "https://www.keytradebank.be/".concat(language, "/contact");
  var _useState = React$1.useState(false),
    _useState2 = _slicedToArray$2(_useState, 2),
    isSigningOut = _useState2[0],
    setIsSigningOut = _useState2[1];
  var handleSignOut = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsSigningOut(true);
            _context.prev = 1;
            _context.next = 4;
            return REQUESTS.signout(env);
          case 4:
            response = _context.sent;
            if (!response.success) {
              console.error("Signout failed");
            }
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            console.error("Signout failed:", _context.t0);
          case 11:
            _context.prev = 11;
            if (typeof window !== 'undefined') {
              window.location.href = "".concat(window.location.origin, "/").concat(window.location.pathname.split('/')[1]);
            }
            setIsSigningOut(false);
            return _context.finish(11);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8, 11, 15]]);
    }));
    return function handleSignOut() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React$1.createElement(HeaderContainer, null, /*#__PURE__*/React$1.createElement(componentsTitle.Title, {
    level: 'h2'
  }, labels.good_morning, " ", (cookieData === null || cookieData === void 0 ? void 0 : cookieData.firstName) || ""), /*#__PURE__*/React$1.createElement(ButtonsContainer, null, /*#__PURE__*/React$1.createElement(Accordion_1, {
    data: [{
      header: labels.need_help,
      content: /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(StyledButton, {
        fullWidth: true,
        onClick: function onClick() {
          if (typeof window !== 'undefined') {
            window.open(labels.faq_url);
          }
        },
        iconLeft: /*#__PURE__*/React$1.createElement(componentsIcon.Icon, {
          icon: 'icn_info'
        }),
        size: 'sm'
      }, labels.faq), /*#__PURE__*/React$1.createElement("br", null), /*#__PURE__*/React$1.createElement("br", null), /*#__PURE__*/React$1.createElement(StyledButton, {
        fullWidth: true,
        onClick: function onClick() {
          if (typeof window !== 'undefined') {
            window.open(contactUrl);
          }
        },
        iconLeft: /*#__PURE__*/React$1.createElement(componentsIcon.Icon, {
          icon: 'icn_travelAssistance'
        }),
        size: 'sm'
      }, labels.contact_us))
    }]
  }), /*#__PURE__*/React$1.createElement("div", {
    style: {
      flex: '0 1 auto'
    }
  }), /*#__PURE__*/React$1.createElement(StyledButton, {
    onClick: handleSignOut,
    iconLeft: /*#__PURE__*/React$1.createElement(componentsIcon.Icon, {
      icon: 'icn_signout'
    }),
    size: 'sm',
    disabled: isSigningOut
  }, labels.logout)));
};
var statusOrder = [1, 5, 2, 4, 3];
var sortByStatus = function sortByStatus(a, b) {
  return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$filter2;
                const placement = (_overflowsData$filter2 = overflowsData.filter(d => {
                  if (hasFallbackAxisSideDirection) {
                    const currentSideAxis = getSideAxis(d.placement);
                    return currentSideAxis === initialSideAxis ||
                    // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    currentSideAxis === 'y';
                  }
                  return true;
                }).map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset$1 = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [':popover-open', ':modal'].some(selector => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  // https://drafts.csswg.org/css-transforms-2/#individual-transforms
  return ['transform', 'translate', 'scale', 'rotate', 'perspective'].some(value => css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'translate', 'scale', 'rotate', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 :
  // RTL <body> scrollbar.
  getWindowScrollBarX(documentElement, htmlRect));
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
      // Firefox with layout.scrollbar.side = 3 in about:config to test this.
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle$1(element).position === 'static';
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;

  // Firefox returns the <html> element as the offsetParent if it's non-static,
  // while Chrome and Safari return the <body> element. The <body> element must
  // be used to perform the correct calculations even if the <html> element is
  // non-static.
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === 'rtl';
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        // It's possible that even though the ratio is reported as 1, the
        // element is not actually fully within the IntersectionObserver's root
        // area anymore. This can happen under performance constraints. This may
        // be a bug in the browser's IntersectionObserver implementation. To
        // work around this, we compare the element's bounding rect now with
        // what it was at the time we created the IntersectionObserver. If they
        // are not equal then the element moved, so we refresh.
        refresh();
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = offset$1;

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = shift$1;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = flip$1;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = arrow$1;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
var classnames = {
  exports: {}
};
(function (module) {
  /* global define */

  (function () {
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = '';
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (arg) {
          classes = appendClass(classes, parseValue(arg));
        }
      }
      return classes;
    }
    function parseValue(arg) {
      if (typeof arg === 'string' || typeof arg === 'number') {
        return arg;
      }
      if (_typeof$1(arg) !== 'object') {
        return '';
      }
      if (Array.isArray(arg)) {
        return classNames.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
        return arg.toString();
      }
      var classes = '';
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes = appendClass(classes, key);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + ' ' + newClass;
      }
      return value + newClass;
    }
    if (module.exports) {
      classNames["default"] = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
var classnamesExports = classnames.exports;
var y = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const h = "react-tooltip-core-styles",
  w = "react-tooltip-base-styles",
  b = {
    core: !1,
    base: !1
  };
function S(_ref9) {
  let {
    css: e,
    id: t = w,
    type: o = "base",
    ref: l
  } = _ref9;
  var r, n;
  if (!e || "undefined" == typeof document || b[o]) return;
  if ("core" === o && "undefined" != typeof process && (null === (r = null === process || void 0 === process ? void 0 : process.env) || void 0 === r ? void 0 : r.REACT_TOOLTIP_DISABLE_CORE_STYLES)) return;
  if ("base" !== o && "undefined" != typeof process && (null === (n = null === process || void 0 === process ? void 0 : process.env) || void 0 === n ? void 0 : n.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  "core" === o && (t = h), l || (l = {});
  const {
    insertAt: c
  } = l;
  if (document.getElementById(t)) return void console.warn(`[react-tooltip] Element with id '${t}' already exists. Call \`removeStyle()\` first`);
  const i = document.head || document.getElementsByTagName("head")[0],
    s = document.createElement("style");
  s.id = t, s.type = "text/css", "top" === c && i.firstChild ? i.insertBefore(s, i.firstChild) : i.appendChild(s), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(document.createTextNode(e)), b[o] = !0;
}
const g = (e, t, o) => {
    let l = null;
    return function () {
      for (var _len3 = arguments.length, r = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        r[_key3] = arguments[_key3];
      }
      const n = () => {
        l = null, o || e.apply(this, r);
      };
      o && !l && (e.apply(this, r), l = setTimeout(n, t)), o || (l && clearTimeout(l), l = setTimeout(n, t));
    };
  },
  _ = "DEFAULT_TOOLTIP_ID",
  A = {
    anchorRefs: new Set(),
    activeAnchor: {
      current: null
    },
    attach: () => {},
    detach: () => {},
    setActiveAnchor: () => {}
  },
  O = React$1.createContext({
    getTooltipData: () => A
  });
function k() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _;
  return React$1.useContext(O).getTooltipData(e);
}
const C = "undefined" != typeof window ? React$1.useLayoutEffect : React$1.useEffect,
  R = e => {
    if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
    const t = getComputedStyle(e);
    return ["overflow", "overflow-x", "overflow-y"].some(e => {
      const o = t.getPropertyValue(e);
      return "auto" === o || "scroll" === o;
    });
  },
  x = e => {
    if (!e) return null;
    let t = e.parentElement;
    for (; t;) {
      if (R(t)) return t;
      t = t.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  },
  N = async _ref0 => {
    let {
      elementReference: e = null,
      tooltipReference: t = null,
      tooltipArrowReference: o = null,
      place: l = "top",
      offset: r = 10,
      strategy: n = "absolute",
      middlewares: c = [offset(Number(r)), flip({
        fallbackAxisSideDirection: "start"
      }), shift({
        padding: 5
      })],
      border: i
    } = _ref0;
    if (!e) return {
      tooltipStyles: {},
      tooltipArrowStyles: {},
      place: l
    };
    if (null === t) return {
      tooltipStyles: {},
      tooltipArrowStyles: {},
      place: l
    };
    const s = c;
    return o ? (s.push(arrow({
      element: o,
      padding: 5
    })), computePosition(e, t, {
      placement: l,
      strategy: n,
      middleware: s
    }).then(_ref1 => {
      let {
        x: e,
        y: t,
        placement: o,
        middlewareData: l
      } = _ref1;
      var r, n;
      const c = {
          left: `${e}px`,
          top: `${t}px`,
          border: i
        },
        {
          x: s,
          y: a
        } = null !== (r = l.arrow) && void 0 !== r ? r : {
          x: 0,
          y: 0
        },
        u = null !== (n = {
          top: "bottom",
          right: "left",
          bottom: "top",
          left: "right"
        }[o.split("-")[0]]) && void 0 !== n ? n : "bottom",
        d = i && {
          borderBottom: i,
          borderRight: i
        };
      let p = 0;
      if (i) {
        const e = `${i}`.match(/(\d+)px/);
        p = (null == e ? void 0 : e[1]) ? Number(e[1]) : 1;
      }
      return {
        tooltipStyles: c,
        tooltipArrowStyles: {
          left: null != s ? `${s}px` : "",
          top: null != a ? `${a}px` : "",
          right: "",
          bottom: "",
          ...d,
          [u]: `-${4 + p}px`
        },
        place: o
      };
    })) : computePosition(e, t, {
      placement: "bottom",
      strategy: n,
      middleware: s
    }).then(_ref10 => {
      let {
        x: e,
        y: t,
        placement: o
      } = _ref10;
      return {
        tooltipStyles: {
          left: `${e}px`,
          top: `${t}px`
        },
        tooltipArrowStyles: {},
        place: o
      };
    });
  };
var $ = {
    tooltip: "core-styles-module_tooltip__3vRRp",
    fixed: "core-styles-module_fixed__pcSol",
    arrow: "core-styles-module_arrow__cvMwQ",
    noArrow: "core-styles-module_noArrow__xock6",
    clickable: "core-styles-module_clickable__ZuTTB",
    show: "core-styles-module_show__Nt9eE",
    closing: "core-styles-module_closing__sGnxF"
  },
  j = {
    tooltip: "styles-module_tooltip__mnnfp",
    arrow: "styles-module_arrow__K0L3T",
    dark: "styles-module_dark__xNqje",
    light: "styles-module_light__Z6W-X",
    success: "styles-module_success__A2AKt",
    warning: "styles-module_warning__SCK0X",
    error: "styles-module_error__JvumD",
    info: "styles-module_info__BWdHW"
  };
const I = _ref11 => {
    let {
      forwardRef: t,
      id: r,
      className: n,
      classNameArrow: s,
      variant: u = "dark",
      anchorId: d,
      anchorSelect: p,
      place: v = "top",
      offset: m = 10,
      events: h = ["hover"],
      openOnClick: w = !1,
      positionStrategy: b = "absolute",
      middlewares: S,
      wrapper: E,
      delayShow: _ = 0,
      delayHide: A = 0,
      float: O = !1,
      hidden: T = !1,
      noArrow: L = !1,
      clickable: R = !1,
      closeOnEsc: I = !1,
      closeOnScroll: B = !1,
      closeOnResize: z = !1,
      openEvents: D,
      closeEvents: q,
      globalCloseEvents: H,
      imperativeModeOnly: M,
      style: W,
      position: P,
      afterShow: F,
      afterHide: K,
      content: U,
      contentWrapperRef: V,
      isOpen: X,
      setIsOpen: Y,
      activeAnchor: G,
      setActiveAnchor: Z,
      border: J,
      opacity: Q,
      arrowColor: ee,
      role: te = "tooltip"
    } = _ref11;
    var oe;
    const le = React$1.useRef(null),
      re = React$1.useRef(null),
      ne = React$1.useRef(null),
      ce = React$1.useRef(null),
      ie = React$1.useRef(null),
      [se, ae] = React$1.useState(v),
      [ue, de] = React$1.useState({}),
      [pe, ve] = React$1.useState({}),
      [me, fe] = React$1.useState(!1),
      [ye, he] = React$1.useState(!1),
      [we, be] = React$1.useState(null),
      Se = React$1.useRef(!1),
      Ee = React$1.useRef(null),
      {
        anchorRefs: ge,
        setActiveAnchor: _e
      } = k(r),
      Ae = React$1.useRef(!1),
      [Oe, Te] = React$1.useState([]),
      ke = React$1.useRef(!1),
      Le = w || h.includes("click"),
      Ce = Le || (null == D ? void 0 : D.click) || (null == D ? void 0 : D.dblclick) || (null == D ? void 0 : D.mousedown),
      Re = D ? {
        ...D
      } : {
        mouseenter: !0,
        focus: !0,
        click: !1,
        dblclick: !1,
        mousedown: !1
      };
    !D && Le && Object.assign(Re, {
      mouseenter: !1,
      focus: !1,
      click: !0
    });
    const xe = q ? {
      ...q
    } : {
      mouseleave: !0,
      blur: !0,
      click: !1,
      dblclick: !1,
      mouseup: !1
    };
    !q && Le && Object.assign(xe, {
      mouseleave: !1,
      blur: !1
    });
    const Ne = H ? {
      ...H
    } : {
      escape: I || !1,
      scroll: B || !1,
      resize: z || !1,
      clickOutsideAnchor: Ce || !1
    };
    M && (Object.assign(Re, {
      mouseenter: !1,
      focus: !1,
      click: !1,
      dblclick: !1,
      mousedown: !1
    }), Object.assign(xe, {
      mouseleave: !1,
      blur: !1,
      click: !1,
      dblclick: !1,
      mouseup: !1
    }), Object.assign(Ne, {
      escape: !1,
      scroll: !1,
      resize: !1,
      clickOutsideAnchor: !1
    })), C(() => (ke.current = !0, () => {
      ke.current = !1;
    }), []);
    const $e = e => {
      ke.current && (e && he(!0), setTimeout(() => {
        ke.current && (null == Y || Y(e), void 0 === X && fe(e));
      }, 10));
    };
    React$1.useEffect(() => {
      if (void 0 === X) return () => null;
      X && he(!0);
      const e = setTimeout(() => {
        fe(X);
      }, 10);
      return () => {
        clearTimeout(e);
      };
    }, [X]), React$1.useEffect(() => {
      if (me !== Se.current) if (ie.current && clearTimeout(ie.current), Se.current = me, me) null == F || F();else {
        const e = (e => {
          const t = e.match(/^([\d.]+)(m?s?)$/);
          if (!t) return 0;
          const [, o, l] = t;
          return "s" !== l && "ms" !== l ? 0 : Number(o) * ("ms" === l ? 1 : 1e3);
        })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
        ie.current = setTimeout(() => {
          he(!1), be(null), null == K || K();
        }, e + 25);
      }
    }, [me]);
    const je = function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _;
        ne.current && clearTimeout(ne.current), ne.current = setTimeout(() => {
          $e(!0);
        }, e);
      },
      Ie = function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : A;
        ce.current && clearTimeout(ce.current), ce.current = setTimeout(() => {
          Ae.current || $e(!1);
        }, e);
      },
      Be = e => {
        var t;
        if (!e) return;
        const o = null !== (t = e.currentTarget) && void 0 !== t ? t : e.target;
        if (!(null == o ? void 0 : o.isConnected)) return Z(null), void _e({
          current: null
        });
        _ ? je() : $e(!0), Z(o), _e({
          current: o
        }), ce.current && clearTimeout(ce.current);
      },
      ze = () => {
        R ? Ie(A || 100) : A ? Ie() : $e(!1), ne.current && clearTimeout(ne.current);
      },
      De = _ref12 => {
        let {
          x: e,
          y: t
        } = _ref12;
        var o;
        const l = {
          getBoundingClientRect: () => ({
            x: e,
            y: t,
            width: 0,
            height: 0,
            top: t,
            left: e,
            right: e,
            bottom: t
          })
        };
        N({
          place: null !== (o = null == we ? void 0 : we.place) && void 0 !== o ? o : v,
          offset: m,
          elementReference: l,
          tooltipReference: le.current,
          tooltipArrowReference: re.current,
          strategy: b,
          middlewares: S,
          border: J
        }).then(e => {
          Object.keys(e.tooltipStyles).length && de(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && ve(e.tooltipArrowStyles), ae(e.place);
        });
      },
      qe = e => {
        if (!e) return;
        const t = e,
          o = {
            x: t.clientX,
            y: t.clientY
          };
        De(o), Ee.current = o;
      },
      He = e => {
        var t;
        if (!me) return;
        const o = e.target;
        if (null === (t = le.current) || void 0 === t ? void 0 : t.contains(o)) return;
        [document.querySelector(`[id='${d}']`), ...Oe].some(e => null == e ? void 0 : e.contains(o)) || ($e(!1), ne.current && clearTimeout(ne.current));
      },
      Me = g(Be, 50, !0),
      We = g(ze, 50, !0),
      Pe = React$1.useCallback(() => {
        var e, t;
        const o = null !== (e = null == we ? void 0 : we.position) && void 0 !== e ? e : P;
        o ? De(o) : O ? Ee.current && De(Ee.current) : (null == G ? void 0 : G.isConnected) && N({
          place: null !== (t = null == we ? void 0 : we.place) && void 0 !== t ? t : v,
          offset: m,
          elementReference: G,
          tooltipReference: le.current,
          tooltipArrowReference: re.current,
          strategy: b,
          middlewares: S,
          border: J
        }).then(e => {
          ke.current && (Object.keys(e.tooltipStyles).length && de(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && ve(e.tooltipArrowStyles), ae(e.place));
        });
      }, [me, G, U, W, v, null == we ? void 0 : we.place, m, b, P, null == we ? void 0 : we.position, O]);
    React$1.useEffect(() => {
      var e, t;
      const o = new Set(ge);
      Oe.forEach(e => {
        o.add({
          current: e
        });
      });
      const l = document.querySelector(`[id='${d}']`);
      l && o.add({
        current: l
      });
      const r = () => {
          $e(!1);
        },
        n = x(G),
        c = x(le.current);
      Ne.scroll && (window.addEventListener("scroll", r), null == n || n.addEventListener("scroll", r), null == c || c.addEventListener("scroll", r));
      let i = null;
      Ne.resize ? window.addEventListener("resize", r) : G && le.current && (i = autoUpdate(G, le.current, Pe, {
        ancestorResize: !0,
        elementResize: !0,
        layoutShift: !0
      }));
      const s = e => {
        "Escape" === e.key && $e(!1);
      };
      Ne.escape && window.addEventListener("keydown", s), Ne.clickOutsideAnchor && window.addEventListener("click", He);
      const a = [],
        u = e => {
          me && (null == e ? void 0 : e.target) === G || Be(e);
        },
        p = e => {
          me && (null == e ? void 0 : e.target) === G && ze();
        },
        v = ["mouseenter", "mouseleave", "focus", "blur"],
        m = ["click", "dblclick", "mousedown", "mouseup"];
      Object.entries(Re).forEach(_ref13 => {
        let [e, t] = _ref13;
        t && (v.includes(e) ? a.push({
          event: e,
          listener: Me
        }) : m.includes(e) && a.push({
          event: e,
          listener: u
        }));
      }), Object.entries(xe).forEach(_ref14 => {
        let [e, t] = _ref14;
        t && (v.includes(e) ? a.push({
          event: e,
          listener: We
        }) : m.includes(e) && a.push({
          event: e,
          listener: p
        }));
      }), O && a.push({
        event: "mousemove",
        listener: qe
      });
      const y = () => {
          Ae.current = !0;
        },
        h = () => {
          Ae.current = !1, ze();
        };
      return R && !Ce && (null === (e = le.current) || void 0 === e || e.addEventListener("mouseenter", y), null === (t = le.current) || void 0 === t || t.addEventListener("mouseleave", h)), a.forEach(_ref15 => {
        let {
          event: e,
          listener: t
        } = _ref15;
        o.forEach(o => {
          var l;
          null === (l = o.current) || void 0 === l || l.addEventListener(e, t);
        });
      }), () => {
        var e, t;
        Ne.scroll && (window.removeEventListener("scroll", r), null == n || n.removeEventListener("scroll", r), null == c || c.removeEventListener("scroll", r)), Ne.resize ? window.removeEventListener("resize", r) : null == i || i(), Ne.clickOutsideAnchor && window.removeEventListener("click", He), Ne.escape && window.removeEventListener("keydown", s), R && !Ce && (null === (e = le.current) || void 0 === e || e.removeEventListener("mouseenter", y), null === (t = le.current) || void 0 === t || t.removeEventListener("mouseleave", h)), a.forEach(_ref16 => {
          let {
            event: e,
            listener: t
          } = _ref16;
          o.forEach(o => {
            var l;
            null === (l = o.current) || void 0 === l || l.removeEventListener(e, t);
          });
        });
      };
    }, [G, Pe, ye, ge, Oe, D, q, H, Le]), React$1.useEffect(() => {
      var e, t;
      let o = null !== (t = null !== (e = null == we ? void 0 : we.anchorSelect) && void 0 !== e ? e : p) && void 0 !== t ? t : "";
      !o && r && (o = `[data-tooltip-id='${r}']`);
      const l = new MutationObserver(e => {
        const t = [],
          l = [];
        e.forEach(e => {
          if ("attributes" === e.type && "data-tooltip-id" === e.attributeName) {
            e.target.getAttribute("data-tooltip-id") === r && t.push(e.target);
          }
          if ("childList" === e.type) {
            if (G) {
              const t = [...e.removedNodes].filter(e => 1 === e.nodeType);
              if (o) try {
                l.push(...t.filter(e => e.matches(o))), l.push(...t.flatMap(e => [...e.querySelectorAll(o)]));
              } catch (e) {}
              t.some(e => {
                var t;
                return !!(null === (t = null == e ? void 0 : e.contains) || void 0 === t ? void 0 : t.call(e, G)) && (he(!1), $e(!1), Z(null), ne.current && clearTimeout(ne.current), ce.current && clearTimeout(ce.current), !0);
              });
            }
            if (o) try {
              const l = [...e.addedNodes].filter(e => 1 === e.nodeType);
              t.push(...l.filter(e => e.matches(o))), t.push(...l.flatMap(e => [...e.querySelectorAll(o)]));
            } catch (e) {}
          }
        }), (t.length || l.length) && Te(e => [...e.filter(e => !l.includes(e)), ...t]);
      });
      return l.observe(document.body, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["data-tooltip-id"]
      }), () => {
        l.disconnect();
      };
    }, [r, p, null == we ? void 0 : we.anchorSelect, G]), React$1.useEffect(() => {
      Pe();
    }, [Pe]), React$1.useEffect(() => {
      if (!(null == V ? void 0 : V.current)) return () => null;
      const e = new ResizeObserver(() => {
        setTimeout(() => Pe());
      });
      return e.observe(V.current), () => {
        e.disconnect();
      };
    }, [U, null == V ? void 0 : V.current]), React$1.useEffect(() => {
      var e;
      const t = document.querySelector(`[id='${d}']`),
        o = [...Oe, t];
      G && o.includes(G) || Z(null !== (e = Oe[0]) && void 0 !== e ? e : t);
    }, [d, Oe, G]), React$1.useEffect(() => () => {
      ne.current && clearTimeout(ne.current), ce.current && clearTimeout(ce.current);
    }, []), React$1.useEffect(() => {
      var e;
      let t = null !== (e = null == we ? void 0 : we.anchorSelect) && void 0 !== e ? e : p;
      if (!t && r && (t = `[data-tooltip-id='${r}']`), t) try {
        const e = Array.from(document.querySelectorAll(t));
        Te(e);
      } catch (e) {
        Te([]);
      }
    }, [r, p, null == we ? void 0 : we.anchorSelect]);
    const Fe = null !== (oe = null == we ? void 0 : we.content) && void 0 !== oe ? oe : U,
      Ke = me && Object.keys(ue).length > 0;
    return React$1.useImperativeHandle(t, () => ({
      open: e => {
        if (null == e ? void 0 : e.anchorSelect) try {
          document.querySelector(e.anchorSelect);
        } catch (t) {
          return void console.warn(`[react-tooltip] "${e.anchorSelect}" is not a valid CSS selector`);
        }
        be(null != e ? e : null), (null == e ? void 0 : e.delay) ? je(e.delay) : $e(!0);
      },
      close: e => {
        (null == e ? void 0 : e.delay) ? Ie(e.delay) : $e(!1);
      },
      activeAnchor: G,
      place: se,
      isOpen: Boolean(ye && !T && Fe && Ke)
    })), ye && !T && Fe ? React$1.createElement(E, {
      id: r,
      role: te,
      className: y("react-tooltip", $.tooltip, j.tooltip, j[u], n, `react-tooltip__place-${se}`, $[Ke ? "show" : "closing"], Ke ? "react-tooltip__show" : "react-tooltip__closing", "fixed" === b && $.fixed, R && $.clickable),
      onTransitionEnd: e => {
        ie.current && clearTimeout(ie.current), me || "opacity" !== e.propertyName || (he(!1), be(null), null == K || K());
      },
      style: {
        ...W,
        ...ue,
        opacity: void 0 !== Q && Ke ? Q : void 0
      },
      ref: le
    }, Fe, React$1.createElement(E, {
      className: y("react-tooltip-arrow", $.arrow, j.arrow, s, L && $.noArrow),
      style: {
        ...pe,
        background: ee ? `linear-gradient(to right bottom, transparent 50%, ${ee} 50%)` : void 0
      },
      ref: re
    })) : null;
  },
  B = _ref17 => {
    let {
      content: t
    } = _ref17;
    return React$1.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: t
      }
    });
  },
  z = (e, t) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t),
  D = React$1.forwardRef((_ref18, G) => {
    let {
      id: t,
      anchorId: l,
      anchorSelect: r,
      content: n,
      html: s,
      render: a,
      className: u,
      classNameArrow: d,
      variant: p = "dark",
      place: v = "top",
      offset: m = 10,
      wrapper: f = "div",
      children: h = null,
      events: w = ["hover"],
      openOnClick: b = !1,
      positionStrategy: S = "absolute",
      middlewares: E,
      delayShow: g = 0,
      delayHide: _ = 0,
      float: A = !1,
      hidden: O = !1,
      noArrow: T = !1,
      clickable: L = !1,
      closeOnEsc: C = !1,
      closeOnScroll: R = !1,
      closeOnResize: x = !1,
      openEvents: N,
      closeEvents: $,
      globalCloseEvents: j,
      imperativeModeOnly: D = !1,
      style: q,
      position: H,
      isOpen: M,
      disableStyleInjection: W = !1,
      border: P,
      opacity: F,
      arrowColor: K,
      setIsOpen: U,
      afterShow: V,
      afterHide: X,
      role: Y = "tooltip"
    } = _ref18;
    const [Z, J] = React$1.useState(n),
      [Q, ee] = React$1.useState(s),
      [te, oe] = React$1.useState(v),
      [le, re] = React$1.useState(p),
      [ne, ce] = React$1.useState(m),
      [ie, se] = React$1.useState(g),
      [ae, ue] = React$1.useState(_),
      [de, pe] = React$1.useState(A),
      [ve, me] = React$1.useState(O),
      [fe, ye] = React$1.useState(f),
      [he, we] = React$1.useState(w),
      [be, Se] = React$1.useState(S),
      [Ee, ge] = React$1.useState(null),
      [_e, Ae] = React$1.useState(null),
      Oe = React$1.useRef(W),
      {
        anchorRefs: Te,
        activeAnchor: ke
      } = k(t),
      Le = e => null == e ? void 0 : e.getAttributeNames().reduce((t, o) => {
        var l;
        if (o.startsWith("data-tooltip-")) {
          t[o.replace(/^data-tooltip-/, "")] = null !== (l = null == e ? void 0 : e.getAttribute(o)) && void 0 !== l ? l : null;
        }
        return t;
      }, {}),
      Ce = e => {
        const t = {
          place: e => {
            var t;
            oe(null !== (t = e) && void 0 !== t ? t : v);
          },
          content: e => {
            J(null != e ? e : n);
          },
          html: e => {
            ee(null != e ? e : s);
          },
          variant: e => {
            var t;
            re(null !== (t = e) && void 0 !== t ? t : p);
          },
          offset: e => {
            ce(null === e ? m : Number(e));
          },
          wrapper: e => {
            var t;
            ye(null !== (t = e) && void 0 !== t ? t : f);
          },
          events: e => {
            const t = null == e ? void 0 : e.split(" ");
            we(null != t ? t : w);
          },
          "position-strategy": e => {
            var t;
            Se(null !== (t = e) && void 0 !== t ? t : S);
          },
          "delay-show": e => {
            se(null === e ? g : Number(e));
          },
          "delay-hide": e => {
            ue(null === e ? _ : Number(e));
          },
          float: e => {
            pe(null === e ? A : "true" === e);
          },
          hidden: e => {
            me(null === e ? O : "true" === e);
          },
          "class-name": e => {
            ge(e);
          }
        };
        Object.values(t).forEach(e => e(null)), Object.entries(e).forEach(_ref19 => {
          let [e, o] = _ref19;
          var l;
          null === (l = t[e]) || void 0 === l || l.call(t, o);
        });
      };
    React$1.useEffect(() => {
      J(n);
    }, [n]), React$1.useEffect(() => {
      ee(s);
    }, [s]), React$1.useEffect(() => {
      oe(v);
    }, [v]), React$1.useEffect(() => {
      re(p);
    }, [p]), React$1.useEffect(() => {
      ce(m);
    }, [m]), React$1.useEffect(() => {
      se(g);
    }, [g]), React$1.useEffect(() => {
      ue(_);
    }, [_]), React$1.useEffect(() => {
      pe(A);
    }, [A]), React$1.useEffect(() => {
      me(O);
    }, [O]), React$1.useEffect(() => {
      Se(S);
    }, [S]), React$1.useEffect(() => {
      Oe.current !== W && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
    }, [W]), React$1.useEffect(() => {
      "undefined" != typeof window && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", {
        detail: {
          disableCore: "core" === W,
          disableBase: W
        }
      }));
    }, []), React$1.useEffect(() => {
      var e;
      const o = new Set(Te);
      let n = r;
      if (!n && t && (n = `[data-tooltip-id='${t}']`), n) try {
        document.querySelectorAll(n).forEach(e => {
          o.add({
            current: e
          });
        });
      } catch (e) {
        console.warn(`[react-tooltip] "${n}" is not a valid CSS selector`);
      }
      const c = document.querySelector(`[id='${l}']`);
      if (c && o.add({
        current: c
      }), !o.size) return () => null;
      const i = null !== (e = null != _e ? _e : c) && void 0 !== e ? e : ke.current,
        s = new MutationObserver(e => {
          e.forEach(e => {
            var t;
            if (!i || "attributes" !== e.type || !(null === (t = e.attributeName) || void 0 === t ? void 0 : t.startsWith("data-tooltip-"))) return;
            const o = Le(i);
            Ce(o);
          });
        }),
        a = {
          attributes: !0,
          childList: !1,
          subtree: !1
        };
      if (i) {
        const e = Le(i);
        Ce(e), s.observe(i, a);
      }
      return () => {
        s.disconnect();
      };
    }, [Te, ke, _e, l, r]), React$1.useEffect(() => {
      (null == q ? void 0 : q.border) && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), P && !z("border", `${P}`) && console.warn(`[react-tooltip] "${P}" is not a valid \`border\`.`), (null == q ? void 0 : q.opacity) && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), F && !z("opacity", `${F}`) && console.warn(`[react-tooltip] "${F}" is not a valid \`opacity\`.`);
    }, []);
    let Re = h;
    const xe = React$1.useRef(null);
    if (a) {
      const t = a({
        content: null != Z ? Z : null,
        activeAnchor: _e
      });
      Re = t ? React$1.createElement("div", {
        ref: xe,
        className: "react-tooltip-content-wrapper"
      }, t) : null;
    } else Z && (Re = Z);
    Q && (Re = React$1.createElement(B, {
      content: Q
    }));
    const Ne = {
      forwardRef: G,
      id: t,
      anchorId: l,
      anchorSelect: r,
      className: y(u, Ee),
      classNameArrow: d,
      content: Re,
      contentWrapperRef: xe,
      place: te,
      variant: le,
      offset: ne,
      wrapper: fe,
      events: he,
      openOnClick: b,
      positionStrategy: be,
      middlewares: E,
      delayShow: ie,
      delayHide: ae,
      float: de,
      hidden: ve,
      noArrow: T,
      clickable: L,
      closeOnEsc: C,
      closeOnScroll: R,
      closeOnResize: x,
      openEvents: N,
      closeEvents: $,
      globalCloseEvents: j,
      imperativeModeOnly: D,
      style: q,
      position: H,
      isOpen: M,
      border: P,
      opacity: F,
      arrowColor: K,
      setIsOpen: U,
      afterShow: V,
      afterHide: X,
      activeAnchor: _e,
      setActiveAnchor: e => Ae(e),
      role: Y
    };
    return React$1.createElement(I, {
      ...Ne
    });
  });
"undefined" != typeof window && window.addEventListener("react-tooltip-inject-styles", e => {
  e.detail.disableCore || S({
    css: `:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}`,
    type: "core"
  }), e.detail.disableBase || S({
    css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`,
    type: "base"
  });
});
var img$8 = "data:image/png;base64,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";
var img$7 = "data:image/png;base64,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";
var img$6 = "data:image/png;base64,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";
var img$5 = "data:image/png;base64,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";
var css_248z$6 = ".p8wn57i{padding:10px 20px;font-size:1.6rem;line-height:18px;font-family:'OpenSans Bold',sans-serif;font-weight:600;color:#2c3b45;}.p8wn57i.blue{color:#ffffff;background-color:#007f9e;}.p8wn57i.blueText{color:#007f9e;}@media (max-width: 991px){.p8wn57i{padding:5px;}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9idWlsZHMvb3BwYS9zYWxlcy9wcm9zcGVjdHMvbGlicmFyaWVzL2ZlLXBlcnNvbmFsLXNwYWNlL3NyYy9jb21wb25lbnRzL3NoYXJlZC9QaWxzLnRzeCJdLCJuYW1lcyI6WyIucDh3bjU3aSJdLCJtYXBwaW5ncyI6IkFBS2tCQSIsImZpbGUiOiIvYnVpbGRzL29wcGEvc2FsZXMvcHJvc3BlY3RzL2xpYnJhcmllcy9mZS1wZXJzb25hbC1zcGFjZS9zcmMvY29tcG9uZW50cy9zaGFyZWQvUGlscy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgc3R5bGVkIH0gZnJvbSAnQGxpbmFyaWEvcmVhY3QnO1xuaW1wb3J0IHsgY29uZmlnIH0gZnJvbSAnQGtleXRyYWRlL2Z1bmN0aW9ucyc7XG5jb25zdCB7IGxpc3Q6IGNvbG9ycyB9ID0gY29uZmlnLmNvbG9ycztcbmNvbnN0IHsgZGV2aWNlRG93biB9ID0gY29uZmlnLmJyZWFrcG9pbnRzO1xuY29uc3QgUGlsc0Jsb2NrID0gc3R5bGVkLmRpdiBgXG4gIHBhZGRpbmc6IDEwcHggMjBweDtcbiAgZm9udC1zaXplOiAxLjZyZW07XG4gIGxpbmUtaGVpZ2h0OiAxOHB4O1xuICBmb250LWZhbWlseTogJ09wZW5TYW5zIEJvbGQnLCBzYW5zLXNlcmlmO1xuICBmb250LXdlaWdodDogNjAwO1xuXG4gIGNvbG9yOiAke2NvbG9ycy5CbHVlRGFya307XG5cbiAgJi5ibHVlIHtcbiAgICBjb2xvcjogJHtjb2xvcnMuV2hpdGV9O1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3JzLkJsdWVEYXdufTtcbiAgfVxuXG4gICYuYmx1ZVRleHQge1xuICAgIGNvbG9yOiAke2NvbG9ycy5CbHVlRGF3bn07XG4gIH1cblxuICBAbWVkaWEgJHtkZXZpY2VEb3duLnRhYmxldH0ge1xuICAgIHBhZGRpbmc6IDVweDtcbiAgfVxuYDtcbmV4cG9ydCBjb25zdCBQaWxzID0gKHsgY2hpbGRyZW4sIGJsdWUsIGJsdWVUZXh0IH0pID0+IHtcbiAgICBjb25zdCBjbGFzc2VzID0gW1xuICAgICAgICBibHVlID8gJ2JsdWUnIDogJycsXG4gICAgICAgIGJsdWVUZXh0ID8gJ2JsdWVUZXh0JyA6ICcnLFxuICAgIF0uam9pbignICcpO1xuICAgIHJldHVybiBSZWFjdC5jcmVhdGVFbGVtZW50KFBpbHNCbG9jaywgeyBjbGFzc05hbWU6IGNsYXNzZXMgfSwgY2hpbGRyZW4pO1xufTtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVBpbHMuanMubWFwIl19*/\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$6);
var PilsBlock = /*#__PURE__*/styled_default('div')({
  name: "PilsBlock",
  "class": "p8wn57i",
  propsAsIs: false
});
var Pils = function Pils(_ref) {
  var children = _ref.children,
    blue = _ref.blue,
    blueText = _ref.blueText;
  var classes = [blue ? 'blue' : '', blueText ? 'blueText' : ''].join(' ');
  return /*#__PURE__*/React$1.createElement(PilsBlock, {
    className: classes
  }, children);
};
var css_248z$5 = ".i9ofyep{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;padding:18px 0px;justify-items:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;word-wrap:break-word;white-space:pre-wrap;word-break:break-word;}.i9ofyep.not-first{border-top:1px solid #E4EBEF;}\n.t1p15ndf{margin-left:32px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}@media (max-width: 991px){.t1p15ndf{margin-left:16px;width:60%;}}\n.i1daw4s3{font-weight:bold!important;font-size:1.6rem!important;}\n.i1awbg73{color:#5A7A8E;line-height:20px;}\n.r1hk0h7j{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;margin-left:auto;margin-right:0.5rem;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}@media (max-width: 1199px){.r1hk0h7j{margin-right:-0.5rem;word-wrap:normal!important;white-space:normal!important;word-break:normal!important;}}\n.i18c24pw{margin-right:-5px;}\n.idgqdxn{display:inline-block;position:relative;width:30px;height:15px;}\n.iz2lzt0{position:absolute;}\n.s1pskdwa{font-size:1.6rem!important;color:#5A7A8E!important;}.s1pskdwa.green{color:#038153;}.s1pskdwa.red{color:#ca4036;}@media (max-width: 1199px){.s1pskdwa{font-size:1.4rem!important;}}\n/*# sourceMappingURL=data:application/json;base64,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*/\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$5);
var ItemContainer = /*#__PURE__*/styled_default('div')({
  name: "ItemContainer",
  "class": "i9ofyep",
  propsAsIs: false
});
var TitleBlock$1 = /*#__PURE__*/styled_default('div')({
  name: "TitleBlock",
  "class": "t1p15ndf",
  propsAsIs: false
});
var _exp3$1 = function _exp3() {
  return componentsTitle.Title;
};
var ItemTitle = /*#__PURE__*/styled_default(_exp3$1())({
  name: "ItemTitle",
  "class": "i1daw4s3",
  propsAsIs: true
});
var _exp4 = function _exp4() {
  return componentsParagraph.Paragraph;
};
var ItemParagraph = /*#__PURE__*/styled_default(_exp4())({
  name: "ItemParagraph",
  "class": "i1awbg73",
  propsAsIs: true
});
var RightBlock = /*#__PURE__*/styled_default('div')({
  name: "RightBlock",
  "class": "r1hk0h7j",
  propsAsIs: false
});
var ItemPils = /*#__PURE__*/styled_default('div')({
  name: "ItemPils",
  "class": "i18c24pw",
  propsAsIs: false
});
var IconContainer$1 = /*#__PURE__*/styled_default('div')({
  name: "IconContainer",
  "class": "idgqdxn",
  propsAsIs: false
});
var _exp7$1 = function _exp7() {
  return componentsIcon.Icon;
};
var InfoIcon = /*#__PURE__*/styled_default(_exp7$1())({
  name: "InfoIcon",
  "class": "iz2lzt0",
  propsAsIs: true
});
var _exp8$1 = function _exp8() {
  return componentsSpan.Span;
};
var StatusText = /*#__PURE__*/styled_default(_exp8$1())({
  name: "StatusText",
  "class": "s1pskdwa",
  propsAsIs: true
});
var FREE_TEXT_INDEX = 1;
var DocumentItem = function DocumentItem(_ref) {
  var data = _ref.data,
    first = _ref.first,
    index = _ref.index,
    handleOpen = _ref.handleOpen,
    date = _ref.date;
  var _useStore = useStore(),
    language = _useStore.language;
  var labels = locales[language];
  var fileTypeName = FILE_TYPES[data.type];
  var formattedDate = format$3(fromUnixTime(date.seconds), 'MMMM dd, yyyy');
  var _useState = React$1.useState(false),
    _useState2 = _slicedToArray$2(_useState, 2),
    isClient = _useState2[0],
    setIsClient = _useState2[1];
  React$1.useEffect(function () {
    setIsClient(true);
  }, []);
  return /*#__PURE__*/React$1.createElement(ItemContainer, {
    className: !first ? 'not-first' : ''
  }, data.status === FILE_REQUESTED && /*#__PURE__*/React$1.createElement("img", {
    src: img$6,
    width: '17',
    height: '20'
  }), data.status === FILE_PROCESSED && /*#__PURE__*/React$1.createElement("img", {
    src: img$8,
    width: '23',
    height: '25'
  }), data.status === FILE_INVALID && /*#__PURE__*/React$1.createElement("img", {
    src: img$7,
    width: '23',
    height: '25'
  }), (data.status === FILE_SUBMITTED || data.status === FILE_IN_PROGRESS) && /*#__PURE__*/React$1.createElement("img", {
    src: img$5,
    width: '23',
    height: '25'
  }), /*#__PURE__*/React$1.createElement(TitleBlock$1, null, /*#__PURE__*/React$1.createElement(ItemTitle, {
    level: 'h3',
    size: 'xxxs'
  }, labels["document_type_".concat(fileTypeName)]), /*#__PURE__*/React$1.createElement(ItemParagraph, null, data.status === FILE_PROCESSED && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(StatusText, {
    className: "green",
    size: "bodySm",
    weight: "regular"
  }, labels.validated), /*#__PURE__*/React$1.createElement(StatusText, {
    size: "bodySm",
    weight: "regular"
  }, ' • ')), data.status === FILE_INVALID && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(StatusText, {
    className: "red",
    size: "bodySm",
    weight: "regular"
  }, labels.rejected), /*#__PURE__*/React$1.createElement(StatusText, {
    size: "bodySm",
    weight: "regular"
  }, ' • ')), data.status === FILE_IN_PROGRESS && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(StatusText, {
    size: "bodySm",
    weight: "regular"
  }, labels.in_progress), /*#__PURE__*/React$1.createElement(StatusText, {
    size: "bodySm",
    weight: "regular"
  }, ' • ')), data.status === FILE_REQUESTED && /*#__PURE__*/React$1.createElement(StatusText, {
    size: "bodySm",
    weight: "regular"
  }, labels.file_format), data.status === FILE_SUBMITTED && /*#__PURE__*/React$1.createElement(StatusText, {
    size: "bodySm",
    weight: "regular"
  }, labels.pending_for_validation), (data.status === FILE_PROCESSED || data.status === FILE_INVALID) && /*#__PURE__*/React$1.createElement(StatusText, {
    size: "bodySm",
    weight: "regular"
  }, labels.uploaded_on), data.status !== FILE_REQUESTED && isClient && /*#__PURE__*/React$1.createElement(StatusText, {
    size: "bodySm",
    weight: "regular",
    style: {
      breakInside: 'auto'
    }
  }, formattedDate), !!data.refusalReason && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(IconContainer$1, {
    id: "req-tooltip-anchor-".concat(index)
  }, /*#__PURE__*/React$1.createElement(InfoIcon, {
    icon: "icn_info",
    color: "#7C919C",
    size: "20px",
    margin: "0 0 0 5px"
  })), /*#__PURE__*/React$1.createElement(D, {
    anchorSelect: "#req-tooltip-anchor-".concat(index),
    place: "top"
  }, data.refusalReason === FREE_TEXT_INDEX ? data.refusalReasonComment : labels.refusal_reasons[FILE_REFUSAL_REASON[data.refusalReason]])))), data.status === FILE_REQUESTED && /*#__PURE__*/React$1.createElement(RightBlock, {
    onClick: handleOpen
  }, /*#__PURE__*/React$1.createElement(ItemPils, null, /*#__PURE__*/React$1.createElement(Pils, {
    blueText: true
  }, labels.upload)), /*#__PURE__*/React$1.createElement(componentsIcon.Icon, {
    icon: 'icn_arrowRight',
    color: '#007f9e',
    size: '27px'
  })));
};
var css_248z$4 = ".brg3y5k{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:start;-webkit-box-align:start;-ms-flex-align:start;align-items:start;background-color:#ffffff;border-radius:6px;margin-top:20px;padding:0 28px;box-shadow:0px 4px 8px 0px rgba(0, 0, 0, 0.25);-webkit-box-shadow:0px 4px 8px 0px rgba(0, 0, 0, 0.25);-moz-box-shadow:0px 4px 8px 0px rgba(0, 0, 0, 0.25);position:relative;}@media (max-width: 991px){.brg3y5k{padding:0 12px;}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9idWlsZHMvb3BwYS9zYWxlcy9wcm9zcGVjdHMvbGlicmFyaWVzL2ZlLXBlcnNvbmFsLXNwYWNlL3NyYy9jb21wb25lbnRzL3NoYXJlZC9SZXF1ZXN0LnRzeCJdLCJuYW1lcyI6WyIuYnJnM3k1ayJdLCJtYXBwaW5ncyI6IkFBOEJjQSIsImZpbGUiOiIvYnVpbGRzL29wcGEvc2FsZXMvcHJvc3BlY3RzL2xpYnJhcmllcy9mZS1wZXJzb25hbC1zcGFjZS9zcmMvY29tcG9uZW50cy9zaGFyZWQvUmVxdWVzdC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTcGFuIH0gZnJvbSAnQGtleXRyYWRlL2NvbXBvbmVudHMtc3Bhbic7XG5pbXBvcnQgeyBjb25maWcgfSBmcm9tICdAa2V5dHJhZGUvZnVuY3Rpb25zJztcbmltcG9ydCB7IGZvcm1hdCB9IGZyb20gJ2RhdGUtZm5zJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBzdHlsZWQgfSBmcm9tICdAbGluYXJpYS9yZWFjdCc7XG5pbXBvcnQgbG9jYWxlcyBmcm9tICcuLi8uLi9sb2NhbGVzJztcbmltcG9ydCB1c2VTdG9yZSBmcm9tICcuLi8uLi9zdG9yZSc7XG5pbXBvcnQgeyBzb3J0QnlTdGF0dXMgfSBmcm9tICcuLi8uLi91dGlscy9zb3J0JztcbmltcG9ydCB7IERvY3VtZW50SXRlbSB9IGZyb20gJy4vRG9jdW1lbnRJdGVtJztcbmNvbnN0IHsgbGlzdDogY29sb3JzIH0gPSBjb25maWcuY29sb3JzO1xuY29uc3QgeyBkZXZpY2VEb3duIH0gPSBjb25maWcuYnJlYWtwb2ludHM7XG5jb25zdCBSaWdodEFsaWduZWRTcGFuID0gc3R5bGVkKFNwYW4pIGBcbiAgYWxpZ24tc2VsZjogZW5kO1xuICBtYXJnaW4tdG9wOiAxcmVtO1xuICBmb250LXNpemU6IDAuOXJlbTtcbmA7XG5jb25zdCBJbmZvQ29udGFpbmVyID0gc3R5bGVkLmRpdiBgXG4gIHBhZGRpbmc6IDEuMnJlbTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcnMuR3JleTIwU21va2V9O1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGJvdHRvbTogMDtcbiAgbGVmdDogMDtcbiAgcmlnaHQ6IDA7XG4gIGJvcmRlci1yYWRpdXM6IDBweCAwcHggNnB4IDZweDtcbiAgdGV4dC1hbGlnbjogcmlnaHQ7XG5cbiAgQG1lZGlhICR7ZGV2aWNlRG93bi5tb2JpbGVMfSB7XG4gICAgdGV4dC1hbGlnbjogbGVmdDtcbiAgfVxuYDtcbmNvbnN0IEJsb2NrID0gc3R5bGVkLmRpdiBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGFsaWduLWl0ZW1zOiBzdGFydDtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcnMuV2hpdGV9O1xuICBib3JkZXItcmFkaXVzOiA2cHg7XG4gIG1hcmdpbi10b3A6IDIwcHg7XG4gIHBhZGRpbmc6IDAgMjhweDtcbiAgYm94LXNoYWRvdzogMHB4IDRweCA4cHggMHB4IHJnYmEoMCwgMCwgMCwgMC4yNSk7XG4gIC13ZWJraXQtYm94LXNoYWRvdzogMHB4IDRweCA4cHggMHB4IHJnYmEoMCwgMCwgMCwgMC4yNSk7XG4gIC1tb3otYm94LXNoYWRvdzogMHB4IDRweCA4cHggMHB4IHJnYmEoMCwgMCwgMCwgMC4yNSk7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcblxuICBAbWVkaWEgJHtkZXZpY2VEb3duLnRhYmxldH0ge1xuICAgIHBhZGRpbmc6IDAgMTJweDtcbiAgfVxuYDtcbmV4cG9ydCBjb25zdCBSZXF1ZXN0ID0gKHsgaGFuZGxlT3BlblBhbmVsLCByZXF1ZXN0IH0pID0+IHtcbiAgICB2YXIgX2EsIF9iLCBfYywgX2QsIF9lO1xuICAgIGNvbnN0IHsgbGFuZ3VhZ2UgfSA9IHVzZVN0b3JlKCk7XG4gICAgY29uc3QgbGFiZWxzID0gbG9jYWxlc1tsYW5ndWFnZV07XG4gICAgY29uc3QgcmVxdWVzdENyZWF0aW9uRGF0ZSA9IHJlcXVlc3QgPyBmb3JtYXQocmVxdWVzdC5jcmVhdGVkT24uc2Vjb25kcyAqIDEwMDAsICdkZC9NTS95eXl5JykgOiAnJztcbiAgICBjb25zdCBkb2N1bWVudEl0ZW1zID0gKF9jID0gKF9iID0gKF9hID0gcmVxdWVzdCA9PT0gbnVsbCB8fCByZXF1ZXN0ID09PSB2b2lkIDAgPyB2b2lkIDAgOiByZXF1ZXN0LmZpbGVzTGlzdCkgPT09IG51bGwgfHwgX2EgPT09IHZvaWQgMCA/IHZvaWQgMCA6IF9hLnNvcnQoc29ydEJ5U3RhdHVzKSkgPT09IG51bGwgfHwgX2IgPT09IHZvaWQgMCA/IHZvaWQgMCA6IF9iLm1hcCgoaXRlbSwgaSkgPT4gKFJlYWN0LmNyZWF0ZUVsZW1lbnQoRG9jdW1lbnRJdGVtLCB7IGtleTogYHJlcWxpc3Qke2l9YCwgZGF0YTogaXRlbSwgZmlyc3Q6IGkgPT09IDAsIGluZGV4OiBpLCBoYW5kbGVPcGVuOiAoKSA9PiBoYW5kbGVPcGVuUGFuZWwoaSksIGRhdGU6IChyZXF1ZXN0ID09PSBudWxsIHx8IHJlcXVlc3QgPT09IHZvaWQgMCA/IHZvaWQgMCA6IHJlcXVlc3QudXBkYXRlZE9uKSA/IHJlcXVlc3QudXBkYXRlZE9uIDogcmVxdWVzdCA9PT0gbnVsbCB8fCByZXF1ZXN0ID09PSB2b2lkIDAgPyB2b2lkIDAgOiByZXF1ZXN0LmNyZWF0ZWRPbiB9KSkpKSAhPT0gbnVsbCAmJiBfYyAhPT0gdm9pZCAwID8gX2MgOiBbXTtcbiAgICByZXR1cm4gKFJlYWN0LmNyZWF0ZUVsZW1lbnQoXCJkaXZcIiwgbnVsbCxcbiAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChTcGFuLCB7IHNpemU6ICdib2R5U20nLCBjb2xvcjogJ0dyZXlCbHVlJywgd2VpZ2h0OiAnYm9sZCcgfSwgKF9kID0gcmVxdWVzdCA9PT0gbnVsbCB8fCByZXF1ZXN0ID09PSB2b2lkIDAgPyB2b2lkIDAgOiByZXF1ZXN0LmZpbGVzTGlzdCkgPT09IG51bGwgfHwgX2QgPT09IHZvaWQgMCA/IHZvaWQgMCA6XG4gICAgICAgICAgICBfZC5sZW5ndGgsXG4gICAgICAgICAgICBcIiBcIixcbiAgICAgICAgICAgIGxhYmVscy5yZXF1ZXN0ZWRfZG9jdW1lbnRzLnRvVXBwZXJDYXNlKCkpLFxuICAgICAgICAhIXJlcXVlc3QgJiYgISEoKF9lID0gcmVxdWVzdCA9PT0gbnVsbCB8fCByZXF1ZXN0ID09PSB2b2lkIDAgPyB2b2lkIDAgOiByZXF1ZXN0LmZpbGVzTGlzdCkgPT09IG51bGwgfHwgX2UgPT09IHZvaWQgMCA/IHZvaWQgMCA6IF9lLmxlbmd0aCkgJiYgKFJlYWN0LmNyZWF0ZUVsZW1lbnQoTGlzdCwgbnVsbCwgISEocmVxdWVzdCA9PT0gbnVsbCB8fCByZXF1ZXN0ID09PSB2b2lkIDAgPyB2b2lkIDAgOiByZXF1ZXN0LmZpbGVzTGlzdC5sZW5ndGgpICYmIFtcbiAgICAgICAgICAgIC4uLmRvY3VtZW50SXRlbXNcbiAgICAgICAgXSkpKSk7XG59O1xuY29uc3QgTGlzdCA9ICh7IGNoaWxkcmVuIH0pID0+IHtcbiAgICByZXR1cm4gKFJlYWN0LmNyZWF0ZUVsZW1lbnQoUmVhY3QuRnJhZ21lbnQsIG51bGwsXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoQmxvY2ssIG51bGwsIGNoaWxkcmVuKSkpO1xufTtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVJlcXVlc3QuanMubWFwIl19*/\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$4);
var Block = /*#__PURE__*/styled_default('div')({
  name: "Block",
  "class": "brg3y5k",
  propsAsIs: false
});
var Request = function Request(_ref) {
  var handleOpenPanel = _ref.handleOpenPanel,
    request = _ref.request;
  var _a, _b, _c, _d, _e;
  var _useStore = useStore(),
    language = _useStore.language;
  var labels = locales[language];
  request ? format$3(request.createdOn.seconds * 1000, 'dd/MM/yyyy') : '';
  var documentItems = (_c = (_b = (_a = request === null || request === void 0 ? void 0 : request.filesList) === null || _a === void 0 ? void 0 : _a.sort(sortByStatus)) === null || _b === void 0 ? void 0 : _b.map(function (item, i) {
    return /*#__PURE__*/React$1.createElement(DocumentItem, {
      key: "reqlist".concat(i),
      data: item,
      first: i === 0,
      index: i,
      handleOpen: function handleOpen() {
        return handleOpenPanel(i);
      },
      date: (request === null || request === void 0 ? void 0 : request.updatedOn) ? request.updatedOn : request === null || request === void 0 ? void 0 : request.createdOn
    });
  })) !== null && _c !== void 0 ? _c : [];
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(componentsSpan.Span, {
    size: 'bodySm',
    color: 'GreyBlue',
    weight: 'bold'
  }, (_d = request === null || request === void 0 ? void 0 : request.filesList) === null || _d === void 0 ? void 0 : _d.length, " ", labels.requested_documents.toUpperCase()), !!request && !!((_e = request === null || request === void 0 ? void 0 : request.filesList) === null || _e === void 0 ? void 0 : _e.length) && /*#__PURE__*/React$1.createElement(List, null, !!(request === null || request === void 0 ? void 0 : request.filesList.length) && _toConsumableArray$3(documentItems)));
};
var List = function List(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Block, null, children));
};
var css_248z$3 = ".crb8hc3{text-align:center;}\n.ply3ytb{padding:1rem;}\n.crbz63u{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;width:100%;margin:0 auto;text-align:center;padding:10px;position:relative;text-align:left;gap:1.5rem;margin-top:24px;}@media (max-width: 767px){.crbz63u{width:90%;}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9idWlsZHMvb3BwYS9zYWxlcy9wcm9zcGVjdHMvbGlicmFyaWVzL2ZlLXBlcnNvbmFsLXNwYWNlL3NyYy9jb21wb25lbnRzL3NoYXJlZC9zdHlsZWQudHN4Il0sIm5hbWVzIjpbIi5jcmI4aGMzIiwiLnBseTN5dGIiLCIuY3JiejYzdSJdLCJtYXBwaW5ncyI6IkFBTXdCQTtBQU9MQztBQU9HQyIsImZpbGUiOiIvYnVpbGRzL29wcGEvc2FsZXMvcHJvc3BlY3RzL2xpYnJhcmllcy9mZS1wZXJzb25hbC1zcGFjZS9zcmMvY29tcG9uZW50cy9zaGFyZWQvc3R5bGVkLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IExpbmsgfSBmcm9tICdAa2V5dHJhZGUvY29tcG9uZW50cy1saW5rJztcbmltcG9ydCB7IFBhcmFncmFwaCB9IGZyb20gJ0BrZXl0cmFkZS9jb21wb25lbnRzLXBhcmFncmFwaCc7XG5pbXBvcnQgeyBjb25maWcgfSBmcm9tICdAa2V5dHJhZGUvZnVuY3Rpb25zJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBzdHlsZWQgfSBmcm9tICdAbGluYXJpYS9yZWFjdCc7XG5jb25zdCB7IGRldmljZURvd24gfSA9IGNvbmZpZy5icmVha3BvaW50cztcbmNvbnN0IENlbnRlcmVkVGV4dERpdiA9IHN0eWxlZC5kaXYgYFxuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG5gO1xuZXhwb3J0IGNvbnN0IFN0eWxlZFBhcmFncmFwaExpZ2h0R3JleSA9IChwcm9wcykgPT4ge1xuICAgIHJldHVybiAoUmVhY3QuY3JlYXRlRWxlbWVudChDZW50ZXJlZFRleHREaXYsIG51bGwsXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoUGFyYWdyYXBoLCB7IHNpemU6ICdzbScsIGNvbG9yOiAnR3JleUJsdWUnIH0sIHByb3BzLmNoaWxkcmVuKSkpO1xufTtcbmNvbnN0IFBhZGRlZExpbmsgPSBzdHlsZWQoTGluaykgYFxuICBwYWRkaW5nOiAxcmVtO1xuYDtcbmV4cG9ydCBjb25zdCBTdHlsZWRMaW5rID0gKHByb3BzKSA9PiB7XG4gICAgcmV0dXJuIChSZWFjdC5jcmVhdGVFbGVtZW50KFBhZGRlZExpbmssIG51bGwsXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoTGluaywgT2JqZWN0LmFzc2lnbih7fSwgcHJvcHMpLCBwcm9wcy5jaGlsZHJlbikpKTtcbn07XG5leHBvcnQgY29uc3QgQ29sdW1uID0gc3R5bGVkLmRpdiBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIHdpZHRoOiAxMDAlO1xuICBtYXJnaW46IDAgYXV0bztcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBwYWRkaW5nOiAxMHB4O1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIHRleHQtYWxpZ246IGxlZnQ7XG4gIGdhcDogMS41cmVtO1xuICBtYXJnaW4tdG9wOiAyNHB4O1xuXG4gIEBtZWRpYSAke2RldmljZURvd24ubW9iaWxlTH0ge1xuICAgIHdpZHRoOiA5MCU7XG4gIH1cbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1zdHlsZWQuanMubWFwIl19*/\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$3);
var CenteredTextDiv = /*#__PURE__*/styled_default('div')({
  name: "CenteredTextDiv",
  "class": "crb8hc3",
  propsAsIs: false
});
var StyledParagraphLightGrey = function StyledParagraphLightGrey(props) {
  return /*#__PURE__*/React$1.createElement(CenteredTextDiv, null, /*#__PURE__*/React$1.createElement(componentsParagraph.Paragraph, {
    size: 'sm',
    color: 'GreyBlue'
  }, props.children));
};
var _exp$2 = function _exp() {
  return componentsLink.Link;
};
var PaddedLink = /*#__PURE__*/styled_default(_exp$2())({
  name: "PaddedLink",
  "class": "ply3ytb",
  propsAsIs: true
});
var StyledLink = function StyledLink(props) {
  return /*#__PURE__*/React$1.createElement(PaddedLink, null, /*#__PURE__*/React$1.createElement(componentsLink.Link, Object.assign({}, props), props.children));
};
var Column = /*#__PURE__*/styled_default('div')({
  name: "Column",
  "class": "crbz63u",
  propsAsIs: false
});
var COMMON_MIME_TYPES = new Map([
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
['aac', 'audio/aac'], ['abw', 'application/x-abiword'], ['arc', 'application/x-freearc'], ['avif', 'image/avif'], ['avi', 'video/x-msvideo'], ['azw', 'application/vnd.amazon.ebook'], ['bin', 'application/octet-stream'], ['bmp', 'image/bmp'], ['bz', 'application/x-bzip'], ['bz2', 'application/x-bzip2'], ['cda', 'application/x-cdf'], ['csh', 'application/x-csh'], ['css', 'text/css'], ['csv', 'text/csv'], ['doc', 'application/msword'], ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'], ['eot', 'application/vnd.ms-fontobject'], ['epub', 'application/epub+zip'], ['gz', 'application/gzip'], ['gif', 'image/gif'], ['heic', 'image/heic'], ['heif', 'image/heif'], ['htm', 'text/html'], ['html', 'text/html'], ['ico', 'image/vnd.microsoft.icon'], ['ics', 'text/calendar'], ['jar', 'application/java-archive'], ['jpeg', 'image/jpeg'], ['jpg', 'image/jpeg'], ['js', 'text/javascript'], ['json', 'application/json'], ['jsonld', 'application/ld+json'], ['mid', 'audio/midi'], ['midi', 'audio/midi'], ['mjs', 'text/javascript'], ['mp3', 'audio/mpeg'], ['mp4', 'video/mp4'], ['mpeg', 'video/mpeg'], ['mpkg', 'application/vnd.apple.installer+xml'], ['odp', 'application/vnd.oasis.opendocument.presentation'], ['ods', 'application/vnd.oasis.opendocument.spreadsheet'], ['odt', 'application/vnd.oasis.opendocument.text'], ['oga', 'audio/ogg'], ['ogv', 'video/ogg'], ['ogx', 'application/ogg'], ['opus', 'audio/opus'], ['otf', 'font/otf'], ['png', 'image/png'], ['pdf', 'application/pdf'], ['php', 'application/x-httpd-php'], ['ppt', 'application/vnd.ms-powerpoint'], ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'], ['rar', 'application/vnd.rar'], ['rtf', 'application/rtf'], ['sh', 'application/x-sh'], ['svg', 'image/svg+xml'], ['swf', 'application/x-shockwave-flash'], ['tar', 'application/x-tar'], ['tif', 'image/tiff'], ['tiff', 'image/tiff'], ['ts', 'video/mp2t'], ['ttf', 'font/ttf'], ['txt', 'text/plain'], ['vsd', 'application/vnd.visio'], ['wav', 'audio/wav'], ['weba', 'audio/webm'], ['webm', 'video/webm'], ['webp', 'image/webp'], ['woff', 'font/woff'], ['woff2', 'font/woff2'], ['xhtml', 'application/xhtml+xml'], ['xls', 'application/vnd.ms-excel'], ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'], ['xml', 'application/xml'], ['xul', 'application/vnd.mozilla.xul+xml'], ['zip', 'application/zip'], ['7z', 'application/x-7z-compressed'],
// Others
['mkv', 'video/x-matroska'], ['mov', 'video/quicktime'], ['msg', 'application/vnd.ms-outlook']]);
function toFileWithPath(file, path) {
  var f = withMimeType(file);
  if (typeof f.path !== 'string') {
    // on electron, path is already set to the absolute path
    var webkitRelativePath = file.webkitRelativePath;
    Object.defineProperty(f, 'path', {
      value: typeof path === 'string' ? path
      // If <input webkitdirectory> is set,
      // the File will have a {webkitRelativePath} property
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
      : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
      writable: false,
      configurable: false,
      enumerable: true
    });
  }
  return f;
}
function withMimeType(file) {
  var name = file.name;
  var hasExtension = name && name.lastIndexOf('.') !== -1;
  if (hasExtension && !file.type) {
    var ext = name.split('.').pop().toLowerCase();
    var type = COMMON_MIME_TYPES.get(ext);
    if (type) {
      Object.defineProperty(file, 'type', {
        value: type,
        writable: false,
        configurable: false,
        enumerable: true
      });
    }
  }
  return file;
}
var FILES_TO_IGNORE = [
// Thumbnail cache files for macOS and Windows
'.DS_Store', 'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
        return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
      } else if (isChangeEvt(evt)) {
        return [2 /*return*/, getInputFiles(evt)];
      } else if (Array.isArray(evt) && evt.every(function (item) {
        return 'getFile' in item && typeof item.getFile === 'function';
      })) {
        return [2 /*return*/, getFsHandleFiles(evt)];
      }
      return [2 /*return*/, []];
    });
  });
}
function isDataTransfer(value) {
  return isObject(value);
}
function isChangeEvt(value) {
  return isObject(value) && isObject(value.target);
}
function isObject(v) {
  return _typeof$1(v) === 'object' && v !== null;
}
function getInputFiles(evt) {
  return fromList(evt.target.files).map(function (file) {
    return toFileWithPath(file);
  });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
  return __awaiter(this, void 0, void 0, function () {
    var files;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, Promise.all(handles.map(function (h) {
            return h.getFile();
          }))];
        case 1:
          files = _a.sent();
          return [2 /*return*/, files.map(function (file) {
            return toFileWithPath(file);
          })];
      }
    });
  });
}
function getDataTransferFiles(dt, type) {
  return __awaiter(this, void 0, void 0, function () {
    var items, files;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!dt.items) return [3 /*break*/, 2];
          items = fromList(dt.items).filter(function (item) {
            return item.kind === 'file';
          });
          // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
          // only 'dragstart' and 'drop' has access to the data (source node)
          if (type !== 'drop') {
            return [2 /*return*/, items];
          }
          return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
        case 1:
          files = _a.sent();
          return [2 /*return*/, noIgnoredFiles(flatten(files))];
        case 2:
          return [2 /*return*/, noIgnoredFiles(fromList(dt.files).map(function (file) {
            return toFileWithPath(file);
          }))];
      }
    });
  });
}
function noIgnoredFiles(files) {
  return files.filter(function (file) {
    return FILES_TO_IGNORE.indexOf(file.name) === -1;
  });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
  if (items === null) {
    return [];
  }
  var files = [];
  // tslint:disable: prefer-for-of
  for (var i = 0; i < items.length; i++) {
    var file = items[i];
    files.push(file);
  }
  return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
  if (typeof item.webkitGetAsEntry !== 'function') {
    return fromDataTransferItem(item);
  }
  var entry = item.webkitGetAsEntry();
  // Safari supports dropping an image node from a different window and can be retrieved using
  // the DataTransferItem.getAsFile() API
  // NOTE: FileSystemEntry.file() throws if trying to get the file
  if (entry && entry.isDirectory) {
    return fromDirEntry(entry);
  }
  return fromDataTransferItem(item);
}
function flatten(items) {
  return items.reduce(function (acc, files) {
    return __spreadArray(__spreadArray([], __read(acc), false), __read(Array.isArray(files) ? flatten(files) : [files]), false);
  }, []);
}
function fromDataTransferItem(item) {
  var file = item.getAsFile();
  if (!file) {
    return Promise.reject("".concat(item, " is not a File"));
  }
  var fwp = toFileWithPath(file);
  return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
    });
  });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
  var reader = entry.createReader();
  return new Promise(function (resolve, reject) {
    var entries = [];
    function readEntries() {
      var _this = this;
      // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
      // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
      reader.readEntries(function (batch) {
        return __awaiter(_this, void 0, void 0, function () {
          var files, err_1, items;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!!batch.length) return [3 /*break*/, 5];
                _a.label = 1;
              case 1:
                _a.trys.push([1, 3,, 4]);
                return [4 /*yield*/, Promise.all(entries)];
              case 2:
                files = _a.sent();
                resolve(files);
                return [3 /*break*/, 4];
              case 3:
                err_1 = _a.sent();
                reject(err_1);
                return [3 /*break*/, 4];
              case 4:
                return [3 /*break*/, 6];
              case 5:
                items = Promise.all(batch.map(fromEntry));
                entries.push(items);
                // Continue reading
                readEntries();
                _a.label = 6;
              case 6:
                return [2 /*return*/];
            }
          });
        });
      }, function (err) {
        reject(err);
      });
    }
    readEntries();
  });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2 /*return*/, new Promise(function (resolve, reject) {
        entry.file(function (file) {
          var fwp = toFileWithPath(file, entry.fullPath);
          resolve(fwp);
        }, function (err) {
          reject(err);
        });
      })];
    });
  });
}
var _default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    if (acceptedFilesArray.length === 0) {
      return true;
    }
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();
      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }
      return mimeType === validType;
    });
  }
  return true;
};
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}
var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || _default(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }
  return [true, null];
}
function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string|string[]} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */

function allFilesAccepted(_ref) {
  var files = _ref.files,
    accept = _ref.accept,
    minSize = _ref.minSize,
    maxSize = _ref.maxSize,
    multiple = _ref.multiple,
    maxFiles = _ref.maxFiles,
    validator = _ref.validator;
  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }
  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
      _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
      accepted = _fileAccepted2[0];
    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
      _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
      sizeMatch = _fileMatchSize2[0];
    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }
  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file

  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}
function onDocumentDragOver(event) {
  event.preventDefault();
}
function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }
      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray$1(_ref2, 2),
        mimeType = _ref3[0],
        ext = _ref3[1];
      var ok = true;
      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }
      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }
      return ok;
    }).reduce(function (agg, _ref4) {
      var _ref5 = _slicedToArray$1(_ref4, 2),
        mimeType = _ref5[0],
        ext = _ref5[1];
      return _objectSpread$1(_objectSpread$1({}, agg), {}, _defineProperty$1({}, mimeType, ext));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: acceptForPicker
    }];
  }
  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray$1(_ref6, 2),
        mimeType = _ref7[0],
        ext = _ref7[1];
      return [].concat(_toConsumableArray$1(a), [mimeType], _toConsumableArray$1(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }
  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */

var _excluded = ["children"],
  _excluded2 = ["open"],
  _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
  _excluded4 = ["refKey", "onChange", "onClick"];
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/React$1.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    params = _objectWithoutProperties(_ref, _excluded);
  var _useDropzone = useDropzone(params),
    open = _useDropzone.open,
    props = _objectWithoutProperties(_useDropzone, _excluded2);
  React$1.useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes$1.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes$1.objectOf(PropTypes$1.arrayOf(PropTypes$1.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes$1.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes$1.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes$1.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes$1.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes$1.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes$1.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes$1.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes$1.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes$1.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes$1.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes$1.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes$1.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes$1.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes$1.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes$1.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes$1.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes$1.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes$1.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes$1.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes$1.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes$1.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes$1.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes$1.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    accept = _defaultProps$props.accept,
    disabled = _defaultProps$props.disabled,
    getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
    maxSize = _defaultProps$props.maxSize,
    minSize = _defaultProps$props.minSize,
    multiple = _defaultProps$props.multiple,
    maxFiles = _defaultProps$props.maxFiles,
    onDragEnter = _defaultProps$props.onDragEnter,
    onDragLeave = _defaultProps$props.onDragLeave,
    onDragOver = _defaultProps$props.onDragOver,
    onDrop = _defaultProps$props.onDrop,
    onDropAccepted = _defaultProps$props.onDropAccepted,
    onDropRejected = _defaultProps$props.onDropRejected,
    onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
    onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
    useFsAccessApi = _defaultProps$props.useFsAccessApi,
    autoFocus = _defaultProps$props.autoFocus,
    preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
    noClick = _defaultProps$props.noClick,
    noKeyboard = _defaultProps$props.noKeyboard,
    noDrag = _defaultProps$props.noDrag,
    noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
    onError = _defaultProps$props.onError,
    validator = _defaultProps$props.validator;
  var acceptAttr = React$1.useMemo(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = React$1.useMemo(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = React$1.useMemo(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = React$1.useMemo(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = React$1.useRef(null);
  var inputRef = React$1.useRef(null);
  var _useReducer = React$1.useReducer(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var isFocused = state.isFocused,
    isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = React$1.useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;
          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };
  React$1.useEffect(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = React$1.useRef([]);
  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }
    event.preventDefault();
    dragTargetsRef.current = [];
  };
  React$1.useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }
    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]); // Auto focus the root when autoFocus is true

  React$1.useEffect(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }
    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = React$1.useCallback(function (e) {
    if (onError) {
      onError(e);
    } else {
      // Let the user know something's gone wrong if they haven't provided the onError cb.
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = React$1.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });
        if (onDragEnter) {
          onDragEnter(event);
        }
      })["catch"](function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = React$1.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);
    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */
    }
    if (hasFiles && onDragOver) {
      onDragOver(event);
    }
    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = React$1.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);
    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }
    dragTargetsRef.current = targets;
    if (targets.length > 0) {
      return;
    }
    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });
    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = React$1.useCallback(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
        _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
        accepted = _fileAccepted2[0],
        acceptError = _fileAccepted2[1];
      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
        sizeMatch = _fileMatchSize2[0],
        sizeError = _fileMatchSize2[1];
      var customErrors = validator ? validator(file) : null;
      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];
        if (customErrors) {
          errors = errors.concat(customErrors);
        }
        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });
    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }
    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });
    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }
    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }
    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = React$1.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        setFiles(files, event);
      })["catch"](function (e) {
        return onErrCb(e);
      });
    }
    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = React$1.useCallback(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      })["catch"](function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }
    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = React$1.useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }
    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = React$1.useCallback(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = React$1.useCallback(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = React$1.useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450

    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);
  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };
  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };
  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };
  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };
  var getRootProps = React$1.useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$refKey = _ref2.refKey,
        refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
        role = _ref2.role,
        onKeyDown = _ref2.onKeyDown,
        onFocus = _ref2.onFocus,
        onBlur = _ref2.onBlur,
        onClick = _ref2.onClick,
        onDragEnter = _ref2.onDragEnter,
        onDragOver = _ref2.onDragOver,
        onDragLeave = _ref2.onDragLeave,
        onDrop = _ref2.onDrop,
        rest = _objectWithoutProperties(_ref2, _excluded3);
      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = React$1.useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = React$1.useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$refKey = _ref3.refKey,
        refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
        onChange = _ref3.onChange,
        onClick = _ref3.onClick,
        rest = _objectWithoutProperties(_ref3, _excluded4);
      var inputProps = _defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);
      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread(_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });
    case "blur":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });
    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });
    case "closeDialog":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });
    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });
    case "setFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });
    case "reset":
      return _objectSpread({}, initialState);
    default:
      return state;
  }
}
function noop() {}
var img$4 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QA/wD/AP+gvaeTAAABwElEQVQ4ja2TPWhUQRSFvzs7m3T+oJV2kixoqYZgZSFaKSnSJ7Iu2FkqoiQvYQWtxM7CvHVbS0FSWKUXbSyyEO208KdYBF2TN3NTbPb9+3yCt5p775xzz5yZgf8c8sdOEN5GuQccyiG+43nAevtxfcL7vVmMDjC8wMu7LELPoyzi9TTdG4Mi4d3+Mabd4UzVcxEhRLgMfMxBWqhuorQxbGVavxtDy5TbRjleqlt5XZSvkz3hZBnHlPtmEXcJb05iZBblCchDlLelVuTD6DmUO6jcAr+D8Z8SD4N+C3UD1F9lvfOqFuFK7xqiL3Fmhu71DwCmFvAfIiGMfN4RWA03WAmX4zzYWCLoPatHaE3xCQkXEM7GuTKP6nwVoa1qotpAcm9VaNRTWHZkkQYqeeWVIqovRRFEi4NitB8Ps4mYlIduXDQlXv4tIldCGNlx0WeOOAIzSlL5CexWcSd+WK+FryR+gV/ua0K/16U5/bTIYmNk9S0HnZ1M/ujmEBjGuZfxG9grOzI2OlgcqRySDqNHAWiqm5RSfqmw2nsDnAE+16Q8AbxnrT0Xy0p6ouz2r9D0HURPlcKFH0CUKnwB9zy9ZR9p55HcELH7KQAAAABJRU5ErkJggg==";
var img$3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAAhklEQVQokZ3RMQ7CMBBEUR8DKdwCFK5OOIMpkiJFuEsejUEIbGWJK0s7/9uaTbgho0uBgw4ThlQusGwJCriUfE44YN4SNHOVwTEENgKPlyD6s5rgHAIbpQiDH4IL1gKu6KPgvpcr5Zz2lPUO/rumn0BzHt1jNYd7tJSvMqeEAWN0j0WQcX0Cj3XCjNQzFCcAAAAASUVORK5CYII=";
var img$2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAA5FBMVEUAAAAAAP8AgIAAVaoAdKIAgJUAgKQAeaEAgJkAeZ4AgKIAgJ0AgJsAe54AgKIAe5wAgJ4AgKEAfJ0AgJ4AfZ0AgJ4Afp4Afp0AgJ8AfpwAfp0Afp0AgJ4Afp8Afp4AgJ8Afp0AgJ4AgJ0Af54Af54Af50AgJ8AgJ0Af54Af54Af54AgJ8Af54AgJ4AgJ8Af58AgJ4Af54AgJ4Af58AgJ0AgJ4Af54AgJ4AgJ4AgJ8AgJ4Af54AgJ8AgJ4Af54Af54Af54AgJ4AgJ4Af54Af54AgJ4Af54AgJ4Af54Afp4Af57///9XKc12AAAASnRSTlMAAQIDCwwOExQVFhocHR4fIiYnKi9ER0lKS1FTVFVXYmtscIGDhYqSm6GprK2utLm6u8DBxMzV1tze4uXm6O3v8fL09ff6+/z9/se+sfkAAAABYktHREtpC4VQAAAAv0lEQVQYGQXBiSICQQAA0LdCcrZyRTly5ijC2Iyz2tL8/wd5DwAAQNbqf82L6y0AWOqlyfNDkcbHAGS9dFcjO/qY7QJopXtg57dYblSB/qQGOE9/af6Uw9cAYLt8ubidxQ2UfQCLOEw3KIYZAHh9x2U6AACP31j/+cyhWgVrowE0Z+MT8hhzKs23+T7YGw7kMaWYu0qTUwD1OB2NprHeONsEoFO2Q2iXHQBQWRWClQUAgBAAABACAAC6XQAAAOAfZwEXXT3f0BgAAAAASUVORK5CYII=";
var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAolBMVEUAAAB3mZmAj594lpaAjJl6j5l8kpmAjpx9k5x8kp16kpx8kJ19kJt7kZx9kp18kpx7kZt7kpx9kpt8kZx8kJx9kZx8kJx8kZ18kZx8kZt8kZx9kpx8kZ19kZt8kZx7kp18kpx8kZx8kZx8kZ18kZx8kpt8kZx9kZx7kpx7kZx8kZx8kZt8kZx8kZx8kZx8kZx8kZx8kZx8kZx8kZx8kZz///83MBSPAAAANHRSTlMADxARFBkjJDtGS05cXWB3eHyFhoiJmJ6jpKeqq661uL/DyMrMzdjZ293e5Obn6u7z+Pn+S0hBzwAAAAFiS0dENd622WsAAACRSURBVBjTldFbE8EwEIbhz6nOquoUixYp6hRt9///Nhc2xGCM9/LJbDKTBepJwdKhCUmZ0fDelbOWYBzb49NsnbffcFyy6iKsPvE4AcqbrCHY13pVwzxPtumZF4I9IlVFJSQiusQv487DXzEkaeDgMpWiX+MfsetLHQd39vP2f9+pTOA7BWYKwNOPdTAzF9rDDSWlGUQSertSAAAAAElFTkSuQmCC";
var useFetchContract = function useFetchContract(env, canFetch) {
  var _useStore = useStore(),
    contractData = _useStore.contractData,
    setContract = _useStore.setContract,
    setError = _useStore.setError;
  React$1.useEffect(function () {
    var getContractCall = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return REQUESTS.getContract(env);
            case 3:
              result = _context.sent;
              if (!(result.contractId <= 0)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              setContract(result);
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              setError(_context.t0.message);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      }));
      return function getContractCall() {
        return _ref.apply(this, arguments);
      };
    }();
    if (canFetch == 8) {
      getContractCall();
    }
  }, [canFetch]);
  return contractData;
};
var css_248z$2 = "@-webkit-keyframes fadeIn-f1y83iw6{from{opacity:0;}to{opacity:1;}}@keyframes fadeIn-f1y83iw6{from{opacity:0;}to{opacity:1;}}\n@-webkit-keyframes fadeOut-fhcjx40{from{opacity:1;}to{opacity:0;}}@keyframes fadeOut-fhcjx40{from{opacity:1;}to{opacity:0;}}\n@-webkit-keyframes slideIn-s16qfrov{from{right:-908px;}to{right:0;}}@keyframes slideIn-s16qfrov{from{right:-908px;}to{right:0;}}\n@-webkit-keyframes slideOut-s64k89g{from{right:0;}to{right:-908px;}}@keyframes slideOut-s64k89g{from{right:0;}to{right:-908px;}}\n@-webkit-keyframes inBtn-i18sqvvi{from{right:-44px;}to{right:864px;}}@keyframes inBtn-i18sqvvi{from{right:-44px;}to{right:864px;}}\n@-webkit-keyframes outBtn-o1us3wur{from{right:864px;}to{right:-44px;}}@keyframes outBtn-o1us3wur{from{right:864px;}to{right:-44px;}}\n.pw6sypt{visibility:var(--pw6sypt-0);-webkit-animation:var(--pw6sypt-1) 0.5s linear;animation:var(--pw6sypt-1) 0.5s linear;-webkit-transition:visibility 0.5s linear;transition:visibility 0.5s linear;position:fixed;height:100%;width:840px;top:0;right:0;background-color:#ffffff;z-index:99999;overflow:auto;}@media (max-width: 991px){.pw6sypt{margin-top:80px;width:100%;height:100%;}}\n.b80pwr6{visibility:var(--b80pwr6-0);-webkit-animation:var(--b80pwr6-1) 0.25s linear;animation:var(--b80pwr6-1) 0.25s linear;-webkit-transition:visibility 0.25s linear;transition:visibility 0.25s linear;position:fixed;top:0;bottom:0;right:0;left:0;width:100%;height:100%;background-color:rgba(60, 84, 99, 0.5);z-index:9999;}\n.c1jiu3a9{visibility:var(--c1jiu3a9-0);-webkit-animation:var(--c1jiu3a9-1) 0.5s linear;animation:var(--c1jiu3a9-1) 0.5s linear;-webkit-transition:visibility 0.5s linear;transition:visibility 0.5s linear;height:44px;width:44px;background-color:#2c3b45;border-radius:22px;position:absolute;top:32px;right:864px;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-justify-content:center;justify-content:center;z-index:99999;}@media (max-width: 991px){.c1jiu3a9{top:20px;right:20px;-webkit-animation:none;animation:none;-webkit-transition:none;transition:none;}}\n.t1k8hugl{padding:40px 48px;background-color:#F1F5F7;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:space-between;-webkit-justify-content:space-between;justify-content:space-between;}@media (max-width: 991px){.t1k8hugl{padding:40px 48px;}}\n.hapbwqz{font-family:Averta,sans-serif;font-size:1.6rem;line-height:28px;font-weight:bold;color:#5A7A8E;}\n.tft612{font-family:Averta,sans-serif;font-size:2.1rem;line-height:32px;font-weight:bold;color:#2c3b45;}\n.ccgi2ep{font-family:Averta,sans-serif;font-size:1.6rem;padding:48px;overflow:auto;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}@media (max-width: 991px){.ccgi2ep{padding:24px;}}\n.u1av3zjv{cursor:pointer;border:1px solid #889CA6;border-style:dashed;border-radius:0.5rem;padding:23px;text-align:center;margin:20px 0 10px 0;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-justify-content:center;justify-content:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-family:Averta,sans-serif!important;font-size:1.6rem!important;line-height:1.5;color:#2c3b45;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;}.u1av3zjv:hover{background-color:#F2F5F7;}\n.f9ge826{border:1px solid #CEDAE1;padding:12px 24px;border-radius:6px;margin:20px 0 0 0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;font-family:Averta,sans-serif!important;font-size:1.6rem!important;line-height:1.5;color:#2c3b45;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}\n.f1t8ipqb{line-height:20px;font-size:1.6rem;font-weight:600;}\n.fb42kor{color:#7c919c;line-height:18px;font-size:1.6rem;}\n.i1diecit{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}.i1diecit.pointer{cursor:pointer;}.i1diecit.right{margin-left:auto;}\n.sbxnacr{display:inline-block;margin:0 8px;}\n.b1p2zz9m{font-weight:bold;color:#007f9e;margin-left:5px;cursor:pointer;font-size:1.6rem!important;}\n.f1ozzopp{color:#7C919C;font-size:14px;line-height:20px;}.f1ozzopp.error{color:#D11E0B;}\n.wvndiz1{background-color:#fbf4d3;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:60px;padding:5px 22px 8px 4px;border-radius:5px;margin-bottom:16px;}@media (max-width: 991px){.wvndiz1{margin-top:20px!important;}}\n.ep1suzd{background-color:#F6D2CE;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:60px;padding:5px 22px 8px 4px;border-radius:5px;margin-bottom:16px;}@media (max-width: 991px){.ep1suzd{margin-top:20px!important;}}\n.iltpg7w{margin:0 8px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}\n.t7od6x9{color:#2c3b45;padding:0.5rem;font-size:1.6rem;line-height:18px;margin-top:3px;font-family:Averta,sans-serif!important;}\n.s2c2pgy{visibility:var(--s2c2pgy-0);font-family:Averta,sans-serif!important;font-weight:700;border-radius:1rem!important;-webkit-transition:visibility 0.5s linear;transition:visibility 0.5s linear;position:relative;background-color:#007f9e;border-color:#007f9e;font-size:1.6rem!important;min-width:100%;}@media (max-width: 991px){.s2c2pgy{position:fixed!important;bottom:20px!important;left:20px!important;width:calc(100% - 40px)!important;padding:10px 0!important;}}\n.derw56e{display:inline-block;margin-right:12px;}\n/*# sourceMappingURL=data:application/json;base64,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*/\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$2);
var colors$1 = config_1.colors.list;
// Fade in animation
// Fade out animation
// Slide in animation
// Slide out animation
// Button in animation
// Button out animation
// const GlobalStyle = createGlobalStyle`
//   body {
//     overflow-x: hidden;
//   }
// `
var _exp$1 = function _exp() {
  return function (_ref) {
    var open = _ref.open;
    return open ? 'visible' : 'hidden';
  };
};
var _exp2 = function _exp2() {
  return function (_ref2) {
    var open = _ref2.open;
    return open ? "s16qfrov" : "s64k89g";
  };
};
var PanelContainer = /*#__PURE__*/styled_default('div')({
  name: "PanelContainer",
  "class": "pw6sypt",
  propsAsIs: false,
  vars: {
    "pw6sypt-0": [_exp$1()],
    "pw6sypt-1": [_exp2()]
  }
});
var _exp5 = function _exp5() {
  return function (_ref3) {
    var open = _ref3.open;
    return open ? 'visible' : 'hidden';
  };
};
var _exp6 = function _exp6() {
  return function (_ref4) {
    var open = _ref4.open;
    return open ? "f1y83iw6" : "fhcjx40";
  };
};
var BlackShadow = /*#__PURE__*/styled_default('div')({
  name: "BlackShadow",
  "class": "b80pwr6",
  propsAsIs: false,
  vars: {
    "b80pwr6-0": [_exp5()],
    "b80pwr6-1": [_exp6()]
  }
});
var _exp7 = function _exp7() {
  return function (_ref5) {
    var open = _ref5.open;
    return open ? 'visible' : 'hidden';
  };
};
var _exp8 = function _exp8() {
  return function (_ref6) {
    var open = _ref6.open;
    return open ? "i18sqvvi" : "o1us3wur";
  };
};
var CloseBtn = /*#__PURE__*/styled_default('div')({
  name: "CloseBtn",
  "class": "c1jiu3a9",
  propsAsIs: false,
  vars: {
    "c1jiu3a9-0": [_exp7()],
    "c1jiu3a9-1": [_exp8()]
  }
});
var TitleContainer = /*#__PURE__*/styled_default('div')({
  name: "TitleContainer",
  "class": "t1k8hugl",
  propsAsIs: false
});
var HeadBlock = /*#__PURE__*/styled_default('div')({
  name: "HeadBlock",
  "class": "hapbwqz",
  propsAsIs: false
});
var TitleBlock = /*#__PURE__*/styled_default('div')({
  name: "TitleBlock",
  "class": "tft612",
  propsAsIs: false
});
var ContentContainer = /*#__PURE__*/styled_default('div')({
  name: "ContentContainer",
  "class": "ccgi2ep",
  propsAsIs: false
});
var UploadBlock = /*#__PURE__*/styled_default('div')({
  name: "UploadBlock",
  "class": "u1av3zjv",
  propsAsIs: false
});
var FileBlock = /*#__PURE__*/styled_default('div')({
  name: "FileBlock",
  "class": "f9ge826",
  propsAsIs: false
});
var FileName = /*#__PURE__*/styled_default('div')({
  name: "FileName",
  "class": "f1t8ipqb",
  propsAsIs: false
});
var FileInfos = /*#__PURE__*/styled_default('div')({
  name: "FileInfos",
  "class": "fb42kor",
  propsAsIs: false
});
var IconContainer = /*#__PURE__*/styled_default('div')({
  name: "IconContainer",
  "class": "i1diecit",
  propsAsIs: false
});
var Spacer = /*#__PURE__*/styled_default('span')({
  name: "Spacer",
  "class": "sbxnacr",
  propsAsIs: false
});
var _exp19 = function _exp19() {
  return componentsSpan.Span;
};
var BrowseBlock = /*#__PURE__*/styled_default(_exp19())({
  name: "BrowseBlock",
  "class": "b1p2zz9m",
  propsAsIs: true
});
var _exp21 = function _exp21() {
  return componentsParagraph.Paragraph;
};
var FormatBLock = /*#__PURE__*/styled_default(_exp21())({
  name: "FormatBLock",
  "class": "f1ozzopp",
  propsAsIs: true
});
var WarningBlock = /*#__PURE__*/styled_default('div')({
  name: "WarningBlock",
  "class": "wvndiz1",
  propsAsIs: false
});
var ErrorBlock = /*#__PURE__*/styled_default('div')({
  name: "ErrorBlock",
  "class": "ep1suzd",
  propsAsIs: false
});
var IconBlock = /*#__PURE__*/styled_default('div')({
  name: "IconBlock",
  "class": "iltpg7w",
  propsAsIs: false
});
var TextBlock = /*#__PURE__*/styled_default('div')({
  name: "TextBlock",
  "class": "t7od6x9",
  propsAsIs: false
});
var _exp27 = function _exp27() {
  return componentsButton.Button;
};
var _exp28 = function _exp28() {
  return function (_ref7) {
    var open = _ref7.open;
    return open ? 'visible' : 'hidden';
  };
};
var SendButton = /*#__PURE__*/styled_default(_exp27())({
  name: "SendButton",
  "class": "s2c2pgy",
  propsAsIs: true,
  vars: {
    "s2c2pgy-0": [_exp28()]
  }
});
var DownloadIcon = /*#__PURE__*/styled_default('img')({
  name: "DownloadIcon",
  "class": "derw56e",
  propsAsIs: false
});
var MAX_SIZE = 5242880;
var UploadPanel = function UploadPanel(_ref8) {
  var open = _ref8.open,
    handleOpen = _ref8.handleOpen,
    file = _ref8.file,
    uploadHandler = _ref8.uploadHandler,
    uploadError = _ref8.uploadError;
  var _a;
  var _useState = React$1.useState(false),
    _useState2 = _slicedToArray$2(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = React$1.useState([]),
    _useState4 = _slicedToArray$2(_useState3, 2),
    files = _useState4[0],
    setFiles = _useState4[1];
  var _useState5 = React$1.useState(false),
    _useState6 = _slicedToArray$2(_useState5, 2),
    uploading = _useState6[0],
    setUploading = _useState6[1];
  var _useStore = useStore(),
    language = _useStore.language,
    env = _useStore.env,
    contractData = _useStore.contractData,
    contractError = _useStore.contractError,
    setContractError = _useStore.setContractError;
  var labels = locales[language];
  var _useDropzone = useDropzone({
      onDrop: function onDrop(acceptedFiles) {
        acceptedFiles.map(function (file) {
          if (UPLOAD_FILE_TYPES.includes(file.type) && file.size <= MAX_SIZE) {
            setFiles(function (files) {
              return [].concat(_toConsumableArray$3(files), [file]);
            });
          } else {
            setError(true);
          }
        });
      },
      disabled: typeof window === 'undefined'
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps;
  var readableFileSize = function readableFileSize(fileSize) {
    var sizeInKb = fileSize / 1024;
    return sizeInKb > 1024 ? "".concat((sizeInKb / 1024).toFixed(2), " mb") : "".concat(sizeInKb.toFixed(2), " kb");
  };
  var deleteFile = function deleteFile(index) {
    setFiles([].concat(_toConsumableArray$3(files.slice(0, index)), _toConsumableArray$3(files.slice(index + 1))));
  };
  var clearAndClose = function clearAndClose() {
    handleOpen();
    setContractError('');
    document.body.style.overflow = 'auto';
  };
  var fileTypeName = FILE_TYPES[(_a = file === null || file === void 0 ? void 0 : file.type) !== null && _a !== void 0 ? _a : 1];
  useFetchContract(env, file === null || file === void 0 ? void 0 : file.type);
  var handleDownload = function handleDownload() {
    var linkSource = "data:application/pdf;base64,".concat(contractData === null || contractData === void 0 ? void 0 : contractData.content);
    downloadByURL(linkSource, (contractData === null || contractData === void 0 ? void 0 : contractData.filename) || "contract.pdf");
  };
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement("div", {
    style: {
      maxHeight: '300px',
      overflowY: 'auto'
    }
  }, /*#__PURE__*/React$1.createElement(BlackShadow, {
    onClick: clearAndClose,
    open: open
  }), /*#__PURE__*/React$1.createElement(CloseBtn, {
    open: open,
    onClick: clearAndClose
  }, /*#__PURE__*/React$1.createElement("img", {
    src: img$3,
    width: "16",
    height: "16"
  })), /*#__PURE__*/React$1.createElement(PanelContainer, {
    open: open
  }, /*#__PURE__*/React$1.createElement(TitleContainer, null, /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(HeadBlock, null, labels.requested_document), /*#__PURE__*/React$1.createElement(TitleBlock, null, labels["document_type_".concat(fileTypeName)])), !contractError && (contractData === null || contractData === void 0 ? void 0 : contractData.contractId) && contractData.contractId > 0 && /*#__PURE__*/React$1.createElement(componentsButton.Button, {
    primary: true,
    onClick: handleDownload
  }, labels.download)), /*#__PURE__*/React$1.createElement(ContentContainer, null, contractError && /*#__PURE__*/React$1.createElement(ErrorBlock, null, /*#__PURE__*/React$1.createElement(IconBlock, null, /*#__PURE__*/React$1.createElement(componentsIcon.Icon, {
    icon: "icn_exclamationCircle",
    color: colors$1.BlueDark
  })), /*#__PURE__*/React$1.createElement(TextBlock, null, labels.error_contract_not_found)), /*#__PURE__*/React$1.createElement(componentsSpan.Span, {
    color: null
  }, labels.multiple_documents), !!files.length && files.map(function (_file, i) {
    var _a;
    var fileType = _file === null || _file === void 0 ? void 0 : _file.type;
    return /*#__PURE__*/React$1.createElement(FileBlock, {
      key: "file_blck_".concat(i)
    }, /*#__PURE__*/React$1.createElement(IconContainer, null, /*#__PURE__*/React$1.createElement("img", {
      src: img$1,
      width: "18",
      height: "20",
      style: {
        marginRight: '24px'
      }
    })), /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(FileName, null, _file.name), /*#__PURE__*/React$1.createElement(FileInfos, null, (_a = DISPLAY_FORMATS[fileType]) !== null && _a !== void 0 ? _a : '', /*#__PURE__*/React$1.createElement(Spacer, null, "\u2022"), readableFileSize(_file.size))), /*#__PURE__*/React$1.createElement(IconContainer, {
      className: "right pointer",
      onClick: function onClick() {
        return deleteFile(i);
      }
    }, /*#__PURE__*/React$1.createElement("img", {
      src: img$4,
      width: "16",
      height: "15"
    })));
  }), /*#__PURE__*/React$1.createElement(UploadBlock, Object.assign({}, getRootProps(), {
    error: error || uploadError
  }), /*#__PURE__*/React$1.createElement("input", Object.assign({}, getInputProps())), /*#__PURE__*/React$1.createElement(DownloadIcon, {
    src: img$2,
    height: "20",
    width: "20"
  }), /*#__PURE__*/React$1.createElement(componentsSpan.Span, {
    color: null,
    weight: "regular"
  }, labels.drop_here), /*#__PURE__*/React$1.createElement(BrowseBlock, null, labels.browse_files)), !error && !uploadError && /*#__PURE__*/React$1.createElement(FormatBLock, {
    className: error ? 'error' : ''
  }, labels.accepted_formats), error && /*#__PURE__*/React$1.createElement(FormatBLock, {
    className: error ? 'error' : '',
    error: error
  }, labels.upload_error), uploadError && /*#__PURE__*/React$1.createElement(FormatBLock, {
    className: error ? 'error' : '',
    error: uploadError
  }, labels.upload_error), /*#__PURE__*/React$1.createElement(WarningBlock, null, /*#__PURE__*/React$1.createElement(IconBlock, null, /*#__PURE__*/React$1.createElement(componentsIcon.Icon, {
    icon: "icn_exclamationCircle",
    color: colors$1.BlueDark
  })), /*#__PURE__*/React$1.createElement(TextBlock, null, labels.readable_files)), /*#__PURE__*/React$1.createElement(SendButton, {
    disabled: uploading || files.length === 0,
    onClick: function onClick() {
      setUploading(true);
      uploadHandler(files, setFiles)["finally"](function () {
        return setUploading(false);
      });
    },
    open: open
  }, labels.send_for_review)))));
};
var Home = function Home() {
  var _useStore = useStore(),
    setError = _useStore.setError,
    request = _useStore.request,
    env = _useStore.env,
    setContract = _useStore.setContract;
  var _useState = React$1.useState(false),
    _useState2 = _slicedToArray$2(_useState, 2),
    openPanel = _useState2[0],
    setOpenPanel = _useState2[1];
  var _useState3 = React$1.useState(undefined),
    _useState4 = _slicedToArray$2(_useState3, 2),
    file = _useState4[0],
    setFile = _useState4[1];
  var _useState5 = React$1.useState(false),
    _useState6 = _slicedToArray$2(_useState5, 2),
    uploadError = _useState6[0],
    setUploadError = _useState6[1];
  useFetchRequest(env);
  useFetchContract$1(env, undefined);
  var handleOpenPanel = function handleOpenPanel(index) {
    setOpenPanel(function (openPanel) {
      return !openPanel;
    });
    if (index >= 0) {
      setFile(request === null || request === void 0 ? void 0 : request.filesList[index]);
      setContract(null);
    } else {
      setFile(undefined);
    }
    document.body.style.overflow = 'hidden';
  };
  var uploadFile = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(files, setFiles) {
      var guids, index, response, result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(files.length === 0)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            guids = [];
            index = 0;
          case 4:
            if (!(index < files.length)) {
              _context.next = 18;
              break;
            }
            _context.prev = 5;
            _context.next = 8;
            return REQUESTS.uploadFileCall(files[index], env);
          case 8:
            response = _context.sent;
            if (!response.errorCode) {
              guids.push(response.id);
            } else {
              setUploadError(true);
            }
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](5);
            setUploadError(true);
          case 15:
            index++;
            _context.next = 4;
            break;
          case 18:
            if (!(files.length === guids.length)) {
              _context.next = 41;
              break;
            }
            if (!(file && request)) {
              _context.next = 40;
              break;
            }
            _context.prev = 20;
            _context.next = 23;
            return REQUESTS.postGuisCall({
              requestId: request.id,
              fileId: file.id,
              guids: guids
            }, env);
          case 23:
            result = _context.sent;
            if (!result.success) {
              _context.next = 32;
              break;
            }
            _context.next = 27;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 2000);
            });
          case 27:
            if (typeof window !== 'undefined') {
              window.location.reload();
            }
            setFiles([]);
            handleOpenPanel(-1);
            _context.next = 33;
            break;
          case 32:
            setError('Error when processing guis');
          case 33:
            _context.next = 38;
            break;
          case 35:
            _context.prev = 35;
            _context.t1 = _context["catch"](20);
            setError('Error when processing guis');
          case 38:
            _context.next = 41;
            break;
          case 40:
            setError('No file or request ID');
          case 41:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 12], [20, 35]]);
    }));
    return function uploadFile(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React$1.createElement(Column, null, /*#__PURE__*/React$1.createElement(Header, {
    request: request
  }), /*#__PURE__*/React$1.createElement(GreetingLabels, {
    request: request
  }), /*#__PURE__*/React$1.createElement(Request, {
    handleOpenPanel: handleOpenPanel,
    request: request
  })), /*#__PURE__*/React$1.createElement(UploadPanel, {
    open: openPanel,
    handleOpen: function handleOpen() {
      return handleOpenPanel(-1);
    },
    file: file,
    uploadHandler: uploadFile,
    uploadError: uploadError
  }));
};
var img = "data:image/png;base64,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";
var Logo = function Logo() {
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("img", {
    src: img,
    style: {
      display: 'block',
      height: 'auto',
      width: '100%',
      maxHeight: '40px',
      objectFit: 'contain'
    }
  }));
};
var css_248z$1 = ".m1qwqjbl{margin:1.5rem;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:2rem;}.m1qwqjbl div h2{font-family:Averta,sans-serif!important;font-weight:700!important;font-size:2.1rem!important;margin-bottom:2rem!important;}.m1qwqjbl div p{font-family:Averta,sans-serif!important;font-size:1.6rem!important;}\n.b1ch6enn{cursor:pointer;text-align:center;width:100%;-webkit-transition:color 0.2s ease-in-out 0s,border 0.2s ease-in-out 0s,background-color 0.2s ease-in-out 0s;transition:color 0.2s ease-in-out 0s,border 0.2s ease-in-out 0s,background-color 0.2s ease-in-out 0s;}.b1ch6enn:hover{color:#2c3b45!important;}\n.b2gu4wb{width:20px!important;height:20px!important;position:absolute!important;margin-left:4px;margin-top:2px;}\n.s1c2g24c a{font-family:Averta,sans-serif;font-size:1.6rem;font-weight:700;color:#007F9E;}\n/*# sourceMappingURL=data:application/json;base64,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*/\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$1);
var colors = config_1.colors.list;
var _exp = function _exp() {
  return componentsCard.Card;
};
var MainContainer = /*#__PURE__*/styled_default(_exp())({
  name: "MainContainer",
  "class": "m1qwqjbl",
  propsAsIs: true
});
var BottomBlock = /*#__PURE__*/styled_default('div')({
  name: "BottomBlock",
  "class": "b1ch6enn",
  propsAsIs: false
});
var _exp3 = function _exp3() {
  return componentsIcon.Icon;
};
var BottomArrow = /*#__PURE__*/styled_default(_exp3())({
  name: "BottomArrow",
  "class": "b2gu4wb",
  propsAsIs: true
});
var StyledLinkContainer = /*#__PURE__*/styled_default('div')({
  name: "StyledLinkContainer",
  "class": "s1c2g24c",
  propsAsIs: false
});
var Invalid = function Invalid(_ref) {
  var env = _ref.env;
  var _useStore = useStore(),
    language = _useStore.language;
  var labels = locales[language];
  var prodOnboardingUrl = "https://www.keytradebank.be/onboarding/".concat(language);
  var testOnboardingUrl = "https://www.test.w.keytradebank.be/onboarding/".concat(language);
  var onboardingUrls = {
    prod: prodOnboardingUrl,
    test: testOnboardingUrl
  };
  var getOnboardingUrl = function getOnboardingUrl(env) {
    var _a;
    return (_a = onboardingUrls[env]) !== null && _a !== void 0 ? _a : testOnboardingUrl;
  };
  return /*#__PURE__*/React$1.createElement(Column, {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React$1.createElement(Logo, null), /*#__PURE__*/React$1.createElement(MainContainer, null, /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(componentsTitle.Title, {
    level: 'h2',
    size: 'xxs',
    margin: '1rem',
    center: true
  }, labels.request_expired_title), /*#__PURE__*/React$1.createElement(StyledParagraphLightGrey, null, labels.request_expired_description)), /*#__PURE__*/React$1.createElement(StyledLinkContainer, null, /*#__PURE__*/React$1.createElement(StyledLink, {
    href: getOnboardingUrl(env),
    size: 'sm',
    isSemiBold: true
  }, labels.request_expired_button_label))), /*#__PURE__*/React$1.createElement(BottomBlock, {
    onClick: function onClick() {
      return console.log('cant connect');
    }
  }, /*#__PURE__*/React$1.createElement(componentsSpan.Span, {
    size: 'bodySm',
    weight: 'regular',
    color: 'GreyBlue'
  }, labels.cant_connect), ' ', /*#__PURE__*/React$1.createElement(BottomArrow, {
    icon: 'icn_longArrowRight',
    color: colors.GreyDark
  })), /*#__PURE__*/React$1.createElement(BottomBlock, {
    onClick: function onClick() {
      return console.log('cant connect');
    }
  }, /*#__PURE__*/React$1.createElement(componentsSpan.Span, {
    size: 'bodySm',
    weight: 'regular',
    color: 'GreyBlue'
  }, labels.questions), ' ', /*#__PURE__*/React$1.createElement(BottomArrow, {
    icon: 'icn_longArrowRight',
    color: colors.GreyDark
  })));
};
var useCheckMagicLink = function useCheckMagicLink(reference, env) {
  var _useState = React$1.useState(true),
    _useState2 = _slicedToArray$2(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = React$1.useState(null),
    _useState4 = _slicedToArray$2(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  React$1.useEffect(function () {
    if (!reference) {
      checkUserData(env);
      return;
    }
    checkValidity(reference, env);
  }, [reference, env]);
  var checkValidity = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(reference, env) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return REQUESTS.checkValidityCall(reference, env);
          case 3:
            _context.next = 8;
            break;
          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            setError(_context.t0.message);
          case 8:
            _context.prev = 8;
            setLoading(false);
            return _context.finish(8);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 5, 8, 11]]);
    }));
    return function checkValidity(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var checkUserData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(env) {
      var userData, _userData$user, firstName, lastName, lang, origin, _reference;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            setLoading(true);
            _context2.next = 4;
            return REQUESTS.getUserData(env);
          case 4:
            userData = _context2.sent;
            if (userData === null || userData === void 0 ? void 0 : userData.user) {
              _userData$user = userData.user, firstName = _userData$user.firstName, lastName = _userData$user.lastName, lang = _userData$user.lang, origin = _userData$user.origin, _reference = _userData$user.reference;
              useStore.getState().setIsLoggedIn(true);
              useStore.getState().setCookieData({
                firstName: firstName,
                lastName: lastName,
                lang: lang,
                origin: origin,
                reference: _reference
              });
            } else {
              useStore.getState().setIsLoggedIn(false);
              useStore.getState().setCurrentScreen(SCREENS.INVALID);
              useStore.getState().setError("");
            }
            _context2.next = 11;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            setError(_context2.t0.message);
          case 11:
            _context2.prev = 11;
            setLoading(false);
            return _context2.finish(11);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 8, 11, 14]]);
    }));
    return function checkUserData(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    loading: loading,
    error: error
  };
};
var useHandleError = function useHandleError() {
  var _useStore = useStore(),
    setCurrentScreen = _useStore.setCurrentScreen,
    setError = _useStore.setError;
  React$1.useEffect(function () {
    var _a;
    if (typeof window !== 'undefined') {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var error = (_a = urlParams.get('error')) !== null && _a !== void 0 ? _a : '';
      if (error) {
        if (error === 'expired') {
          setCurrentScreen(SCREENS.INVALID);
          return;
        }
        setError(error);
      }
    }
  }, [setCurrentScreen, setError]);
};
var useLanguageFromUrl = function useLanguageFromUrl() {
  var defaultLang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en";
  var initialLang = React$1.useRef(defaultLang);
  var _useStore = useStore(),
    setLanguage = _useStore.setLanguage;
  React$1.useEffect(function () {
    if (typeof window !== 'undefined') {
      var url = new URL(window.location.href);
      var pathParts = url.pathname.split('/');
      var languageValue = pathParts[1] ? pathParts[1] : initialLang.current;
      setLanguage(languageValue !== null && languageValue !== void 0 ? languageValue : defaultLang);
    }
  }, [defaultLang]);
};
var css_248z = ".s3eaeoe{margin:150px auto;width:100%;text-align:center;}\n/*# sourceMappingURL=data:application/json;base64,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*/\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z);
var SpinnerContainer = /*#__PURE__*/styled_default('div')({
  name: "SpinnerContainer",
  "class": "s3eaeoe",
  propsAsIs: false
});
//const PersonalSpace = ({ lang = 'en', env = 'test', customization}: IProps) => {
var PersonalSpace = function PersonalSpace(_ref) {
  _ref.lang;
  var _ref$env = _ref.env,
    env = _ref$env === void 0 ? 'test' : _ref$env;
  var _useState = React$1.useState(true),
    _useState2 = _slicedToArray$2(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  // const safeCustomization = customization ?? { setPageCustomization: () => {} };
  // safeCustomization.setPageCustomization({ hideNavigation: true });
  var _useStore = useStore(),
    currentScreen = _useStore.currentScreen,
    setEnv = _useStore.setEnv,
    error = _useStore.error,
    isFetchLoading = _useStore.isLoading;
  _useStore.isLoggedIn;
  var reference = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('reference') : null;
  var _useCheckMagicLink = useCheckMagicLink(reference, env),
    linkLoading = _useCheckMagicLink.loading,
    linkError = _useCheckMagicLink.error;
  useHandleError();
  useLanguageFromUrl();
  React$1.useEffect(function () {
    setIsLoading(true);
    if (env) {
      setEnv(env);
    }
    if (reference && reference !== "") ;else {
      setIsLoading(false);
    }
  }, [env]);
  var renderLoadingState = isLoading || isFetchLoading || linkLoading;
  if (renderLoadingState) {
    return /*#__PURE__*/React$1.createElement(SpinnerContainer, null, /*#__PURE__*/React$1.createElement(componentsLoader.LoaderSpinner, null));
  }
  if (currentScreen === SCREENS.INVALID) {
    return /*#__PURE__*/React$1.createElement(Invalid, {
      env: env
    });
  }
  if (error || linkError) {
    return /*#__PURE__*/React$1.createElement(Error$1, null);
  }
  if (currentScreen === SCREENS.HOME) {
    return /*#__PURE__*/React$1.createElement(Home, null);
  }
};
module.exports = PersonalSpace;